const appDomain = "rcp.lightning-e.com";
const curStore  = "welleasy.myshopify.com"
const customer  = window._rcp_customer;
const rcpURL    = "https://" + appDomain + "api/order?email=" + customer.email + "&id=" + customer.id;
const publicKey = "660565-854809";
const formatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
});
window.autoshipQuantityUpdates = [];
if( !window.luigiDataLayer )
{
    window.luigiDataLayer = [];
}
var fetchedProductData = [];

(function() {
    var handleAutoshipClick = function(e) {
        var clickedElement = e.target;
        
        if (clickedElement.closest && clickedElement.closest('.autoship-add-to-cart')) {
            var autoshipBtn = clickedElement.closest('.autoship-add-to-cart');
            
            if (autoshipBtn && autoshipBtn.closest('.product-grid__product-card') && autoshipBtn.id !== 'ProductSubmitButton-autoship') {
                if (!autoshipBtn.disabled && typeof handleAutoshipAdd === 'function') {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    autoshipBtn.disabled = true;
                    handleAutoshipAdd(autoshipBtn);
                    return false;
                }
            }
        } else if (clickedElement.closest && clickedElement.closest('.product-grid__product-card')) {
            var productCard = clickedElement.closest('.product-grid__product-card');
            var autoshipBtn = productCard.querySelector('.autoship-add-to-cart');
            
            if (autoshipBtn && (clickedElement.classList.contains('autoship-add-to') || clickedElement.classList.contains('autoship-name') || clickedElement.closest('.autoship-add-to') || clickedElement.closest('.autoship-name'))) {
                if (!autoshipBtn.disabled && typeof handleAutoshipAdd === 'function') {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    autoshipBtn.disabled = true;
                    handleAutoshipAdd(autoshipBtn);
                    return false;
                }
            }
        }
    };
    
    document.addEventListener('click', handleAutoshipClick, true);
    document.addEventListener('mousedown', handleAutoshipClick, true);
})();

function SendAPIRequest(urlPart, method, payload, cb) {
    var url;
    var xhr = new XMLHttpRequest();

    if (urlPart.startsWith("http")) {
        url = urlPart;
    }
    else {
        if (window._apiRoot) {
            url = window._apiRoot + urlPart;
        }
    }

    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            var response;
            var err;
            if (xhr.status == 200) {
                if ((xhr.responseText) && (xhr.responseText.length > 0)) {
                    try {
                        response = JSON.parse(xhr.responseText);
                    }
                    catch (e) {
                        console.log("error parsing response : " + e.stack);
                        err = { "error": e };
                    }
                }
            }
            else {
                err = { "error": xhr.status };

                if ((xhr.responseText) && (xhr.responseText.length > 0)) {
                    try {
                        err.detail = JSON.parse(xhr.responseText);
                    }
                    catch (e) {
                    }
                }
            }

            cb(err, response, xhr);
        }
    };


    if (method == "GET") {
        var qpStr = "?";
        if (payload) {
            for (var key in payload) {
                if (qpStr.length > 1) {
                    qpStr += "&";
                }
                qpStr += key + "=" + encodeURIComponent(payload[key]);
            }

            xhr.open(method, url + qpStr, true);
        }
        else {
            xhr.open(method, url + qpStr, true);
        }

        xhr.setRequestHeader("x-store", curStore);
        xhr.send();
    }
    else {
        if (!payload) {
            payload = {};
        }

        xhr.open(method, url, true);
        xhr.setRequestHeader("x-store", curStore);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.send(JSON.stringify(payload));
    }
}

function CreateSearchParamsArray(url)
{
    return new URLSearchParams(url);
}

/**
 * FetchNextAutoshipOrder
 * 
 * Usage:
 *   FetchNextAutoshipOrder(function(err, data) {
 *     if (!err) {
 *       // use data here
 *     }
 *   });
 * 
 * This function is asynchronous and does not return the data directly.
 * 
 * Needs a callback to get the data when it is ready.
 */
function FetchNextAutoshipOrder( cb )
{
    // Return data is

    // charges : array of future Recharge charges in date order (so just look at the first)
    // subs : object containing data about individual subscriptions, keyed by process date

    // each charge contains:
    // aid : address ID
    // cid : customer ID in Recharge (NOT Shopify)
    // at  : date that charge will be processed
    // lines : array of line items

    // each line item contains:
    // pid : Shopify product ID
    // vid : Shopify variant ID
    // qty : quantity of product
    // sid : id of the associated subscription or onetime in Recharge
    // type : whether it's a subscription or onetime purchase

    // each sub contains:
    // sid : subscription ID
    // aid : address ID
    // ncs : Next Charge Scheduled
    // pid : Shopify product ID
    // vid : Shopify variant ID
    // qty : quantity of product
    // sub : details of subscription frequency containing "frequencyUnit" and "frequency", e.g. "week" and "4"

    // Accept a callback as an argument, like the original function at the top of the file
    // function FetchNextAutoshipOrder(cb) { ... }
    // If cb is not provided, do nothing
    var pdpBtn = document.getElementById("ProductSubmitButton-autoship");

    if ( ( cb ) && ( customer ) && ( customer.email ) && ( customer.id ) )
    {
        if ( window._autoshipCBQ )
        {
            window._autoshipCBQ.push( cb );
        }
        else
        {
            window._autoshipData = null;
            window._autoshipCBQ  = [ cb ];

            SendAPIRequest( "https://" + appDomain + "/api/order", "GET", customer, function( err, response )
            {
                window._autoshipData = response;

                var cbs = window._autoshipCBQ;
                window._autoshipCBQ = null;

                if ( ( response ) && ( response.charges ) && ( response.charges.length > 0 ) )
                {
                    document.body.classList.add( "has-autoship" );
                    document.body.classList.add( "js-autoship-checked" );
                    if (pdpBtn)
                    {
                        pdpBtn.classList.remove( "visibility-hidden" );
                    }
                }
                else
                {
                    document.body.classList.remove("has-autoship");
                    document.body.classList.add( "js-autoship-checked" );

                    var svgIcon = `
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="14" viewBox="0 0 22 14" fill="none">
                            <path d="M20.938 3.88773C20.9263 3.88703 20.9507 3.8827 21.0044 3.95316C21.0533 4.01728 21.1018 4.11242 21.1479 4.22464C21.2395 4.44722 21.3024 4.69594 21.3286 4.80179C21.4313 5.21251 21.4383 5.55473 21.4312 5.78812V5.79007C21.4093 6.87764 21.1147 7.78731 20.8765 8.37308C20.7451 8.69572 20.5918 9.01084 20.4136 9.31937L20.2271 9.62503C18.1692 12.8252 14.2197 14.1985 10.5767 13.0225L10.2251 12.9004C9.94338 12.797 9.66997 12.6793 9.40869 12.545L9.40674 12.544C9.01046 12.3444 8.71 12.1893 8.47803 12.0459C8.24712 11.9032 8.09569 11.7793 7.99072 11.6465H7.98975C7.96867 11.6188 7.88628 11.5082 7.74561 11.4825V11.4815L7.73486 11.4805H7.64893C7.56814 11.492 7.50249 11.5337 7.45361 11.5782C7.39314 11.6332 7.34065 11.7088 7.29346 11.7813C7.19133 11.9381 7.08437 12.1303 6.90479 12.375C6.57139 12.8292 6.3297 12.9984 6.17432 13.085L6.16943 13.0879C6.15368 13.0973 6.13643 13.1024 6.12158 13.1104L6.0835 13.0576C5.8908 12.7759 5.35022 11.9703 5.06396 10.9073C4.82966 10.0283 4.84975 9.2811 4.89111 7.83694V7.83109C4.89111 7.81474 4.89164 7.79881 4.89209 7.78323C4.91137 7.78029 4.93228 7.77695 4.95459 7.77347C5.4896 7.68959 6.5544 7.52632 7.66553 7.67191C8.22829 7.74649 9.19241 7.80166 10.3647 8.21194V8.21292C10.411 8.22966 10.4539 8.24616 10.4937 8.26077C10.3538 8.59904 10.1357 8.8126 9.99951 8.94534C9.55987 9.35934 9.32657 9.56772 9.20264 9.68069C9.16097 9.71868 9.12711 9.7535 9.1001 9.78128H8.95947L9.0083 10.0215C9.02812 10.1185 9.09679 10.1826 9.14404 10.2188C9.19716 10.2595 9.26304 10.2948 9.3335 10.3252C9.47566 10.3865 9.66801 10.4423 9.89502 10.4893C10.3512 10.5836 10.9756 10.647 11.688 10.6328C13.1113 10.6045 14.9132 10.2666 16.437 9.22269C16.8351 8.95031 17.6499 8.33018 18.4644 7.52151C19.276 6.71568 20.1045 5.70601 20.5073 4.65335L20.5083 4.65237C20.5447 4.55529 20.623 4.34198 20.7261 4.1553C20.778 4.06123 20.8306 3.98414 20.8794 3.9346C20.9109 3.90271 20.9299 3.89106 20.938 3.88773Z" fill="black" stroke="black" stroke-width="0.4"/>
                            <path d="M1.40625 4.01465C3.53427 0.711274 7.67062 -0.644625 11.4121 0.736328C11.6937 0.839712 11.9673 0.956482 12.2285 1.09082L12.2305 1.0918C12.6268 1.29137 12.9272 1.44642 13.1592 1.58984C13.39 1.73256 13.5415 1.85657 13.6465 1.98926C13.664 2.01217 13.729 2.10121 13.8398 2.14062L13.8916 2.1543L13.9023 2.15625C14.0236 2.17152 14.1184 2.11694 14.1836 2.05762C14.244 2.00262 14.2966 1.92784 14.3438 1.85547C14.4459 1.69866 14.5528 1.50645 14.7324 1.26172C15.0659 0.807379 15.3075 0.638318 15.4629 0.551758L15.4678 0.548828C15.4835 0.539471 15.4998 0.532448 15.5146 0.524414L15.5537 0.579102C15.7224 0.825821 16.1573 1.47235 16.4551 2.3418L16.5732 2.72852C16.8077 3.60771 16.7875 4.35534 16.7461 5.7998V5.80469C16.7461 5.82089 16.7446 5.83709 16.7441 5.85254L16.6826 5.86328C16.1477 5.94714 15.0834 6.11024 13.9727 5.96484C13.4096 5.89018 12.4432 5.83399 11.2695 5.42285C11.2236 5.40622 11.1811 5.38952 11.1416 5.375C11.2813 5.0368 11.5005 4.82322 11.6367 4.69043L11.6377 4.69141C12.0781 4.27673 12.3117 4.06798 12.4355 3.95508C12.493 3.90272 12.5383 3.86066 12.5664 3.82715C12.5812 3.80949 12.6052 3.77809 12.6191 3.73535C12.6358 3.68402 12.6301 3.64 12.624 3.6123H12.6221C12.6006 3.51895 12.5354 3.4563 12.4893 3.4209C12.4362 3.3803 12.3701 3.34578 12.2998 3.31543C12.1577 3.25413 11.9662 3.19734 11.7393 3.15039C11.283 3.05603 10.658 2.99267 9.94531 3.00684C8.52197 3.03515 6.72013 3.37303 5.19629 4.41699C4.79819 4.68936 3.98343 5.30951 3.16895 6.11816C2.3573 6.924 1.52878 7.93366 1.12598 8.98633V8.9873C1.08959 9.08436 1.01043 9.29854 0.907227 9.48535C0.855339 9.57922 0.802618 9.65562 0.753906 9.70508C0.720376 9.73906 0.700455 9.74834 0.693359 9.75098C0.684344 9.74593 0.663079 9.73005 0.629883 9.68652C0.581067 9.62246 0.531496 9.52809 0.485352 9.41602C0.439507 9.30462 0.4005 9.18637 0.370117 9.08301L0.304688 8.83789C0.201999 8.42717 0.195001 8.08495 0.202148 7.85156V7.84961C0.223984 6.76231 0.518683 5.85332 0.756836 5.26758C0.888124 4.94499 1.04157 4.62975 1.21973 4.32129L1.40625 4.01465Z" fill="black" stroke="black" stroke-width="0.4"/>
                        </svg>
                    `;

                    if (pdpBtn)
                    {
                        var isMyAisle = document.body.id === 'lightning-my-aisle' || document.querySelector('#lightning-my-aisle');
                        var fontSize = isMyAisle ? '12px' : '14px';
                        
                        function updatePdpButtonWithPercent()
                        {
                            if (document.body.classList.contains('has-autoship')) return false;
                            
                            var mainPriceEl = document.querySelector('.product-main-price');
                            var autoshipPriceEl = document.querySelector('.autoship-price');
                            
                            if (!mainPriceEl || !autoshipPriceEl) return false;
                            
                            var mainPrice = parseFloat(mainPriceEl.textContent.replace(/[^0-9.]/g, ''));
                            var autoshipPrice = parseFloat(autoshipPriceEl.textContent.replace(/[^0-9.]/g, ''));
                            
                            if (isNaN(mainPrice) || isNaN(autoshipPrice) || mainPrice <= 0) return false;
                            
                            var autoshipPercent = Math.round(((mainPrice - autoshipPrice) / mainPrice) * 100);
                            if (autoshipPercent <= 0) return false;
                            
                            var label = 'Subscribe & Save ' + autoshipPercent + '%';
                            pdpBtn.innerHTML = `
                                <span class="autoship-add-to">
                                    ${svgIcon}
                                    <span class="autoship-name" style="font-size:${fontSize}; vertical-align: middle;">${label}</span>
                                </span>`;
                            pdpBtn.classList.remove("visibility-hidden");
                            if (pdpBtn.dataset.autoshipLabelBound === '1') {
                                delete pdpBtn.dataset.autoshipLabelBound;
                            }
                            return true;
                        }
                        
                        if (!updatePdpButtonWithPercent())
                        {
                            pdpBtn.classList.remove("visibility-hidden");
                            if (pdpBtn.dataset.autoshipLabelBound === '1') {
                                delete pdpBtn.dataset.autoshipLabelBound;
                            }
                            
                            setTimeout(updatePdpButtonWithPercent, 500);
                            setTimeout(updatePdpButtonWithPercent, 1500);
                            setTimeout(updatePdpButtonWithPercent, 3000);
                        }
                    }

                    var plpBtn = document.querySelector(".autoship-add-to-cart:not(#ProductSubmitButton-autoship)");
                    if (plpBtn && plpBtn.id !== 'ProductSubmitButton-autoship')
                    {
                        var isMyAisle = document.body.id === 'lightning-my-aisle' || document.querySelector('#lightning-my-aisle');
                        var fontSize = isMyAisle ? '12px' : '14px';
                        plpBtn.innerHTML =
                            '<span class="autoship-add-to">'
                        + svgIcon
                        + '<span class="autoship-name" style="font-size: ' + fontSize + '; vertical-align: middle;"><strong>Autoship </strong>every 4 weeks</span>'
                        + '</span>';
                        plpBtn.style.fontSize = "12px";
                    }
                }


                cbs.forEach( function( callback )
                {
                    if ( typeof callback === "function" )
                    {
                        if ( response )
                        {
                            callback( null, response );
                        }
                        else
                        {
                            callback( err || "No response from API" );
                        }
                    }
                } );
                //console.log("Response from API:", response)
            } );
        }
    }
    else if ( cb )
    {
        cb( );
    }
}

function ReallyModifySubscriptionQuantity(sid, qty, cb) {
    var body = {
        "auth": customer,
        "sid": sid,
        "qty": qty
    };
    SendAPIRequest(
        "https://" + appDomain + "/api/subscriptions", 
        "PUT", 
        body, 
        function(err, response) {
            if( response )
            {
                var modalNotification = document.querySelector('.autoship-updated-notification');
                if( modalNotification )
                {
                    modalNotification.classList.remove( 'visibility-hidden' );
                    setTimeout( function(){
                        modalNotification.classList.add( 'visibility-hidden' );
                    }, 2000);
                }
            }
            if (typeof cb === "function") cb(err, response);
        }
    );
}

function ReallyCreateNewSubscription(aid, ncs, freq, freqUnit, qty, pid, vid, cb) {
    var body = {
        "auth": customer,
        "aid": aid,
        "ncs": ncs,
        "sub": { "frequency": freq, "frequencyUnit": freqUnit },
        "qty": qty,
        "pid": pid,
        "vid": vid
    };
    SendAPIRequest(
        "https://" + appDomain + "/api/subscriptions", 
        "POST", 
        body, 
        function(err, response) {
            if (typeof cb === "function") cb(err, response);
        }
    );
}

function ReallyModifyOnetimeQuantityCancel(otid, qty, cb) {
    var body = {
        "auth": customer,
        "otid": otid,
        "qty": qty
    };
    SendAPIRequest(
        "https://" + appDomain + "/api/onetime", 
        "PUT", 
        body, 
        function(err, response) {
            if (typeof cb === "function") cb(err, response);
        }
    );
}

function ReallyModifyOnetimeQuantity(aid, qty, pid, vid, cb) {
    var body = {
        "auth"  : customer,
        "aid"   : aid,
        "qty"   : qty,
        "pid"   : pid,
        "vid"   : vid
    };
    SendAPIRequest(
      "https://" + appDomain + "/api/onetime", 
      "POST", 
      body, 
      function(err, response) {
        if (typeof cb === "function") {
          cb(err, response);
        }
      }
    );
}

function ReallySkipAutoshipCharge( cid, sid, cb )
{
    var body =
    {
        "auth": customer,
        "cid": cid,
        "sid": sid,
        "skip": true
    };
    SendAPIRequest(
        "https://" + appDomain + "/api/subscriptions", 
        "PUT", 
        body, 
        function(err, response) {
            if ( typeof cb === "function" )
            {
                cb( err, response );
            }
        }
    );
}

function ReallyRescheduleAutoshipDate( cid, date, cb )
{
    //cid of charge to reschedule
    //date as string "2025-09-04" etc
    var body =
    {
        "auth": customer,
        "cid": cid,
        "date": date
    };
    SendAPIRequest(
        "https://" + appDomain + "/api/subscriptions", 
        "PUT", 
        body, 
        function(err, response) {
            if ( typeof cb === "function" )
            {
                cb( err, response );
            }
        }
    );
}

function ReallApplyChargeDiscount( cid, code, cb )
{
    var body =
    {
        "auth": customer,
        "cid": cid + "",
        "discount_code": code
    };
    SendAPIRequest(
        "https://" + appDomain + "/api/discount", 
        "POST", 
        body, 
        function(err, response) {
            if ( typeof cb === "function" )
            {
                cb( err, response );
            }
        }
    );
}

function getRechargeLineInfo(rechargeData, productId, variantId) {
    if (!rechargeData || !rechargeData.subs) return null;
    
    for (const date in rechargeData.subs) {
        const subs = rechargeData.subs[date];
        for (const sub of subs) {
            if (sub.pid == productId && sub.vid == variantId) {
                return {
                    sid: sub.sid,
                    aid: sub.aid,
                    ncs: sub.ncs,
                    freq: sub.sub.frequency,
                    freqUnit: sub.sub.frequencyUnit,
                    qty: sub.qty
                };
            }
        }
    }
    return null;
}

function getNextRechargeSub( rechargeData )
{
    if ( rechargeData.subs && Object.keys( rechargeData.subs ).length > 0 )
    {
        var subKeys = Object.keys( window._autoshipData.subs );
        if ( subKeys.length > 0 )
        {
            subKeys.sort( function( a, b )
            {
                a = a.split( "T" )[ 0 ].split('-').join('');
                b = b.split( "T" )[ 0 ].split('-').join('');
                return a - b;
            } );

            var matchingSub = rechargeData.subs[ subKeys[ 0 ] ];
            if ( matchingSub )
            {
                var freq = matchingSub[ 0 ].sub.frequency;
                var freqUnit = matchingSub[ 0 ].sub.frequencyUnit;

                return {
                    aid: matchingSub[ 0 ].aid,
                    ncs: matchingSub[ 0 ].ncs,
                    freq: freq,
                    freqUnit: freqUnit
                }
            }
        }
    }
    return null;
}

function getNextRechargeCharge( rechargeData )
{
    var newestCharge = null;
    rechargeData.charges.forEach( ( charge ) =>
    {
        if ( newestCharge == null  )
        {
            newestCharge = charge;
        }
        else if ( newestCharge.status == "SKIPPED" && charge.status == "QUEUED" )
        {
            newestCharge = charge;
        }
        else
        {
            var currChargeDate = newestCharge.at.split( "T" )[ 0 ].split('-').join('');
            var newChargeDate = charge.at.split( "T" )[ 0 ].split('-').join('');

            if ( newChargeDate < currChargeDate )
            {
                newestCharge = charge;
            }
        }
    });
    return newestCharge;
}

function getSkippedSubsCharge( chargeDate )
{
    //chargeDate - charge.at value of charge skipped subs originate from
    var skippedSubsCharge = null;
    var newSkippedSubsCharge = null;
    var charges = window._autoshipData.charges;
    var skippedSubsCharge = charges.find( ( charge ) => charge.at == chargeDate && charge.status == "SKIPPED" );

    if ( skippedSubsCharge )
    {
        var skippedSubs = skippedSubsCharge.lines.toSorted( function( a, b )
        {
            a = a.sid;
            b = b.sid;
            return a - b;
        } );

        charges.forEach( charge =>
        {
            if ( charge.status == "QUEUED" )
            {
                var chargeSubs = charge.lines.toSorted( function( a, b )
                {
                    a = a.sid;
                    b = b.sid;
                    return a - b;
                } );

                if ( JSON.stringify( skippedSubs ) == JSON.stringify( chargeSubs ) )
                {
                    newSkippedSubsCharge = charge;
                    return newSkippedSubsCharge;
                }
            }
        });
    }
    return newSkippedSubsCharge;
}

function GetPageFromUrlParam()
{
    var params   = CreateSearchParamsArray( window.location.search );
    var page     = params.get( "page" );
    var pageInt  = parseInt( page, 10 );

    if ( !isNaN( pageInt ) && pageInt > 0 )
    {
        return pageInt;
    }

    return 1;
}

function UpdateUrlPageParam( page )
{
    var url = new URL( window.location.href );
    url.searchParams.set( "page", page );
    history.replaceState( {}, "", url.pathname + url.search );
}

let currentPage = GetPageFromUrlParam();
const perPage = 50;
let totalPages = 1;
let currentQuery = "";

function renderPagination() 
{
  const paginationContainer = document.querySelector('.pagination');
  if (!paginationContainer) return;
  
  paginationContainer.innerHTML = '';
  const prevButton = document.createElement('a');
  prevButton.href = '#';
  prevButton.classList.add('pagination__link');
  prevButton.innerHTML = '&laquo; Prev';
  if (currentPage === 1) {
    prevButton.classList.add('disabled');
  } else {
    prevButton.addEventListener('click', (e) => 
    {
      e.preventDefault();
      goToPage(currentPage - 1);
    });
  }
  paginationContainer.appendChild(prevButton);
  const startPage = Math.max(1, currentPage - 2);
  const endPage = Math.min(totalPages, startPage + 4);
  
  for (let i = startPage; i <= endPage; i++) 
  {
    const pageLink = document.createElement('a');
    pageLink.href = '#';
    pageLink.classList.add('pagination__link');
    pageLink.textContent = i;
    
    if (i === currentPage) 
    {
      pageLink.classList.add('active');
    } else {
      pageLink.addEventListener('click', (e) => 
      {
        e.preventDefault();
        goToPage(i);
      });
    }
    
    paginationContainer.appendChild(pageLink);
  }
  
  const nextButton = document.createElement('a');
  nextButton.href = '#';
  nextButton.classList.add('pagination__link');
  nextButton.innerHTML = 'Next &raquo;';
  if (currentPage === totalPages) 
  {
    nextButton.classList.add('disabled');
  } else {
    nextButton.addEventListener('click', (e) => 
    {
      e.preventDefault();
      goToPage(currentPage + 1);
    });
  }
  paginationContainer.appendChild(nextButton);
}

function goToPage(page) 
{
  currentPage = page;
  UpdateUrlPageParam( currentPage );
  const pagination = document.querySelector('.pagination');
  pagination.classList.add('loading');
  window.scrollTo({ top: 0, behavior: 'smooth' });
  GetLuigiBoxCollectionProducts(
    currentPage,
    perPage,
    function(results)
    {
      //renderLuigiProductCards(results);
      pagination.classList.remove('loading');
    },
    function(error) 
    {
      console.error('Error loading products:', error);
      pagination.classList.remove('loading');
    },
    currentQuery,
    _rcp_template.collectionTitle
  );
}

function ApplyRCPDataToProductCards( )
{
    FetchNextAutoshipOrder( function( err, rechargeData )
    {
        if ( rechargeData && rechargeData.charges && rechargeData.charges.length > 0 )
        {
        }
        else
        {
            document.querySelectorAll(".autoship-add-to-cart:not(#ProductSubmitButton-autoship)").forEach(btn => 
            {
                var isMyAisle = document.body.id === 'lightning-my-aisle' || document.querySelector('#lightning-my-aisle');
                var fontSize = isMyAisle ? '12px' : '14px';
                
                var expectedContent = `
                    <span class="autoship-add-to">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="14" viewBox="0 0 22 14" fill="none" style="vertical-align:middle; margin-right:6px;">
                        <path d="M20.938 3.88773C20.9263 3.88703 20.9507 3.8827 21.0044 3.95316C21.0533 4.01728 21.1018 4.11242 21.1479 4.22464C21.2395 4.44722 21.3024 4.69594 21.3286 4.80179C21.4313 5.21251 21.4383 5.55473 21.4312 5.78812V5.79007C21.4093 6.87764 21.1147 7.78731 20.8765 8.37308C20.7451 8.69572 20.5918 9.01084 20.4136 9.31937L20.2271 9.62503C18.1692 12.8252 14.2197 14.1985 10.5767 13.0225L10.2251 12.9004C9.94338 12.797 9.66997 12.6793 9.40869 12.545L9.40674 12.544C9.01046 12.3444 8.71 12.1893 8.47803 12.0459C8.24712 11.9032 8.09569 11.7793 7.99072 11.6465H7.98975C7.96867 11.6188 7.88628 11.5082 7.74561 11.4825V11.4815L7.73486 11.4805H7.64893C7.56814 11.492 7.50249 11.5337 7.45361 11.5782C7.39314 11.6332 7.34065 11.7088 7.29346 11.7813C7.19133 11.9381 7.08437 12.1303 6.90479 12.375C6.57139 12.8292 6.3297 12.9984 6.17432 13.085L6.16943 13.0879C6.15368 13.0973 6.13643 13.1024 6.12158 13.1104L6.0835 13.0576C5.8908 12.7759 5.35022 11.9703 5.06396 10.9073C4.82966 10.0283 4.84975 9.2811 4.89111 7.83694V7.83109C4.89111 7.81474 4.89164 7.79881 4.89209 7.78323C4.91137 7.78029 4.93228 7.77695 4.95459 7.77347C5.4896 7.68959 6.5544 7.52632 7.66553 7.67191C8.22829 7.74649 9.19241 7.80166 10.3647 8.21194V8.21292C10.411 8.22966 10.4539 8.24616 10.4937 8.26077C10.3538 8.59904 10.1357 8.8126 9.99951 8.94534C9.55987 9.35934 9.32657 9.56772 9.20264 9.68069C9.16097 9.71868 9.12711 9.7535 9.1001 9.78128H8.95947L9.0083 10.0215C9.02812 10.1185 9.09679 10.1826 9.14404 10.2188C9.19716 10.2595 9.26304 10.2948 9.3335 10.3252C9.47566 10.3865 9.66801 10.4423 9.89502 10.4893C10.3512 10.5836 10.9756 10.647 11.688 10.6328C13.1113 10.6045 14.9132 10.2666 16.437 9.22269C16.8351 8.95031 17.6499 8.33018 18.4644 7.52151C19.276 6.71568 20.1045 5.70601 20.5073 4.65335L20.5083 4.65237C20.5447 4.55529 20.623 4.34198 20.7261 4.1553C20.778 4.06123 20.8306 3.98414 20.8794 3.9346C20.9109 3.90271 20.9299 3.89106 20.938 3.88773Z" fill="black" stroke="black" stroke-width="0.4"/>
                        <path d="M1.40625 4.01465C3.53427 0.711274 7.67062 -0.644625 11.4121 0.736328C11.6937 0.839712 11.9673 0.956482 12.2285 1.09082L12.2305 1.0918C12.6268 1.29137 12.9272 1.44642 13.1592 1.58984C13.39 1.73256 13.5415 1.85657 13.6465 1.98926C13.664 2.01217 13.729 2.10121 13.8398 2.14062L13.8916 2.1543L13.9023 2.15625C14.0236 2.17152 14.1184 2.11694 14.1836 2.05762C14.244 2.00262 14.2966 1.92784 14.3438 1.85547C14.4459 1.69866 14.5528 1.50645 14.7324 1.26172C15.0659 0.807379 15.3075 0.638318 15.4629 0.551758L15.4678 0.548828C15.4835 0.539471 15.4998 0.532448 15.5146 0.524414L15.5537 0.579102C15.7224 0.825821 16.1573 1.47235 16.4551 2.3418L16.5732 2.72852C16.8077 3.60771 16.7875 4.35534 16.7461 5.7998V5.80469C16.7461 5.82089 16.7446 5.83709 16.7441 5.85254L16.6826 5.86328C16.1477 5.94714 15.0834 6.11024 13.9727 5.96484C13.4096 5.89018 12.4432 5.83399 11.2695 5.42285C11.2236 5.40622 11.1811 5.38952 11.1416 5.375C11.2813 5.0368 11.5005 4.82322 11.6367 4.69043L11.6377 4.69141C12.0781 4.27673 12.3117 4.06798 12.4355 3.95508C12.493 3.90272 12.5383 3.86066 12.5664 3.82715C12.5812 3.80949 12.6052 3.77809 12.6191 3.73535C12.6358 3.68402 12.6301 3.64 12.624 3.6123H12.6221C12.6006 3.51895 12.5354 3.4563 12.4893 3.4209C12.4362 3.3803 12.3701 3.34578 12.2998 3.31543C12.1577 3.25413 11.9662 3.19734 11.7393 3.15039C11.283 3.05603 10.658 2.99267 9.94531 3.00684C8.52197 3.03515 6.72013 3.37303 5.19629 4.41699C4.79819 4.68936 3.98343 5.30951 3.16895 6.11816C2.3573 6.924 1.52878 7.93366 1.12598 8.98633V8.9873C1.08959 9.08436 1.01043 9.29854 0.907227 9.48535C0.855339 9.57922 0.802618 9.65562 0.753906 9.70508C0.720376 9.73906 0.700455 9.74834 0.693359 9.75098C0.684344 9.74593 0.663079 9.73005 0.629883 9.68652C0.581067 9.62246 0.531496 9.52809 0.485352 9.41602C0.439507 9.30462 0.4005 9.18637 0.370117 9.08301L0.304688 8.83789C0.201999 8.42717 0.195001 8.08495 0.202148 7.85156V7.84961C0.223984 6.76231 0.518683 5.85332 0.756836 5.26758C0.888124 4.94499 1.04157 4.62975 1.21973 4.32129L1.40625 4.01465Z" fill="black" stroke="black" stroke-width="0.4"/>
                        </svg>
                        <span class="autoship-name" style="font-size: ` + fontSize + `; vertical-align: middle;"><strong>Autoship </strong>every 4 weeks</span>
                        </span>

                `;
                
                var hasAutoshipName = btn.querySelector('.autoship-name');
                var currentFontSize = hasAutoshipName ? window.getComputedStyle(hasAutoshipName).fontSize : '';
                
                if (!hasAutoshipName || currentFontSize !== fontSize) {
                    btn.innerHTML = expectedContent;
                }
                
                if (btn.closest('.product-grid__product-card')) {
                    btn.style.cssText += 'pointer-events: auto !important; cursor: pointer !important;';
                    var allChildren = btn.querySelectorAll('*');
                    allChildren.forEach(function(child) {
                        child.style.cssText += 'pointer-events: auto !important; cursor: pointer !important; user-select: none !important;';
                    });
                }
            });

            function updatePdpButtonWithPercent()
            {
                var pdpButton = document.getElementById("ProductSubmitButton-autoship");
                if (!pdpButton) return;

                if (document.body.classList.contains('has-autoship')) return;

                var isMyAisle = document.body.id === 'lightning-my-aisle' || document.querySelector('#lightning-my-aisle');
                var fontSize = isMyAisle ? '12px' : '14px';

                var mainPriceEl = document.querySelector('.product-main-price');
                var autoshipPriceEl = document.querySelector('.autoship-price');

                if (!mainPriceEl || !autoshipPriceEl) return;

                var mainPrice = parseFloat(mainPriceEl.textContent.replace(/[^0-9.]/g, ''));
                var autoshipPrice = parseFloat(autoshipPriceEl.textContent.replace(/[^0-9.]/g, ''));

                if (isNaN(mainPrice) || isNaN(autoshipPrice) || mainPrice <= 0) return;

                var autoshipPercent = Math.round(((mainPrice - autoshipPrice) / mainPrice) * 100);
                if (autoshipPercent <= 0) return;

                var label = 'Subscribe & Save ' + autoshipPercent + '%';

                var autoshipNameEl = pdpButton.querySelector('.autoship-name');
                if (autoshipNameEl)
                {
                    autoshipNameEl.style.fontSize = fontSize;
                    autoshipNameEl.style.verticalAlign = 'middle';
                    autoshipNameEl.textContent = label;
                }
                else
                {
                    pdpButton.innerHTML =
                        '<span class="autoship-add-to">' +
                            '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="14" viewBox="0 0 22 14" fill="none" style="vertical-align:middle; margin-right:6px;">' +
                                '<path d="M20.938 3.88773C20.9263 3.88703 20.9507 3.8827 21.0044 3.95316C21.0533 4.01728 21.1018 4.11242 21.1479 4.22464C21.2395 4.44722 21.3024 4.69594 21.3286 4.80179C21.4313 5.21251 21.4383 5.55473 21.4312 5.78812V5.79007C21.4093 6.87764 21.1147 7.78731 20.8765 8.37308C20.7451 8.69572 20.5918 9.01084 20.4136 9.31937L20.2271 9.62503C18.1692 12.8252 14.2197 14.1985 10.5767 13.0225L10.2251 12.9004C9.94338 12.797 9.66997 12.6793 9.40869 12.545L9.40674 12.544C9.01046 12.3444 8.71 12.1893 8.47803 12.0459C8.24712 11.9032 8.09569 11.7793 7.99072 11.6465H7.98975C7.96867 11.6188 7.88628 11.5082 7.74561 11.4825V11.4815L7.73486 11.4805H7.64893C7.56814 11.492 7.50249 11.5337 7.45361 11.5782C7.39314 11.6332 7.34065 11.7088 7.29346 11.7813C7.19133 11.9381 7.08437 12.1303 6.90479 12.375C6.57139 12.8292 6.3297 12.9984 6.17432 13.085L6.16943 13.0879C6.15368 13.0973 6.13643 13.1024 6.12158 13.1104L6.0835 13.0576C5.8908 12.7759 5.35022 11.9703 5.06396 10.9073C4.82966 10.0283 4.84975 9.2811 4.89111 7.83694V7.83109C4.89111 7.81474 4.89164 7.79881 4.89209 7.78323C4.91137 7.78029 4.93228 7.77695 4.95459 7.77347C5.4896 7.68959 6.5544 7.52632 7.66553 7.67191C8.22829 7.74649 9.19241 7.80166 10.3647 8.21194V8.21292C10.411 8.22966 10.4539 8.24616 10.4937 8.26077C10.3538 8.59904 10.1357 8.8126 9.99951 8.94534C9.55987 9.35934 9.32657 9.56772 9.20264 9.68069C9.16097 9.71868 9.12711 9.7535 9.1001 9.78128H8.95947L9.0083 10.0215C9.02812 10.1185 9.09679 10.1826 9.14404 10.2188C9.19716 10.2595 9.26304 10.2948 9.3335 10.3252C9.47566 10.3865 9.66801 10.4423 9.89502 10.4893C10.3512 10.5836 10.9756 10.647 11.688 10.6328C13.1113 10.6045 14.9132 10.2666 16.437 9.22269C16.8351 8.95031 17.6499 8.33018 18.4644 7.52151C19.276 6.71568 20.1045 5.70601 20.5073 4.65335L20.5083 4.65237C20.5447 4.55529 20.623 4.34198 20.7261 4.1553C20.778 4.06123 20.8306 3.98414 20.8794 3.9346C20.9109 3.90271 20.9299 3.89106 20.938 3.88773Z"></path>' +
                                '<path d="M1.40625 4.01465C3.53427 0.711274 7.67062 -0.644625 11.4121 0.736328C11.6937 0.839712 11.9673 0.956482 12.2285 1.09082L12.2305 1.0918C12.6268 1.29137 12.9272 1.44642 13.1592 1.58984C13.39 1.73256 13.5415 1.85657 13.6465 1.98926C13.664 2.01217 13.729 2.10121 13.8398 2.14062L13.8916 2.1543L13.9023 2.15625C14.0236 2.17152 14.1184 2.11694 14.1836 2.05762C14.244 2.00262 14.2966 1.92784 14.3438 1.85547C14.4459 1.69866 14.5528 1.50645 14.7324 1.26172C15.0659 0.807379 15.3075 0.638318 15.4629 0.551758L15.4678 0.548828C15.4835 0.539471 15.4998 0.532448 15.5146 0.524414L15.5537 0.579102C15.7224 0.825821 16.1573 1.47235 16.4551 2.3418L16.5732 2.72852C16.8077 3.60771 16.7875 4.35534 16.7461 5.7998V5.80469C16.7461 5.82089 16.7446 5.83709 16.7441 5.85254L16.6826 5.86328C16.1477 5.94714 15.0834 6.11024 13.9727 5.96484C13.4096 5.89018 12.4432 5.83399 11.2695 5.42285C11.2236 5.40622 11.1811 5.38952 11.1416 5.375C11.2813 5.0368 11.5005 4.82322 11.6367 4.69043L11.6377 4.69141C12.0781 4.27673 12.3117 4.06798 12.4355 3.95508C12.493 3.90272 12.5383 3.86066 12.5664 3.82715C12.5812 3.80949 12.6052 3.77809 12.6191 3.73535C12.6358 3.68402 12.6301 3.64 12.624 3.6123H12.6221C12.6006 3.51895 12.5354 3.4563 12.4893 3.4209C12.4362 3.3803 12.3701 3.34578 12.2998 3.31543C12.1577 3.25413 11.9662 3.19734 11.7393 3.15039C11.283 3.05603 10.658 2.99267 9.94531 3.00684C8.52197 3.03515 6.72013 3.37303 5.19629 4.41699C4.79819 4.68936 3.98343 5.30951 3.16895 6.11816C2.3573 6.924 1.52878 7.93366 1.12598 8.98633V8.9873C1.08959 9.08436 1.01043 9.29854 0.907227 9.48535C0.855339 9.57922 0.802618 9.65562 0.753906 9.70508C0.720376 9.73906 0.700455 9.74834 0.693359 9.75098C0.684344 9.74593 0.663079 9.73005 0.629883 9.68652C0.581067 9.62246 0.531496 9.52809 0.485352 9.41602C0.439507 9.30462 0.4005 9.18637 0.370117 9.08301L0.304688 8.83789C0.201999 8.42717 0.195001 8.08495 0.202148 7.85156V7.84961C0.223984 6.76231 0.518683 5.85332 0.756836 5.26758C0.888124 4.94499 1.04157 4.62975 1.21973 4.32129L1.40625 4.01465Z"></path>' +
                            '</svg>' +
                            '<span class="autoship-name" style="font-size:' + fontSize + '; vertical-align: middle;">' + label + '</span>' +
                        '</span>';
                }
            }
            
            updatePdpButtonWithPercent();
            setTimeout(updatePdpButtonWithPercent, 500);
            setTimeout(updatePdpButtonWithPercent, 1500);
            setTimeout(updatePdpButtonWithPercent, 3000);

            document.querySelectorAll(".autoship-add-to-cart:not(.product-grid__product-card .autoship-add-to-cart):not(.autoship-push-content .autoship-add-to-cart):not(#ProductSubmitButton-autoship)").forEach(function (btn)
            {
                var autoshipPriceEl = document.querySelector('.top__prices__autoship-price');
                var currentPriceEl = document.querySelector('.top__prices__curr-price');

                var autoshipPercent = null;

                if (autoshipPriceEl && currentPriceEl)
                {
                    var autoPrice = parseFloat(autoshipPriceEl.textContent.replace(/[^0-9.]/g, ''));
                    var currentPrice = parseFloat(currentPriceEl.textContent.replace(/[^0-9.]/g, ''));

                    if (!isNaN(autoPrice) && !isNaN(currentPrice) && currentPrice > 0)
                    {
                        autoshipPercent = Math.round(((currentPrice - autoPrice) / currentPrice) * 100);
                        if (autoshipPercent <= 0) autoshipPercent = null;
                    }
                }

                var label = autoshipPercent
                    ? 'Subscribe & Save ' + autoshipPercent + '%'
                    : 'Subscribe & Save';

                btn.innerHTML =
                    '<span class="autoship-add-to">' +
                        '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="14" viewBox="0 0 22 14" fill="none" style="vertical-align:middle; margin-right:6px;">' +
                            '<path d="M20.938 3.88773C20.9263 3.88703 20.9507 3.8827 21.0044 3.95316C21.0533 4.01728 21.1018 4.11242 21.1479 4.22464C21.2395 4.44722 21.3024 4.69594 21.3286 4.80179C21.4313 5.21251 21.4383 5.55473 21.4312 5.78812V5.79007C21.4093 6.87764 21.1147 7.78731 20.8765 8.37308C20.7451 8.69572 20.5918 9.01084 20.4136 9.31937L20.2271 9.62503C18.1692 12.8252 14.2197 14.1985 10.5767 13.0225L10.2251 12.9004C9.94338 12.797 9.66997 12.6793 9.40869 12.545L9.40674 12.544C9.01046 12.3444 8.71 12.1893 8.47803 12.0459C8.24712 11.9032 8.09569 11.7793 7.99072 11.6465H7.98975C7.96867 11.6188 7.88628 11.5082 7.74561 11.4825V11.4815L7.73486 11.4805H7.64893C7.56814 11.492 7.50249 11.5337 7.45361 11.5782C7.39314 11.6332 7.34065 11.7088 7.29346 11.7813C7.19133 11.9381 7.08437 12.1303 6.90479 12.375C6.57139 12.8292 6.3297 12.9984 6.17432 13.085L6.16943 13.0879C6.15368 13.0973 6.13643 13.1024 6.12158 13.1104L6.0835 13.0576C5.8908 12.7759 5.35022 11.9703 5.06396 10.9073C4.82966 10.0283 4.84975 9.2811 4.89111 7.83694V7.83109C4.89111 7.81474 4.89164 7.79881 4.89209 7.78323C4.91137 7.78029 4.93228 7.77695 4.95459 7.77347C5.4896 7.68959 6.5544 7.52632 7.66553 7.67191C8.22829 7.74649 9.19241 7.80166 10.3647 8.21194V8.21292C10.411 8.22966 10.4539 8.24616 10.4937 8.26077C10.3538 8.59904 10.1357 8.8126 9.99951 8.94534C9.55987 9.35934 9.32657 9.56772 9.20264 9.68069C9.16097 9.71868 9.12711 9.7535 9.1001 9.78128H8.95947L9.0083 10.0215C9.02812 10.1185 9.09679 10.1826 9.14404 10.2188C9.19716 10.2595 9.26304 10.2948 9.3335 10.3252C9.47566 10.3865 9.66801 10.4423 9.89502 10.4893C10.3512 10.5836 10.9756 10.647 11.688 10.6328C13.1113 10.6045 14.9132 10.2666 16.437 9.22269C16.8351 8.95031 17.6499 8.33018 18.4644 7.52151C19.276 6.71568 20.1045 5.70601 20.5073 4.65335L20.5083 4.65237C20.5447 4.55529 20.623 4.34198 20.7261 4.1553C20.778 4.06123 20.8306 3.98414 20.8794 3.9346C20.9109 3.90271 20.9299 3.89106 20.938 3.88773Z"></path>' +
                            '<path d="M1.40625 4.01465C3.53427 0.711274 7.67062 -0.644625 11.4121 0.736328C11.6937 0.839712 11.9673 0.956482 12.2285 1.09082L12.2305 1.0918C12.6268 1.29137 12.9272 1.44642 13.1592 1.58984C13.39 1.73256 13.5415 1.85657 13.6465 1.98926C13.664 2.01217 13.729 2.10121 13.8398 2.14062L13.8916 2.1543L13.9023 2.15625C14.0236 2.17152 14.1184 2.11694 14.1836 2.05762C14.244 2.00262 14.2966 1.92784 14.3438 1.85547C14.4459 1.69866 14.5528 1.50645 14.7324 1.26172C15.0659 0.807379 15.3075 0.638318 15.4629 0.551758L15.4678 0.548828C15.4835 0.539471 15.4998 0.532448 15.5146 0.524414L15.5537 0.579102C15.7224 0.825821 16.1573 1.47235 16.4551 2.3418L16.5732 2.72852C16.8077 3.60771 16.7875 4.35534 16.7461 5.7998V5.80469C16.7461 5.82089 16.7446 5.83709 16.7441 5.85254L16.6826 5.86328C16.1477 5.94714 15.0834 6.11024 13.9727 5.96484C13.4096 5.89018 12.4432 5.83399 11.2695 5.42285C11.2236 5.40622 11.1811 5.38952 11.1416 5.375C11.2813 5.0368 11.5005 4.82322 11.6367 4.69043L11.6377 4.69141C12.0781 4.27673 12.3117 4.06798 12.4355 3.95508C12.493 3.90272 12.5383 3.86066 12.5664 3.82715C12.5812 3.80949 12.6052 3.77809 12.6191 3.73535C12.6358 3.68402 12.6301 3.64 12.624 3.6123H12.6221C12.6006 3.51895 12.5354 3.4563 12.4893 3.4209C12.4362 3.3803 12.3701 3.34578 12.2998 3.31543C12.1577 3.25413 11.9662 3.19734 11.7393 3.15039C11.283 3.05603 10.658 2.99267 9.94531 3.00684C8.52197 3.03515 6.72013 3.37303 5.19629 4.41699C4.79819 4.68936 3.98343 5.30951 3.16895 6.11816C2.3573 6.924 1.52878 7.93366 1.12598 8.98633V8.9873C1.08959 9.08436 1.01043 9.29854 0.907227 9.48535C0.855339 9.57922 0.802618 9.65562 0.753906 9.70508C0.720376 9.73906 0.700455 9.74834 0.693359 9.75098C0.684344 9.74593 0.663079 9.73005 0.629883 9.68652C0.581067 9.62246 0.531496 9.52809 0.485352 9.41602C0.439507 9.30462 0.4005 9.18637 0.370117 9.08301L0.304688 8.83789C0.201999 8.42717 0.195001 8.08495 0.202148 7.85156V7.84961C0.223984 6.76231 0.518683 5.85332 0.756836 5.26758C0.888124 4.94499 1.04157 4.62975 1.21973 4.32129L1.40625 4.01465Z"></path>' +
                        '</svg>' +
                        '<span class="autoship-name" style="font-size:14px;">' + label + '</span>' +
                    '</span>';
            });
        }

        setUpCartEventsWellEasy( );      
        updateGridSection( );  
    } );
}

function FindLoadedRechargeData( array, key, value )
{
    for( var i = 0; i < array.length; i++ )
    {
        if (array[ i ][ key ] == value)
        {
            return array[ i ]; // return the whole object
        }
    }
    return null; // not found
}

function RenderAutoshipPrice( productCard, variant )
{
    const autoshipPrice = formatter.format(parseFloat((variant.selling_plan_allocations[ 0 ].price / 100) + " GBP"));
    const autoshipSpan = productCard.querySelector( ".product-card__price-autoship-price" );
    if ( autoshipSpan )
    {
        autoshipSpan.textContent = autoshipPrice;
        autoshipSpan.parentElement.classList.remove( "visibility-hidden" );
        productCard.querySelector('.autoship-add-to-cart').classList.remove( "visibility-hidden" );
        productCard.querySelector('.pdp-autoship-qty').classList.remove( "visibility-hidden" );
    }
}

function ObserveSingleProductCard( productCard )
{
    if( !productCard ) return; // No card found

    var observer = new IntersectionObserver( function( entries, obs )
    {
        var entry = entries[ 0 ];
        if( entry.isIntersecting )
        {
            GetAutoshipData( productCard );
            // Stop observing once loaded
            obs.unobserve( productCard );
        }
    },
    {
        root: null,
        rootMargin: "200px 0px",
        threshold: 0
    });

    observer.observe( productCard );
}

function GetAutoshipData( productCard )
{
    var productData = JSON.parse(productCard?.dataset.productData || '{}');
    if( productData != '{}' )
    {
        var rechargeVariant = FindLoadedRechargeData( fetchedProductData, "id", productData.attributes.to_cart_variant_id[ 0 ] );
        if( rechargeVariant )
        {
            RenderAutoshipPrice( productCard, rechargeVariant );
        }
        else
        {
            var url;
            if ( productData.url.indexOf( "?" ) > 0 )
            {
                var parts = productData.url.split( "?" );
                url = parts[ 0 ] + ".js?" + parts[ 1 ];
            }
            else
            {
                url = productData.url + ".js";
            }
            FetchJSONDataFromURL( url, function( err, response, xhr )
            {
                if ( ( response ) && ( response.variants ) )
                {
                    for ( var i = 0; i < response.variants.length; i++ )
                    {
                        var variant = response.variants[ i ];
                        if ( variant.id == productData.attributes.to_cart_variant_id[ 0 ] )
                        {
                            if ( ( variant.selling_plan_allocations ) && ( variant.selling_plan_allocations.length > 0 ) )
                            {
                                RenderAutoshipPrice( productCard, variant );
                                fetchedProductData.push( variant );
                            }
                        }
                    }
                }
            } );
        }
    }
}

function UpdateAutoshipShipping()
{
    var freeEl = document.getElementById( "shipping_free" );
    var paidEl = document.getElementById( "shipping_paid" );

    if ( ( !freeEl ) || ( !paidEl ) )
    {
        return;
    }

    function toPence( val )
    {
        if ( val == null )
        {
            return null;
        }

        var s = String( val ).trim().replace( /,/g, "" );
        var n = parseFloat( s );

        if ( isNaN( n ) || !isFinite( n ) )
        {
            return null;
        }
        var looksLikePounds = ( s.indexOf( "." ) !== -1 ) || ( n < 1000 );
        return Math.round( looksLikePounds ? ( n * 100 ) : n );
    }

    var totalPence = null;
    var mgrTotalEl = document.querySelector( ".autoship-manager .price__discounted" );

    if ( mgrTotalEl )
    {
        var dsPence = ( mgrTotalEl.dataset ) ? mgrTotalEl.dataset.totalPence : null;
        var dsPrice = ( mgrTotalEl.dataset ) ? mgrTotalEl.dataset.totalPrice : null;

        totalPence = toPence( ( dsPence != null && dsPence !== "" ) ? dsPence : dsPrice );
    }

    if ( totalPence == null )
    {
        var nextOrderEl = document.querySelector( ".autoship-no .details__order__total-price__price" );
        if ( nextOrderEl )
        {
            var text = ( nextOrderEl.textContent || "" ).replace( /,/g, "" );
            var gbp = parseFloat( text.replace( /[^\d.]/g, "" ) );

            if ( ( !isNaN( gbp ) ) && ( isFinite( gbp ) ) )
            {
                totalPence = Math.round( gbp * 100 );
            }
        }
    }

    var isFree = ( totalPence != null ) && ( totalPence >= 3900 );
    freeEl.style.display = isFree ? "" : "none";
    paidEl.style.display = isFree ? "none" : "";
}

function renderLuigiProductCards(json)
{
        const products = json.results.hits;
        const oldProducts = document.querySelectorAll(".product-grid__product-card:not(.product-grid__product-card--template):not( .product-grid__product-card--skeleton ):not(.grid-promo-card)");
        oldProducts.forEach(el => el.remove());

        const template = document.querySelector(".product-grid__product-card--template");
        const skeletons = document.querySelectorAll( ".product-grid__product-card--skeleton" );
        skeletons.forEach( el => el.classList.add( "hidden" ) );

        products.forEach( (product, index) => {
            if( 
                ( product.attributes.to_cart_variant_id || product.attributes.to_cart_product_id ) 
                && product.attributes.price
                && ( Number( product.attributes.price_amount ) > 0 )
                && product.url
                && product.attributes.title
            )
            {
                const productCard = template.cloneNode(true);
                productCard.dataset.productId = product.attributes.to_cart_product_id;
                productCard.dataset.variantId = product.attributes.to_cart_variant_id;

                var vids = productCard.querySelectorAll( "[data-variant-id]" );
                vids.forEach( function( vid )
                {
                    vid.setAttribute( "data-variant-id", productCard.dataset.variantId );
                } );
                
                const skuList = 
                [
                product.attributes.handle,
                ...(product.attributes.sku_list || []),
                product.attributes.sku,
                product.attributes.to_cart_variant_id
                ].filter(Boolean).join(';');

                const ratingDiv = document.createElement('div');
                ratingDiv.className = 'ruk_rating_snippet';
                ratingDiv.setAttribute('data-sku', skuList);
                const target = productCard.querySelector('.product-card__brand-review-container')
                            || productCard.querySelector('.product-card__price-container') 
                            || productCard.querySelector('.product-card__title-container') 
                            || productCard;
                target.appendChild(ratingDiv);
                const cardLink = productCard.querySelector('.product-card__link-area');

                var collectionUrl = "";
                if ( _rcp_template.template == "collection" )
                {
                    collectionUrl = _rcp_template.collectionHandle
                }
                
                if (cardLink) 
                {
                cardLink.setAttribute('href', collectionUrl + product.url);
                productCard.querySelector('.product-card__info-container').setAttribute('href', collectionUrl + product.url);
                }

                productCard._productData = product;
                productCard.dataset.productData = JSON.stringify(product);
                productCard.classList.remove("product-grid__product-card--template");

                const handle = handleize(product.attributes.title || '');

                const imageWrapperLink = productCard.querySelector(".product-card__link");
                if (imageWrapperLink) imageWrapperLink.setAttribute("href", collectionUrl + product.url);

                var image_url = product.attributes.image_link_l;
                if ( Array.isArray( image_url ) )
                {
                    image_url = image_url[ 0 ];
                }
                image_url = image_url.replace( /(_600x.)/i, "_300x." );

                var isMobile = window.innerWidth <= 768;
                var eagerLimit = isMobile ? 1 : 5;
                var imgEl = productCard.querySelector(".product-card__image__img");
                if ( index < eagerLimit )
                {
                    imgEl.setAttribute( "loading", "eager" );
                    imgEl.fetchPriority = "high";
                }
                else
                {
                    imgEl.setAttribute( "loading", "lazy" );
                    imgEl.setAttribute( "decoding", "async" );
                }

                productCard.querySelector(".product-card__image__img").setAttribute("src", image_url);
                if ( index < eagerLimit )
                {
                    productCard.querySelector(".product-card__image__img").fetchPriority = "high";
                }
                productCard.querySelector(".product-card__image__img").setAttribute("alt", product.attributes.title);
                productCard.querySelector(".product-card__title").innerHTML = product.attributes.title;
                productCard.querySelector(".product-card__brand").innerHTML = product.attributes.brand;
                productCard.querySelector(".product-card__buy-button").dataset.variantId = product.attributes.to_cart_variant_id;

                if ( product.attributes.availability == 0 )
                {
                    var atc = productCard.querySelector(".product-card__buy-button");
                    atc.setAttribute( "disabled", "" );
                    atc.textContent = "Out of Stock";
                }

                productCard.querySelector(".product-card__price__discounted").innerHTML = formatter.format(parseFloat(product.attributes.price));

                if( product.attributes.price_old )
                {
                    productCard.querySelector(".product-card__price__full").innerHTML = "(RRP " + formatter.format(parseFloat(product.attributes.price_old)) + ")";
                }
                else
                {
                    productCard.querySelector(".product-card__price__full").classList.add( "hidden" );
                }

                const discountPercent = Math.round( 100 - (parseFloat(product.attributes.price) / parseFloat(product.attributes.price_old) * 100) );

                var tagContainer = productCard.querySelector( ".product-card__tag-container" );
                var templateTag = productCard.querySelector( ".product-card__tag" );
                if ( discountPercent > 0 )
                {
                    productCard.querySelector(".product-card__discount").innerHTML =
                        productCard.querySelector(".product-card__discount").innerHTML.replace("$percentoff$", discountPercent);
                }
                else
                {
                    productCard.querySelector( ".product-card__discount" ).style.display = "none";
                }

                //product sale tags
                if ( ( product.attributes.category ) && ( product.attributes.category.includes( "New Lower Prices" ) ) )
                {
                    var lowerPricesTag = templateTag.cloneNode( true );
                    lowerPricesTag.classList.add( "product-card__tag--new-sale" );
                    lowerPricesTag.textContent = "New Lower Prices";
                    tagContainer.appendChild( lowerPricesTag );
                }

                if ( product.attributes.tags.includes( "New Lower Price" ) )
                {
                    var newLowerPriceTag = templateTag.cloneNode( true );
                    newLowerPriceTag.classList.add( "product-card__tag--wec" );
                    newLowerPriceTag.classList.add( "product-card__tag--new-lower-price" );
                    newLowerPriceTag.textContent = "New Lower Price";
                    tagContainer.appendChild( newLowerPriceTag );
                }

                if ( product.attributes.tags.includes( "Lower Autoship Price" ) )
                {
                    var lowerAutoshipPriceTag = templateTag.cloneNode( true );
                    lowerAutoshipPriceTag.classList.add( "product-card__tag--wec" );
                    lowerAutoshipPriceTag.classList.add( "product-card__tag--lower-autoship-price" );
                    lowerAutoshipPriceTag.textContent = "Lower Autoship Price";
                    tagContainer.appendChild( lowerAutoshipPriceTag );
                }
                
                if ( product.attributes.tags.includes( "New" ) )
                {
                    var newTag = templateTag.cloneNode( true );
                    newTag.classList.add( "product-card__tag--new" );
                    newTag.textContent = "New";
                    tagContainer.appendChild( newTag );
                }

                if ( product.attributes.tags.includes( "Clearance" ) )
                {
                    var clearanceTag = templateTag.cloneNode( true );
                    clearanceTag.classList.add( "product-card__tag--clear" );
                    clearanceTag.textContent = "Clearance";
                    tagContainer.appendChild( clearanceTag );
                }

                if ( product.attributes.tags.includes( "WellEasy Days 10%" ) || product.attributes.tags.includes( "WellEasy Days 15%" ) || product.attributes.tags.includes( "WellEasy Days 20%" ) )
                {
                    var weDaysTag = templateTag.cloneNode( true );
                    weDaysTag.classList.add( "product-card__tag--wedays" );

                    if ( product.attributes.tags.includes( "WellEasy Days 10%" ) )
                    {
                        weDaysTag.innerHTML = 'WellEasy Days <span class="product-card__tag-badge">10%</span>';
                    }
                    else if ( product.attributes.tags.includes( "WellEasy Days 15%" ) )
                    {
                        weDaysTag.innerHTML = 'WellEasy Days <span class="product-card__tag-badge">15%</span>';
                    }
                    else if ( product.attributes.tags.includes( "WellEasy Days 20%" ) )
                    {
                        weDaysTag.innerHTML = 'WellEasy Days <span class="product-card__tag-badge">20%</span>';
                    }

                    tagContainer.appendChild( weDaysTag );
                }


                product.attributes.tags.filter( tag =>
                {
                    if (tag.includes("Buy") && tag.includes("get") && tag.includes("%") && tag.includes("WellEasy Cash"))
                    {
                        var buyGetTag = templateTag.cloneNode(true);
                        buyGetTag.classList.add("product-card__tag--buy-get-wec");
                        var tagText = tag.split(",")[0].trim();
                        // Add "+" after the first number in "Buy X and get..."
                        var formattedTag = tagText.replace(/Buy (\d+)/, "Buy $1+");
                        buyGetTag.textContent = formattedTag;
                        tagContainer.appendChild(buyGetTag);
                    }
                    else if (tag.includes("WellEasy Cash") || tag.includes("4 for 3")) 
                    {
                        var wecTag = templateTag.cloneNode(true);
                        wecTag.classList.add("product-card__tag--wec");
                        var displayText = tag.split(",")[0].trim();

                        wecTag.innerHTML = `
                            ${displayText}
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none" style="margin-left:3px;vertical-align:middle;">
                                <g clip-path="url(#clip0_11441_43155)">
                                    <rect width="17" height="16" rx="8" fill="white"/>
                                    <path d="M8.5 0.25C13.0708 0.25 16.75 3.73386 16.75 8C16.75 12.2661 13.0708 15.75 8.5 15.75C3.92916 15.75 0.25 12.2661 0.25 8C0.25 3.73386 3.92916 0.25 8.5 0.25ZM11.6914 5.51172C11.6912 4.0372 10.3661 3.1356 8.96777 3.34473C7.55499 3.55525 6.5832 4.75836 6.58301 6.37793C6.58301 6.56942 6.57808 6.76037 6.57031 6.9502H6.4082C6.12184 6.9502 5.84305 7.05684 5.63574 7.25293C5.42928 7.44829 5.3086 7.71609 5.30859 8C5.30859 8.28236 5.4276 8.55057 5.63574 8.74609V8.74707C5.81892 8.92034 6.05786 9.0232 6.30859 9.04492C6.18113 9.65251 6.01376 10.2477 5.79688 10.8291C5.76312 10.9196 5.74212 11.0146 5.73535 11.1104L5.7334 11.2002C5.73345 11.4825 5.85246 11.7508 6.06055 11.9463V11.9473C6.26783 12.1433 6.54669 12.25 6.83301 12.25H10.2334C10.4839 12.2499 10.7287 12.1683 10.9248 12.0166L11.0059 11.9473C11.2138 11.7514 11.333 11.4833 11.333 11.2002C11.333 10.9173 11.2138 10.6478 11.0049 10.4521C10.7979 10.2583 10.5207 10.1505 10.2334 10.1504H8.30566C8.4007 9.78666 8.48064 9.41941 8.54688 9.0498H9.80859C10.0949 9.04969 10.3738 8.94314 10.5811 8.74707L10.5801 8.74609C10.7879 8.55018 10.9082 8.28308 10.9082 8C10.9082 7.71708 10.789 7.44757 10.5801 7.25195C10.3731 7.05819 10.0958 6.95031 9.80859 6.9502H8.77148C8.77847 6.76064 8.7832 6.56967 8.7832 6.37793C8.78327 6.03342 8.85755 5.80009 8.95508 5.65332C9.0495 5.51128 9.17177 5.43907 9.30664 5.41895H9.30762C9.41737 5.40256 9.46138 5.42497 9.4707 5.43164C9.47247 5.43271 9.49213 5.44498 9.49219 5.51172C9.49219 5.79421 9.61102 6.06324 9.81934 6.25879V6.25977C10.027 6.45523 10.305 6.56249 10.5918 6.5625C10.878 6.5625 11.156 6.45466 11.3633 6.25879L11.3643 6.25977C11.5725 6.0638 11.6914 5.79506 11.6914 5.51172Z" fill="#0EC4B9" stroke="black" stroke-width="0.5"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_11441_43155">
                                        <rect width="17" height="16" rx="8" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        `;

                        tagContainer.appendChild(wecTag);
                    }

                    var tags = tag.split(",");
                    tags.forEach(function(singleTag)
                    {
                        singleTag = singleTag.trim();

                        if ( singleTag.includes("Sale") && singleTag.includes("%") )
                        {
                            var discountTag = templateTag.cloneNode(true);
                            discountTag.classList.add("product-card__tag--sale");
                            discountTag.textContent = singleTag;
                            tagContainer.appendChild(discountTag);
                        }
                    });
                });

                // Wishlist
                productCard.querySelector(".button--wishlist").dataset.productHandle = handle;
                productCard.querySelector(".button--wishlist").dataset.product = product.attributes.to_cart_product_id;

                // AUTOSHIP BUTTON
                const autoshipBtn = productCard.querySelector('.autoship-add-to-cart');
                if (autoshipBtn) {
                    
                    if ( product.attributes.availability == 0 )
                    {
                        autoshipBtn.setAttribute( "disabled", "" );
                        autoshipBtn.querySelector( ".autoship-add-to" ).textContent = "Out of Stock";
                    }
                    const productId = product.attributes.to_cart_product_id;
                    const variantId = product.attributes.to_cart_variant_id;
                    
                    autoshipBtn.dataset.productId = productId;
                    autoshipBtn.dataset.variantId = variantId;
                    autoshipBtn.dataset.productTitle = product.attributes.title;
                    autoshipBtn.dataset.productVendor = product.attributes.brand;
                    autoshipBtn.dataset.productImage = product.attributes.image_link;
                    autoshipBtn.dataset.productPrice = product.attributes.price;
                    autoshipBtn.dataset.compareAtPrice  = product.attributes.price_old;
                    autoshipBtn.classList.remove('hidden');
                    
                    
                    function triggerAutoshipAdd() {
                        if (!autoshipBtn.disabled) {
                            autoshipBtn.disabled = true;
                            handleAutoshipAdd(autoshipBtn);
                        }
                    }
                    
                    autoshipBtn.style.cssText += 'pointer-events: auto !important; cursor: pointer !important;';
                    
                    var allChildren = autoshipBtn.querySelectorAll('*');
                    allChildren.forEach(function(child) {
                        child.style.cssText += 'pointer-events: auto !important; cursor: pointer !important; user-select: none !important;';
                    });
                }

                toggleATCButton( productCard.querySelector(".product-card__buy-button") );
                template.parentElement.appendChild(productCard);

                ObserveSingleProductCard( productCard );
            }
        });

        var promoCard = document.querySelector(".grid-promo-card");
        if ( promoCard )
        {
            var promoPosition = parseInt( promoCard.dataset.promoPosition, 10 ) || 3;
            var allCards = template.parentElement.querySelectorAll(".product-grid__product-card:not(.product-grid__product-card--template):not(.product-grid__product-card--skeleton):not(.grid-promo-card)");
            var insertIndex = promoPosition;
            if ( insertIndex < allCards.length )
            {
                allCards[insertIndex].parentNode.insertBefore( promoCard, allCards[insertIndex] );
            }
            else
            {
                template.parentElement.appendChild( promoCard );
            }
            promoCard.style.display = "";
        }
        
        WE_ReviewsIo_InitRatingSnippet( );

        ApplyRCPDataToProductCards( );
        reorderDesktopBrandAboveTitle();
}

function setupCollectionAutoshipQuantity(qtyElement, sid, originalButton) 
{
    const qtyText  = qtyElement.querySelector('.pdp-autoship-qty-count');
    const minusBtn = qtyElement.querySelector('.pdp-autoship-minus');
    const plusBtn  = qtyElement.querySelector('.pdp-autoship-plus');
    originalButton.classList.add( "hidden" );
    qtyElement.classList.remove( "hidden" );
    function updateUI(qty) 
    {
        qtyText.textContent = AutoshipQtyString( qty );
    }

    updateUI( 1 );
    
    function sync( newQty, operator, cb ) 
    {
        if ( newQty == 0 )
        {
            window.ReallyModifySubscriptionQuantity(sid, 0, (err, response) =>
            {
                if ( err ) 
                {
                    console.log('Failed to remove.');
                }
                else
                {
                    window._autoshipData = response;
                    var newestRequest = getNewestRequest( "sid", sid );
                    if ( newestRequest == null || newestRequest.quantity == newQty  )
                    {
                        minusBtn.disabled = false;
                        qtyElement.requestInProgress = false;
                        qtyElement.classList.add( "hidden" );
                        originalButton.classList.remove('hidden');
                        originalButton.removeAttribute( "disabled" );
                        PopulateAutoshipDetails( response );
                        var aMProductCard = document.querySelector( `.autoship-manager .product-card[ data-sid="${ sid }" ]` );
                        if ( aMProductCard ) handleAutoshipManagerQU( aMProductCard, 0, "minus" );
                    }
                    else if ( newestRequest.quantity < newQty )
                    {
                        sync( newestRequest.quantity, "minus" );
                    }
                    else
                    {
                        sync( newestRequest.quantity, "plus" );
                    }
                }
            });
        }
        else
        {
            window.ReallyModifySubscriptionQuantity(sid, newQty, (err, response) => 
            {
                if ( err )
                {
                    alert('Failed to update Autoship quantity.');
                }
                else
                {
                    window._autoshipData = response;
                    var newestRequest = getNewestRequest( "sid", sid );
                    qtyElement.requestInProgress = false;
                    if ( newestRequest == null || newestRequest.quantity == newQty  )
                    {
                        if ( operator == "minus" )
                        {
                            var aMProductCard = document.querySelector( `.autoship-manager .product-card[ data-sid="${ sid }" ]` );
                            if ( aMProductCard ) handleAutoshipManagerQU( aMProductCard, newQty, "minus" );
                        }
                        else
                        {
                            var aMProductCard = document.querySelector( `.autoship-manager .product-card[ data-sid="${ sid }" ]` );
                            if ( aMProductCard ) handleAutoshipManagerQU( aMProductCard, newQty, "plus" );
                        }

                        clearFinishedRequests( "sid", sid );
                    }
                    else if ( newestRequest.quantity < newQty )
                    {
                        sync( newestRequest.quantity, "minus" );
                    }
                    else
                    {
                        sync( newestRequest.quantity, "plus" );
                    }
                }
            });
        }
        if ( typeof cb == "function" )
        {
            cb( );
        }
    }

    if ( !minusBtn._autoshipHandlerAttached )
    {
        minusBtn._autoshipHandlerAttached = true;
        minusBtn.addEventListener('click', () => 
        {
            const current = parseInt(qtyText.textContent) || 1;
            if ( current === 1 )
            {
                minusBtn.disabled = true;
            }
            if ( current - 1 >= 0 )
            {
                window.autoshipQuantityUpdates.push( { sid: sid, quantity: current - 1 } );
                updateUI( current - 1 ) ;
                if ( !qtyElement.requestInProgress )
                {
                    qtyElement.requestInProgress = true;
                    sync( current - 1, "minus" );
                }
            }
        });
    }
    
    if ( !plusBtn._autoshipHandlerAttached )
    {
        plusBtn._autoshipHandlerAttached = true;
        plusBtn.addEventListener('click', () => 
        {
            const current = parseInt(qtyText.textContent) || 1;
            if ( current > 1 )
            {
                minusBtn.disabled = false;
            }
            window.autoshipQuantityUpdates.push( { sid: sid, quantity: current + 1 } );
            updateUI( current + 1 ) ;
            if ( !qtyElement.requestInProgress )
            {
                qtyElement.requestInProgress = true;
                sync( current + 1, "plus" );
            }
        });
    }
}

function FetchJSONDataFromURL( url, cb )
{
    var xhr = new XMLHttpRequest();

    xhr.onreadystatechange = function( )
    {
        if ( xhr.readyState == 4 )
        {
            var response;
            var err;
            if ( xhr.status == 200 )
            {
                if ( ( xhr.responseText ) && ( xhr.responseText.length > 0 ) )
                {
                    try
                    {
                        response = JSON.parse( xhr.responseText );
                    }
                    catch ( e )
                    {
                        console.log("error parsing response : " + e.stack);
                        err = { "error": e };
                    }
                }
            }
            else
            {
                err = { "error": xhr.status };

                if ( ( xhr.responseText ) && ( xhr.responseText.length > 0 ) )
                {
                    try
                    {
                        err.detail = JSON.parse( xhr.responseText );
                    }
                    catch ( e )
                    {
                    }
                }
            }

            cb( err, response, xhr );
        }
    };


    xhr.open( "GET", url, true );
    xhr.send( );
}

function GetSellingPlan( productCard, productData, cb )
{
    var spid = productCard.getAttribute( "data-spid" );
    if ( spid )
    {
        // already fetched
        if ( cb )
        {
            cb( spid );
        }
    }
    else if ( productCard.cbq )
    {
        // being fetched now
        if ( cb )
        {
            productCard.cbq.push( cb );
        }
    }
    else
    {
        // go fetch
        productCard.cbq = [ ];    // so other calls just wait
        if ( cb )
        {
            productCard.cbq.push( cb );
        }

        function Done( )
        {
            var cbq = productCard.cbq;
            productCard.cbq = undefined;

            if ( spid )
            {
                productCard.setAttribute( "data-spid", spid );
            }
            
            for ( var i = 0; i < cbq.length; i++ )
            {
                cbq[ i ]( spid );
            }
        }
        
        var url;
        if ( productData.url.indexOf( "?" ) > 0 )
        {
            var parts = productData.url.split( "?" );
            url = parts[ 0 ] + ".js?" + parts[ 1 ];
        }
        else
        {
            url = productData.url + ".js";
        }
        
        var retries = 0;
        function TryNow( )
        {
            FetchJSONDataFromURL( url, function( err, response, xhr )
            {
                if ( ( response ) && ( response.variants ) )
                {
                    for ( var i = 0; i < response.variants.length; i++ )
                    {
                        var variant = response.variants[ i ];
                        if ( variant.id == productData.attributes.to_cart_variant_id[ 0 ] )
                        {
                            if ( ( variant.selling_plan_allocations ) && ( variant.selling_plan_allocations.length > 0 ) )
                            {
                                spid = variant.selling_plan_allocations[ 0 ].selling_plan_id;
                            }
                            break;
                        }
                    }
                    Done( );
                }
                else if ( retries++ > 3 )
                {
                    Done( );
                }
                else
                {
                    // wtf !?
                    setTimeout( TryNow, 500 );
                }
            } );
        }
        TryNow( );
    }
}


function SetupProductCardForPseudoAutoship( productCard, qty )
{
    var autoshipBtn       = productCard.querySelector('.autoship-add-to-cart');
    var vid               = productCard._productData.attributes.to_cart_variant_id[ 0 ];
    var cartItem          = document.querySelector( `.cart-drawer__content .cart-drawer-items-container .we_cart_item[data-variant-id="${vid}"]` );
    var requestInProgress = false;

    if ( ( cartItem ) && ( cartItem.getAttribute( "data-selling-plan-id" ) ) )
    {
        autoshipBtn.classList.add( 'hidden' );
        
        var qtyElement = autoshipBtn.parentNode.querySelector( ".pdp-autoship-qty" );
        if ( qtyElement )
        {
            qtyElement.classList.remove( "hidden" );
            qtyElement.querySelector( ".pdp-autoship-qty-count" ).innerText = AutoshipQtyString( qty );
        }
        
        
        const qtyText   = qtyElement.querySelector('.pdp-autoship-qty-count');
        const minusBtn  = qtyElement.querySelector('.pdp-autoship-minus');
        const plusBtn   = qtyElement.querySelector('.pdp-autoship-plus');

        var queuedQuantity = qty;

        function sync( updatedQty )
        {
            var key      = cartItem.getAttribute( "data-line-item-id" );
            var update   = { "updates" : { }, "sections" : "cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template" };

            update.updates[ key ] = updatedQty;

            var param =
            {
                "method"  : "POST",
                "headers" : { "Content-Type" : "application/json" },
                "body"    : JSON.stringify( update )
            };

            fetch( window.Shopify.routes.root + 'cart/update.js', param ).then( function( response )
            {
                response.json( ).then( function( result )
                {
                    requestInProgress   = false;
                    var newestRequest   = getNewestRequest( "line", key );
                    qty                 = updatedQty;

                    if ( newestRequest == null || newestRequest.quantity == qty )
                    {
                        if ( qty == 0 )
                        {
                            qtyElement.classList.add( "hidden" );
                            autoshipBtn.classList.remove( 'hidden' );
                            autoshipBtn.querySelector( "img" )?.classList.remove( "autoship-icon--rotating" );
                        }

                        updateCartDrawer( result );
                    }
                    else
                    {
                        sync( newestRequest.quantity );
                    }

                } ).catch ( function( error )
                {
                    console.log( "json error", error );
                } );

            } ).catch( function( error )
            {
                console.log( "fetch error", error );
            } );
        }

        minusBtn.addEventListener( 'click', function( )
        {
            qtyText.textContent = `${AutoshipQtyString( queuedQuantity - 1 )}`;
            if ( cartItem && cartItem.getAttribute( "data-line-item-id" ) )
            {
                window.autoshipQuantityUpdates.push( { line: cartItem.getAttribute( "data-line-item-id" ), quantity: queuedQuantity - 1 } );
                queuedQuantity --;
            }
            if ( !requestInProgress )
            {
                requestInProgress = true;
                sync( qty - 1 );
            }
        } );

        plusBtn.addEventListener( 'click', function( )
        {
            qtyText.textContent = `${AutoshipQtyString( queuedQuantity + 1 )}`;
            if ( cartItem && cartItem.getAttribute( "data-line-item-id" ) )
            {
                window.autoshipQuantityUpdates.push( { line: cartItem.getAttribute( "data-line-item-id" ), quantity: queuedQuantity + 1 } );
                queuedQuantity ++;
            }
            if ( !requestInProgress )
            {
                requestInProgress = true;
                sync( qty + 1 );
            }
        } );
    }
}

function fetchVariantSellingPlan(variantId, cb) 
{
  try 
  {
    var handle = window.Shopify?.current_product?.handle;
    var url = handle ? `/products/${handle}.js`
                     : (window.location.pathname.replace(/\/$/, '') + '.js');

    FetchJSONDataFromURL(url, function (err, data) 
    {
      if (err || !data || !data.variants) return cb();
      var v = data.variants.find(function(x){ return String(x.id) === String(variantId); });
      var spid = v?.selling_plan_allocations?.[0]?.selling_plan_id;
      cb(spid);
    });
  } catch (e) 
  {
    cb();
  }
}


function HandleAutoshipAddAsSubscription(button) 
{
  const iconImg = button.querySelector && button.querySelector('img');
  function stopSpin(){ if (iconImg) iconImg.classList.remove('autoship-icon--rotating'); }
  const productCard = button.closest && button.closest('.product-grid__product-card');
  const isPLP = !!productCard;

  if (isPLP) 
  {
    const productData = JSON.parse(productCard?.dataset.productData || '{}');

    GetSellingPlan(productCard, productData, function (spid) 
    {
      if (!spid) { alert('Unable to add product'); stopSpin(); return; }

      const qpstr = `id=${productData.attributes.to_cart_variant_id[0]}&quantity=1&selling_plan=${spid}`;

      rcpAddToCart(qpstr, function () 
      {
        toggleATCButton(button);
        const price      = parseFloat(productData.attributes?.price);
        const compareAt  = parseFloat(productData.attributes?.price_old);
        const autoshipP  = (price * 0.95).toFixed(2);


        renderAutoshipATCPopup( productData );
        /*
        showAutoshipModal({
          product: 
          {
            id: productData.attributes?.to_cart_product_id,
            title: productData.attributes?.title,
            vendor: productData.attributes?.brand,
            featured_image: productData.attributes?.image_link,
            image: productData.attributes?.image_link
          },
          variant: 
          {
            id: productData.attributes?.to_cart_variant_id,
            price: price,
            compare_at_price: compareAt,
            autoship_price: autoshipP
          },
          rechargeData: null,
          mode: 'selling_plan'
        });
        */
        
        stopSpin();
      });
    });

} else {
  const product = window.Shopify.current_product;
  const variant = getSelectedVariant();
  if (!product || !variant) { stopSpin(); return; }

  function afterAdd() {
    const price     = parseFloat((variant.price ?? 0) / 100 || variant.price || 0);
    const compareAt = parseFloat((variant.compare_at_price ?? 0) / 100 || 0);
    const autoshipP = (price * 0.95).toFixed(2);
    renderAutoshipATCPopup( product, variant );
    setupPdpAutoshipQuantityPseudo(variant.id, button);
    stopSpin();
  }

  // Try inline selling plan first, then fetch if missing
  var inlineSpid = variant?.selling_plan_allocations?.[0]?.selling_plan_id;
  function addWith(spid){
    if (!spid) { alert('Autoship not available for this variant.'); stopSpin(); return; }
    var qp = `id=${variant.id}&quantity=1&selling_plan=${spid}`;
    rcpAddToCart(qp, afterAdd);
  }

  if (inlineSpid) {
    addWith(inlineSpid);
  } else {
    fetchVariantSellingPlan(variant.id, addWith);
  }
}

}



function handleAutoshipAdd(button) 
{
  const iconImg      = button.querySelector('svg');
  const productId    = button.dataset.productId;
  const variantId    = button.dataset.variantId;
  const productTitle = button.dataset.productTitle;
  const productVendor= button.dataset.productVendor;
  const productImage = button.dataset.productImage;
  const productPrice = button.dataset.productPrice;

  if (iconImg) iconImg.classList.add('is-rotating');

  function stopSpin() { if (iconImg) iconImg.classList.remove('is-rotating'); }
  function fallbackAdd() 
  {
    HandleAutoshipAddAsSubscription(button);
    button.disabled = false;
    stopSpin();
  }

  FetchNextAutoshipOrder(function (err, rechargeData) 
  {
    if (err || !rechargeData) return fallbackAdd();

    const info = getNextRechargeSub(rechargeData);
    if (!info || !info.aid || !info.ncs || !info.freq || !info.freqUnit) return fallbackAdd();
    ReallyCreateNewSubscription(info.aid, info.ncs, info.freq, info.freqUnit, 1, productId, variantId, function( err2, updatedData ) 
    {
        if (err2) { console.error('Create subscription error:', err2); return fallbackAdd(); }

        window._autoshipData = updatedData;


        const fresh = getRechargeLineInfo(updatedData, productId, variantId);

        const productCard = button.closest('.product-grid__product-card');
        const pd = productCard ? JSON.parse(productCard.dataset.productData || '{}') : {};
        const price = parseFloat(pd.attributes?.price || productPrice || 0);
        const compareAt = parseFloat(pd.attributes?.price_old || button.dataset.compareAtPrice || 0);
        
        showAutoshipModal({
          product: 
          {
            id: productId,
            title: pd.attributes?.title || productTitle,
            vendor: pd.attributes?.brand || productVendor,
            featured_image: pd.attributes?.image_link || productImage,
            image: pd.attributes?.image_link || productImage
          },
          variant: 
          {
            id: variantId,
            price: price,
            compare_at_price: compareAt,
            autoship_price: (price * 0.95).toFixed(2)
          },
          rechargeData: updatedData
        });
        
        stopSpin();

        setupCollectionAutoshipQuantity( productCard.querySelector( ".pdp-autoship-qty" ), fresh.sid, button );

        FetchNewAutoShipProducts( updatedData );
    });
  });
}
 

function handleize( string )
{
    return string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
}

function UpdateCollectionFacets( facets )
{
    var filterInputs = document.querySelectorAll( ".header__facets-search__filter input" );
    filterInputs.forEach( function( input )
    {
        var valueFound = false;
        facets.forEach( function( facet )
        {
            if( input.dataset.filterParent == facet.name )
            {
                values.forEach( function( value )
                {
                    if( input.value == value.value )
                    {
                        input.parentElement.querySelector( "div[data-filter]" ).innerHTML = `${value.value} (${value.hits_count})`;
                        input.removeAttribute( "disabled" );
                        valueFound = true;
                    }
                });
            }
        });
        if( valueFound == false )
        {
            input.parentElement.querySelector( "div[data-filter]" ).innerHTML = input.parentElement.querySelector( "div[data-filter]" ).innerHTML.split("(")[ 0 ] + " (0)";
            input.setAttribute( "disabled", "" );
        }
    });
}

function CreateCollectionFacets(facets)
{
    var facetsContainer = document.querySelector(".header__facets-search__filters");
    var facetTemplate   = facetsContainer.querySelector(".header__facets-search__filter-template");
    var brandsContainer = facetsContainer.querySelector(".header__facets-search__filter[data-facet-title='Brands']");
    var mobileBrands    = document.querySelector(".mobile-filter-options[data-group='brands']");

    facets.forEach(function(facet)
    {
        if (facet.name == "brand")
        {
            var values = facet.values;
            var copy;

            // desktop
            if (brandsContainer)
            {
                copy = brandsContainer;
            }
            else
            {
                copy = facetTemplate.cloneNode(true);
                var copyTitle = copy.querySelector(".header__facets-search__filter-title");
                copyTitle.textContent = facet.name;
            }

            var dropdown      = copy.querySelector(".filter__dropdown");
            var valueTemplate = dropdown.querySelector(".filter__value-template");

            copy.classList.add("header__facets-search__filter");
            copy.classList.remove("header__facets-search__filter-template");

            values.forEach(function(value)
            {
                // desktop option
                var valueCopy = valueTemplate.cloneNode(true);
                var input     = valueCopy.querySelector("input");
                var label     = valueCopy.querySelector("div[data-filter]");

                valueCopy.classList.add("filter__value");
                valueCopy.classList.remove("filter__value-template");
                input.setAttribute("filter-parent", facet.name);
                input.value = value.value;
                label.dataset.filter = value.value;
                label.innerHTML = value.value + " (" + value.hits_count + ")";
                valueCopy.classList.remove("hidden");
                dropdown.appendChild(valueCopy);

                // mobile option
                if (mobileBrands)
                {
                    var mobileLabel = document.createElement("label");
                    mobileLabel.classList.add("mobile-filter-option");

                    var mInput = document.createElement("input");
                    mInput.type  = "checkbox";
                    mInput.name  = "brands";
                    mInput.value = value.value;

                    var mSpan = document.createElement("span");
                    mSpan.textContent = value.value + " (" + value.hits_count + ")";

                    mobileLabel.appendChild(mInput);
                    mobileLabel.appendChild(mSpan);
                    mobileBrands.appendChild(mobileLabel);
                }
            });

            copy.classList.remove("hidden");
            facetsContainer.appendChild(copy);
        }
        else
        {
            var valueTexts = facetsContainer.querySelectorAll(".filter__value div[data-filter]");
            valueTexts.forEach(function(valueText)
            {
                facet.values.forEach(function(value)
                {
                    if (valueText.dataset.filter == value.value)
                    {
                        valueText.textContent = value.value + " (" + value.hits_count + ")";
                        if (value.hits_count > 0)
                        {
                            valueText.parentElement.classList.remove("hidden");
                        }
                        else
                        {
                            valueText.parentElement.classList.add("hidden");
                        }
                    }
                });
            });
        }
    });

    HandleFacetsEvents(facetsContainer);

    document.addEventListener("click", function(event)
    {
        var openDropdownContainers = document.querySelectorAll(".collection-template-v2__header .dropdown--container.open");
        openDropdownContainers.forEach(function(container)
        {
            var filterDropdown = container.querySelector(".filter__dropdown");
            var sortDropdown   = container.querySelector(".sort__dropdown");
            if (
                !container.contains(event.target) &&
                (!filterDropdown || !filterDropdown.contains(event.target)) &&
                (!sortDropdown || !sortDropdown.contains(event.target))
            )
            {
                container.classList.remove("open");
            }
        });
    });
}


function ToggleDropDown( e )
{
    var dropdownContainers   = document.querySelectorAll( ".header__facets-search .dropdown--container, .mobile-filters-wrapper .dropdown--container" );
    dropdownContainers.forEach( function( container )
    {
        if( container.querySelector( ".header__facets-search__dropdown--trigger" ) != e.currentTarget || container.classList.contains( "open" ) )
        {
            container.classList.remove("open");
        }
        else
        {
            container.classList.add("open");
        }
    });
}

function InitliaseFacetInputs()
{
    var params = CreateSearchParamsArray(window.location.search);
    var facetsContainer = document.querySelector(".header__facets-search");
    var mobileFacetsContainer = document.querySelector(".mobile-filters-wrapper");

    if (facetsContainer)
    {
        params.forEach(function(value, key)
        {
            if (key == "sort_by")
            {
                var sortInput = facetsContainer.querySelector(".sort__value:has( div[data-sort='" + value + "'] ) input");
                var mobileInput = mobileFacetsContainer.querySelector(".sort__value:has( div[data-sort='" + value + "'] ) input");
                if (sortInput)
                {
                    sortInput.checked = true;
                }
                if (mobileInput)
                {
                    mobileInput.checked = true;
                }
            }
            else
            {
                var filterInput = facetsContainer.querySelector(".filter__value:has( div[data-filter='" + value.replace("+", " ") + "'] ) input");
                var mobileValue = value.replace("+", " ");
                var safeVal = escapeForAttr(mobileValue);
                var mobileInput = mobileFacetsContainer.querySelector(".mobile-filter-option input[value=\"" + safeVal + "\"]");
                if (filterInput)
                {
                    filterInput.checked = true;
                }
                if (mobileInput)
                {
                    mobileInput.checked = true;
                }
            }
        });
    }
}

function HandleFacetUpdate()
{
    var params = CreateSearchParamsArray(window.location.search);
    var sortQuery = "";
    var filterQuery = "";
    params.forEach( function( value, key )
    {
        if( key.includes( "filter" ) && key.includes ( ".and" ) )
        {
            filterQuery += "&f_must[]=" + key.split(".").slice(-1) + ":" + value.replaceAll( " ", "+" ).replaceAll( "&", "%26" );  
        }
        else if( key.includes( "filter" ) && key.includes ( ".or" ) )
        {
            filterQuery += "&f[]=" + key.split(".").slice(-1) + ":" + value.replaceAll( " ", "+" ).replaceAll( "&", "%26" );  
        }
        else if( key.includes( "sort_by" ) )
        {
            sortQuery = "&sort=availability:desc," + value.replace( "+", " " );
        }
    });
    if( _rcp_template.template == "collection" )
    {
        if( _rcp_template.collectionHandle == "all" )
        {
            var query = "&f[]=type:product&plp=category" + filterQuery + sortQuery + "&facets=brand,tags"
            + "&hit_fields=to_cart_product_id,to_cart_variant_id,handle,sku_list,sku,to_cart_variant_id,title,image_link_l,brand,availability,price,price_amount,price_old,category,tags,image_link"
            + "&remove_fields=nested"
        }
        else
        {
            var query = "&f[]=type:product&plp=category&f[]=category:" + encodeURIComponent( _rcp_template.collectionTitle ) + filterQuery + sortQuery + "&facets=brand,tags"
            + "&hit_fields=to_cart_product_id,to_cart_variant_id,handle,sku_list,sku,to_cart_variant_id,title,image_link_l,brand,availability,price,price_amount,price_old,category,tags,image_link"
            + "&remove_fields=nested"
        }
        currentPage = GetPageFromUrlParam();
        GetLuigiBoxCollectionProducts(
            currentPage,
            50,
            function(results) {
                // UpdateCollectionFacets( results.facets );
            },
            function(error) {
            },
            query,
             _rcp_template.collectionTitle
        );
    }
    else if( _rcp_template.template == "search" )
    {
        var URLParams = CreateSearchParamsArray( window.location.search );
        var query = URLParams.get( "q" );
        if( query && query.length > 0 )
        {
            currentPage = GetPageFromUrlParam();
            GetLuigiBoxCollectionProducts(
                currentPage,
                50,
                function(results) {
                    // UpdateCollectionFacets( results.facets );
                },
                function(error) {
                },
                "&f[]=type:product&q=" + encodeURIComponent( query ) + filterQuery + sortQuery + "&facets=brand,tags"
                + "&hit_fields=to_cart_product_id,to_cart_variant_id,handle,sku_list,sku,to_cart_variant_id,title,image_link_l,brand,availability,price,price_amount,price_old,category,tags,image_link"
                + "&remove_fields=nested",
                _rcp_template.collectionTitle
            );
        }
    }
}

function HandleFacetChangeEvent( e, facetsContainer, sortPrev )
{
    currentPage = 1;
    var selectedFilters = {};
    var sortParams      = "";
    var filterParams    = "";
    var params = CreateSearchParamsArray(window.location.search);
    var searchQuery = params.get("q");

    var filters = facetsContainer.querySelectorAll( ".filter__value" );
    filters.forEach( function( filter )
    {
        var input = filter.querySelector( "input" );
        var inputGroup = input.getAttribute( "filter-parent" );
        var inputOperator = input.getAttribute( "filter-operator" );
        if( inputOperator == "and" )
        {
            var inputValue = input.value + ":and";
        }
        else if( inputOperator == "or" )
        {
            var inputValue = input.value + ":or";
        }
        
        if( input.checked )
        {
            if( selectedFilters[ inputGroup ] != undefined )
            {
                selectedFilters[ inputGroup ] = selectedFilters[ inputGroup ] + "," + inputValue;
            }
            else
            {
                selectedFilters[ inputGroup ] = inputValue;
            }
        }
    });
    for( key in selectedFilters )
    {
        var filterValues = selectedFilters[key].split( "," );
        filterValues.forEach( function( filterValue )
        {
            if( filterValue.includes( ":or" ) )
            {
                filterParams += `&filter.or.${key}=${filterValue.replaceAll( " ", "+" ).replace( ":or", "" ).replaceAll( "&", "%26" )}` 
            }
            else if(  filterValue.includes( ":and" ) )
            {
                filterParams += `&filter.and.${key}=${filterValue.replaceAll( " ", "+" ).replace( ":and", "" ).replaceAll( "&", "%26" )}` 
            }
        });
    }

    var sortingCheckContainer = document.querySelector( ".collection-template-v2__header .header__facets-search__sort" );
    sortPrev = document.querySelector( ".collection-template-v2__header .header__facets-search__sort" ).dataset.selected;
    var sortCurr = document.querySelector( ".header__facets-search__dropdown--list.sort__dropdown .sort__value:has(input:checked) [data-sort]" ).dataset.sort;
    if( sortCurr )
    {
        sortParams = "sort_by=" + sortCurr;
    }
    if ( sortPrev != sortCurr )
    {
        sortPrev = sortCurr;
        var sortString = document.querySelector( ".header__facets-search__dropdown--list.sort__dropdown .sort__value:has(input:checked) [data-sort]" ).innerHTML;
        document.querySelector( ".collection-template-v2__header .sort__selected-value" ).innerHTML = sortString;
        sortingCheckContainer.dataset.selected = sortCurr;
    }

    if( searchQuery && searchQuery.length )
    {
        window.history.pushState( "", "", window.location.pathname + "?q=" + searchQuery + "&" + sortParams + filterParams );
    }
    else
    {
        window.history.pushState( "", "", window.location.pathname + "?" + sortParams + filterParams );
    }
    window.dispatchEvent(new PopStateEvent("popstate"));
}

function HandleFacetsEvents( facetsContainer )
{
    var sortPrev    = null;
    var dropdowns   = document.querySelectorAll( ".header__facets-search__dropdown--trigger" );
    var inputs      = facetsContainer.querySelectorAll( ".filter__value input" );
    var sortInputs  = document.querySelectorAll( ".collection-template-v2__header [name='sort-by']" );

    dropdowns.forEach( function( dropdown )
    {
        dropdown.addEventListener( "click", function( e )
        {
            ToggleDropDown( e );
        });
    });

    inputs.forEach( function( input )
    {
        input.addEventListener( "change", function( e )
        {
            HandleFacetChangeEvent( e, facetsContainer, sortPrev );
        } );
    });

    sortInputs.forEach( function( input )
    {
        input.addEventListener( "change", function( e )
        {
            HandleFacetChangeEvent( e, facetsContainer, sortPrev );
        });
    });
}

function SearchTracking( data, collectionTitle, searchTerm )
{
    var params = CreateSearchParamsArray(window.location.search);
    var trackingFilters = {};
    params.forEach( function( value, key )
    {
        if( key.includes( "filter" ) )
        {
            var filterKey = key.split( "." ).slice( -1 );
            if( trackingFilters[ filterKey ] )
            {
                trackingFilters[ filterKey ] = trackingFilters[ filterKey ] + "," + value;
            }
            else
            {
                trackingFilters[ filterKey ] = value;
            }
        }
    });
    if( collectionTitle != "" )
    {
        var searchTrackingData = {
            event: "view_item_list",
            ecommerce: {
                item_list_name: "Product Listing",
                items: []
            },
            scopes: {
                CategoryLabel: collectionTitle
            },
            filters: trackingFilters
        };
    }
    else
    {
        var searchTrackingData = {
            event: "view_item_list",
            ecommerce: {
                item_list_name: "Search Results",
                search_term: searchTerm,
                items: []
            },
            filters: trackingFilters
        };
    }
    if( data.results && data.results.hits )
    {
        data.results.hits.forEach( function( hit, index )
        {
            var hit_brand = "";
            if( hit.attributes.brand && hit.attributes.brand.length > 0 )
            {
                hit_brand = hit.attributes.brand;
            }
            searchTrackingData.ecommerce.items.push({
                item_id: hit.url,
                item_name: hit.attributes.title.replace(/<[^>]*>/g, ""), 
                item_brand: hit_brand,
                price: hit.attributes.price_amount,
                index: index,
                type: hit.type
            });
        });
    }
    window.luigiDataLayer.push(searchTrackingData);
}

function GetLuigiBoxCollectionProducts(page, perPage, callback, errorCallback, query, collectionTitle, searchTerm)
{
    currentQuery = query;
    var xhr = new XMLHttpRequest();
    xhr.open("GET", `https://live.luigisbox.tech/search?tracker_id=${publicKey}&size=${perPage}&page=${page}${query}`, true);
    xhr.setRequestHeader("Content-Type", "application/json");

    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
        if (xhr.status >= 200 && xhr.status < 300) 
        {
            var data = JSON.parse(xhr.responseText);
            totalPages = Math.ceil(data.results.total_hits / perPage);
            
            // Render pagination
            renderPagination();
            //sort out of stock products to end of current pagination
            data.results.hits.sort( ( a, b ) => b.attributes.availability - a.attributes.availability );
            renderLuigiProductCards(data);
            var resultsCount = document.querySelector(".header__collection-title__items__count");
            if (resultsCount) resultsCount.textContent = data.results.total_hits + " items";
                renderSelectedFilterTags();
                var applyBtn = document.querySelector(".mobile-filters-apply");
                if (applyBtn) 
                {
                applyBtn.textContent = `Show ${data.results.total_hits} items`;
                }

                if (callback) callback(data.results);

                SearchTracking( data, collectionTitle, searchTerm );
            } else {
                if (errorCallback) errorCallback("LuigiBox API error: " + xhr.status);
            }
        }
    };

    xhr.send();
}

function RenderAutocompleteResults( results, searchValue, type )
{
    var autocompleteModal = document.querySelector( ".autocomplete-wrapper" );
    if( autocompleteModal )
    {
        var trendingContainers    = autocompleteModal.querySelectorAll( ".autocomplete-trending-suggestions" );
        var viewAllLink           = autocompleteModal.querySelector( ".autocomplete-results-link" );
        var productsContainer     = autocompleteModal.querySelector( ".autocomplete-results-content" );
        var productTemplate       = productsContainer.querySelector( ".autocomplete-product-card-template" );
        var suggestedContainer    = autocompleteModal.querySelector( ".autocomplete-popular-suggestions .autocomplete-aside-row-wrapper" );
        var collectionsContainers = autocompleteModal.querySelectorAll( ".autocomplete-collections .autocomplete-aside-row-wrapper" );
        var brandsContainers      = autocompleteModal.querySelectorAll( ".autocomplete-brands .autocomplete-aside-row-wrapper" );
        var searchInputs = document.querySelectorAll( ".search-bar form.search-form input[type='search']" );
        var brandsArray           = [];
        var fixitCheck = false;
        autocompleteModal.querySelector( ".autocomplete-popular-suggestions" ).classList.add( "hidden" );

        while( productsContainer.querySelector( ".autocomplete-product-card" ) )
        {
            productsContainer.querySelector( ".autocomplete-product-card" ).remove();
        }
        collectionsContainers.forEach( function( container )
        {
            while( container.querySelector( ".autocomplete-aside-row" ) )
            {
                container.querySelector( ".autocomplete-aside-row" ).remove();
            }
        });
        brandsContainers.forEach( function( container )
        {
            while( container.querySelector( ".autocomplete-aside-row" ) )
            {
                container.querySelector( ".autocomplete-aside-row" ).remove();
            }
        });
        while( suggestedContainer.querySelector( ".autocomplete-aside-row" ) )
        {
            suggestedContainer.querySelector( ".autocomplete-aside-row" ).remove();
        }

        if( searchValue && searchValue.length > 0 )
        {
            viewAllLink.setAttribute( "href", "/search?q=" + encodeURIComponent( searchValue ) );
        }

        results.forEach( function( result )
        {
            if( result.type == "query" && type == "top" )
            {
                if( viewAllLink.getAttribute( "href" ).length <= 0 )
                {
                    viewAllLink.setAttribute( "href", "/search?q=" + encodeURIComponent( result.attributes.title ) );
                }
                trendingContainers.forEach( function( container )
                {
                    if( !container.querySelector( ".autocomplete-trending-suggestions-label[search-value='" + result.attributes.title + "']" ) )
                    {
                        var a = document.createElement( "a" );
                        a.classList.add( "autocomplete-trending-suggestions-label" );
                        a.setAttribute( "search-value", result.attributes.title );
                        a.innerHTML = result.attributes.title;
                        if( result.attributes.fixit_redirect_url )
                        {
                            a.setAttribute( "href", result.attributes.fixit_redirect_url[ 0 ] );
                        }
                        else
                        {
                            a.setAttribute( "href", "/search?q=" + encodeURIComponent( result.url ) );
                        }
                        container.appendChild( a );
                    }
                });
            }
            else if( result.type == "query" && type == "search" )
            {
                if( result.match && result.match.toLowerCase().trim() == searchValue.toLowerCase().trim() && result.attributes.fixit_redirect_url )
                {
                    searchInputs.forEach( function( input )
                    {
                        if( fixitCheck == false )
                        {
                            input.setAttribute( "fixit-redirect-url", result.attributes.fixit_redirect_url );
                            fixitCheck = true;
                        }
                    });
                }
                var copy = suggestedContainer.querySelector( ".autocomplete-aside-row-template" ).cloneNode( true );
                copy.classList.replace( "autocomplete-aside-row-template", "autocomplete-aside-row" );
                if( result.attributes.fixit_redirect_url )
                {
                    copy.setAttribute( "href", result.attributes.fixit_redirect_url[ 0 ] );
                }
                else
                {
                    copy.setAttribute( "href", "/search?q=" + encodeURIComponent( result.url ) );
                }
                copy.querySelector( ".autocomplete-aside-value" ).innerHTML = result.attributes.title;
                suggestedContainer.appendChild( copy );
                suggestedContainer.closest( ".autocomplete-popular-suggestions" ).classList.remove( "hidden" );
            }
            else if( result.type == "product" || result.type == "variant" )
            {
                if (result.attributes.title && (result.attributes.title.toLowerCase().includes("membership") || result.attributes.title.toLowerCase().includes("annual") || result.attributes.title.toLowerCase().includes("monthly"))) 
                {
                    return;
                }
                if( result.attributes.brand && brandsArray.includes( result.attributes.brand[ 0 ] ) == false )
                {
                    brandsArray.push( result.attributes.brand[ 0 ] );
                }
                if( 
                    result.attributes.image_link_s
                    && result.attributes.title
                    && result.attributes.price_gbp
                )
                {
                    var copy = productTemplate.cloneNode( true );

                    copy.querySelector( "a" ).setAttribute( "href", result.url );
                    var _a = copy.querySelector("a");
                    if (result.attributes && result.attributes.sku) 
                    {
                        _a.setAttribute("data-luigi-sku", result.attributes.sku);
                    } else if (result.attributes && result.attributes.to_cart_variant_id) 
                    {
                        _a.setAttribute("data-luigi-sku", String(result.attributes.to_cart_variant_id));
                    }
                    if( Array.isArray( result.attributes.image_link_s ) )
                    {
                        copy.querySelector( ".autocomplete-product-card-image img" ).setAttribute( "src", result.attributes.image_link_s[ 0 ].replace("_100x", "_200x") + "&width=100" );
                    }
                    else
                    {
                        copy.querySelector( ".autocomplete-product-card-image img" ).setAttribute( "src", result.attributes.image_link_s.replace("_100x", "_200x") + "&width=100" );
                    }
                    copy.querySelector( ".autocomplete-product-title" ).innerHTML = result.attributes.title;
                    if (result.attributes.discount_price_gbp_percentage_amount) 
                    {
                    var raw = Number(result.attributes.discount_price_gbp_percentage_amount);
                    if (!isNaN(raw) && isFinite(raw)) 
                    {
                        var discountPercent = Math.round(raw);
                        copy.querySelector(".autocomplete-product-discount").innerHTML = "-" + discountPercent + "%";
                    }
                    }
                    copy.querySelector( ".autocomplete-product-current-price" ).innerHTML = formatter.format(parseFloat(result.attributes.price_gbp));
                    if( result.attributes.price_old )
                    {
                        copy.querySelector( ".autocomplete-product-old-price" ).innerHTML = formatter.format(parseFloat(result.attributes.price_old));
                    }

                    copy.classList.replace( "autocomplete-product-card-template", "autocomplete-product-card" );

                    productsContainer.appendChild( copy );
                }
            }
            else if( result.type == "category" )
            {
                collectionsContainers.forEach( function( container )
                {
                    var collectionsTemplate = container.querySelector( ".autocomplete-aside-row-template" );
                    var copy = collectionsTemplate.cloneNode( true );

                    copy.setAttribute( "href", result.url );
                    copy.querySelector( ".autocomplete-aside-value" ).innerHTML = result.attributes.title;

                    var breadcrumbs = "";
                    if( result.attributes.ancestors && result.attributes.ancestors.length > 0 )
                    {
                        result.attributes.ancestors.forEach( function( ancestor )
                        {
                            if( breadcrumbs.length > 0 )
                            {
                                breadcrumbs += " / " + ancestor.title;
                            }
                            else
                            {
                                breadcrumbs = ancestor.title;
                            }
                        });
                    }
                    copy.querySelector( ".autocomplete-aside-info" ).innerHTML = breadcrumbs;

                    copy.classList.replace( "autocomplete-aside-row-template", "autocomplete-aside-row" );

                    container.appendChild( copy );
                });
            }
            if( fixitCheck == false )
            {
                searchInputs.forEach( function( input )
                {
                    if( input.hasAttribute( "fixit-redirect-url" ) )
                    {
                        input.removeAttribute( "fixit-redirect-url" );
                    }
                });
            }
        });
        brandsArray.forEach( function( brand, idx )
        {
            if( idx < 4 )
            {
                brandsContainers.forEach( function( container )
                {
                    var copy = container.querySelector( ".autocomplete-aside-row-template" ).cloneNode( true );
                    copy.classList.replace( "autocomplete-aside-row-template", "autocomplete-aside-row" );
                    copy.setAttribute( "href", "/search?q=" + brand );
                    copy.querySelector( ".autocomplete-aside-value" ).innerHTML = brand;
                    container.appendChild( copy );
                });
            }
        });
    }
}


function AutocompleteProductClickTracking(sku) 
{
    if (!sku) { return; }

    var autocompleteTrackingData = 
    {
        event: "select_item",
        ecommerce: {
            item_list_name: "Autocomplete",
            items: 
            [
                { item_id: sku }
            ]
        }
    };

    if (!window.luigiDataLayer) { window.luigiDataLayer = []; }
    window.luigiDataLayer.push(autocompleteTrackingData);
}

document.addEventListener("click", function(e) 
{
    var a = e.target.closest(".autocomplete-product-card a");
    if (!a) { return; }

    var sku = a.getAttribute("data-luigi-sku");
    if (sku) 
    {
        AutocompleteProductClickTracking(sku);
    }
});
 

function TrackSearchATC(btn)
{
    try
    {
        var card = btn.closest(".product-grid__product-card");
        if (!card) return;

        var pd;
        try { pd = card._productData || JSON.parse(card.dataset.productData || "{}"); }
        catch(_) { pd = {}; }

        var att = (pd && pd.attributes) ? pd.attributes : {};

        function firstOrStr(v)
        {
            if (Array.isArray(v)) return String(v[0] || "");
            return v == null ? "" : String(v);
        }

        var itemUrl =
              firstOrStr(att.url) ||
              firstOrStr(pd.url) ||
              "";

        if (!itemUrl)
        {
            var a = card.querySelector("a[href*='/products/']");
            if (a && a.getAttribute("href")) itemUrl = a.getAttribute("href");
        }

        if (!itemUrl) return;
        var value = undefined;
        if (att.price_amount != null && att.price_amount !== "")
        {
            var n = Number(att.price_amount);
            if (!Number.isNaN(n)) value = n;
        }
        else if (att.price != null && att.price !== "")
        {
            var p = parseFloat(att.price);
            if (!Number.isNaN(p)) value = p;
        }

        var trackingData =
        {
            event: "add_to_cart",
            ecommerce:
            {
                currency: "GBP",
                value: value,
                items: [
                    { item_id: itemUrl }
                ]
            }
        };

        if (!window.luigiDataLayer) window.luigiDataLayer = [];
        window.luigiDataLayer.push(trackingData);
    }
    catch (e)
    {
        console.warn("Search ATC tracking failed:", e);
    }
}

document.addEventListener("click", function(e)
{
    var btn = e.target.closest(".product-card__buy-button");
    if (!btn) return;
    TrackSearchATC(btn);
});


function TrackResultSelect(card, context)
{
    try
    {
        if (!card) return;

        var pd;
        try { pd = card._productData || JSON.parse(card.dataset.productData || "{}"); }
        catch(_) { pd = {}; }

        var att = (pd && pd.attributes) ? pd.attributes : {};

        function firstOrStr(v)
        {
            if (Array.isArray(v)) return String(v[0] || "");
            return v == null ? "" : String(v);
        }

        var itemUrl =
              firstOrStr(att.url) ||
              firstOrStr(pd.url) ||
              "";

        if (!itemUrl)
        {
            var a = card.querySelector("a[href*='/products/']");
            if (a && a.getAttribute("href")) itemUrl = a.getAttribute("href");
        }

        if (!itemUrl) return;

        itemUrl = itemUrl.replace(/^https?:\/\/[^/]+/i, "").split("?")[0].split("#")[0];

        if (itemUrl.indexOf("/products/") === -1) return;

        var trackingData =
        {
            event: "select_item",
            ecommerce:
            {
                item_list_name: context,
                items: [
                    { item_id: itemUrl }
                ]
            }
        };

        if (!window.luigiDataLayer) window.luigiDataLayer = [];
        window.luigiDataLayer.push(trackingData);
    }
    catch (e)
    {
        console.warn("Result click tracking failed:", e);
    }
}

document.addEventListener("click", function(e)
{
    var link = e.target.closest(".product-grid__product-card a[href]");
    if (!link) return;
    if (e.target.closest(".product-card__buy-button, .cart-quantity, .quantity-input, [name='minus'], [name='plus']"))
    {
        return;
    }
    var href = link.getAttribute("href") || "";
    if (href.indexOf("/products/") === -1) return;

    var card = link.closest(".product-grid__product-card");
    if (!card) return;
    var isSearch =
        (location.pathname || "").toLowerCase().indexOf("/search") !== -1 ||
        document.body.classList.contains("template-search") ||
        document.querySelector(".search-results, #SearchResults, .instantsearch");

    var context = isSearch ? "search_results" : "plp_results";

    TrackResultSelect(card, context);
});


function AutocompleteTracking( data, searchValue )
{
    var autocompleteTrackingData = {
        event: "view_item_list",
        ecommerce: {
            item_list_name: "Autocomplete",
            search_term: searchValue,
            items: [
            ]
        }
    };
    if( data.hits )
    {
        data.hits.forEach( function( hit, index )
        {
            var hit_title = hit.attributes.title.replace(/<[^>]*>/g, "");
            if( hit.type == "product" || hit.type == "variant" )
            {
                var hit_brand = "";
                if( hit.attributes.brand && hit.attributes.brand.length > 0 )
                {
                    hit_brand = hit.attributes.brand;
                }
                autocompleteTrackingData.ecommerce.items.push({
                    item_id: hit.url,
                    item_name: hit_title, 
                    item_brand: hit_brand,
                    index: index,
                    type: hit.type
                });
            }
            else
            {
                autocompleteTrackingData.ecommerce.items.push({
                    item_id: hit.url,
                    item_name: hit_title, 
                    index: index,
                    type: hit.type
                });    
            }
        });
    }
    window.luigiDataLayer.push(autocompleteTrackingData);
}

function GetLuigiBoxAutocompleteTopResults(callback, errorCallback, query)
{
    var xhr = new XMLHttpRequest();
    xhr.open("GET", `https://live.luigisbox.tech/v1/top_items?tracker_id=${publicKey}${query}`, true);
    xhr.setRequestHeader("Content-Type", "application/json");

    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
        if (xhr.status >= 200 && xhr.status < 300) {
            var data = JSON.parse( xhr.responseText );
            if (callback) callback(data.hits);
            AutocompleteTracking(data, "");
        } else {
            if (errorCallback) errorCallback("LuigiBox API error: " + xhr.status);
        }
        }
    };

    xhr.send();
}

function GetLuigiBoxAutocompleteResults(callback, errorCallback, query, searchValue)
{
    var xhr = new XMLHttpRequest();
    xhr.open("GET", `https://live.luigisbox.tech/autocomplete/v2?tracker_id=${publicKey}${query}`, true);
    xhr.setRequestHeader("Content-Type", "application/json");

    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
        if (xhr.status >= 200 && xhr.status < 300) {
            var data = JSON.parse( xhr.responseText );
            if (callback) callback(data.hits);
            AutocompleteTracking(data, searchValue);
        } else {
            if (errorCallback) errorCallback("LuigiBox API error: " + xhr.status);
        }
        }
    };

    xhr.send();
}

function HandleSearchFormAutocomplete( searchInput )
{
    var query = searchInput.value;
    if( query.length > 0 )
    {
        GetLuigiBoxAutocompleteResults(
            function(results) {
                if( results )
                {
                    RenderAutocompleteResults( results, query, "search" );
                }
            },
            function(error) {
            },
            "&use_fixits=true&type=product:10,query:5,category:5"
            + "&hit_fields=title,to_cart_variant_id,sku,sku_list,fixit_redirect_url,brand,price_old,price_gbp,discount_price_gbp_percentage_amount,image_link_s,ancestors"
            + "&remove_fields=nested"
            + "&q=" + encodeURIComponent( query ),
            query
        );
    }
    else
    {
        GetLuigiBoxAutocompleteTopResults(
            function(results) {
                if( results )
                {
                    RenderAutocompleteResults( results, "", "top" );
                }
            },
            function(error) {
            },
            "&use_fixits=true&type=product:10,query:5,category:5"
            + "&hit_fields=title,to_cart_variant_id,sku,sku_list,fixit_redirect_url,brand,price_old,price_gbp,discount_price_gbp_percentage_amount,image_link_s,ancestors"
            + "&remove_fields=nested"
        );
    }
}

function SetupAutocompleteDebouncedInput() {
  function AutocompleteDebounce(func, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  }

  function HandleInput(event) {
    HandleSearchFormAutocomplete( event.target );
  }

  const SearchInputs = document.querySelectorAll( ".search-bar form.search-form input[type='search']" );

  SearchInputs.forEach( function( searchInput) {
    const AutocompleteDebouncedHandler = AutocompleteDebounce(HandleInput, 300);
    searchInput.addEventListener('input', AutocompleteDebouncedHandler);
  });
}

function HandleCloseSearchModal( e )
{
    var body = document.querySelector( "body" );
    var searchModal = document.querySelector( ".autocomplete-wrapper" );
    var searchInputs = document.querySelectorAll( "#open-search-bar" );

    if( searchModal.hasAttribute( "open" ) )
    {
        for( var i = 0; i < searchInputs.length; i++ )
        {
            if( searchInputs[ i ].classList.contains( "mobile-serach-input" ) )
            {
                if( e.target.classList.contains( "search-form__icon-clear" ) || e.target.closest( ".search-form__icon-clear" ) )
                {
                    e.target.closest( ".search-form-inner" ).querySelector( "input[type='search']" ).focus()
                    return;
                }
            }
            if( e.target == searchInputs[ i ] )
            {
                return;
            }
        }
        if( ( e.target.closest( ".autocomplete-wrapper" ) != null || e.target.closest( ".utils__item" ) != null ) && !e.target.querySelector( ".search-form__icon-back" ) )
        {
            return;
        }
        else
        {
            searchModal.removeAttribute( "open" );
            body.classList.remove( "search-bar-in-focus" );
            body.removeEventListener( "click", HandleCloseSearchModal );
        }
    }
}

function HandleSearchSubmit( e )
{
    e.preventDefault();
    var form = e.target;
    var input = form.querySelector( "input[type='search']" );
    if( input.hasAttribute( "fixit-redirect-url" ) )
    {
        window.location.href = input.getAttribute( "fixit-redirect-url" );
    }
    else
    {
        form.submit();
    }
}

function HandleOpenSearchModal( e )
{
    var searchInput = e.currentTarget;
    var searchModal = document.querySelector( ".autocomplete-wrapper" );
    var header = document.querySelector( "header.header-content" );
    var headerOffsetTop = header.getBoundingClientRect().top + header.clientHeight + 12;
    var stickyMobNav = document.querySelector( ".sticky-nav-mob" );

    if( searchModal.hasAttribute( "open" ) == false && searchModal.hasAttribute( "initial-load" ) == false )
    {
        HandleSearchFormAutocomplete( searchInput );
    }

    searchModal.style.maxHeight = `calc(100vh - ${headerOffsetTop}px)`;
    searchModal.style.top = header.clientHeight + 12 + "px";
    if( window.innerWidth < 967 && stickyMobNav )
    {
        searchModal.style.paddingBottom = stickyMobNav.clientHeight + 30 + "px";
    }
    else
    {
        searchModal.style.paddingBottom = "";
    }
    searchModal.setAttribute( "open", "" );
    if( searchModal.hasAttribute( "initial-load" ) == false )
    {
        searchModal.setAttribute( "initial-load", "" );
    }
    var body = document.querySelector( "body" );
    body.classList.add( "search-bar-in-focus" );
    body.addEventListener( "click", HandleCloseSearchModal );
}

function BlockIconDefaultClicks()
{
    var openIcons = document.querySelectorAll(".search-form__icon, .search-form__icon-clear");
    openIcons.forEach(function(btn)
    {
        btn.addEventListener("click", function(e)
        {
            e.preventDefault();
            e.stopPropagation();

            var input = btn.closest(".search-form-inner")?.querySelector("input[type='search']");
            if (!input) { return; }

            if (btn.classList.contains("search-form__icon-clear"))
            {
                input.value = "";
                input.dispatchEvent(new Event("input", { bubbles: true }));
                input.focus();
                return;
            }

            input.focus();
            HandleOpenSearchModal({ currentTarget: input });
        });
    });
}

function HandleSearchSubmit( e )
{
    e.preventDefault();
    var form  = e.target;
    var input = form.querySelector("input[type='search']");
    var q     = (input && input.value ? input.value : "").trim();

    if (q.length === 0)
    {
        if (input) 
        {
            input.focus();
            HandleOpenSearchModal({ currentTarget: input });
        }
        return;
    }

    if (input.hasAttribute("fixit-redirect-url"))
    {
        window.location.href = input.getAttribute("fixit-redirect-url");
    }
    else
    {
        form.submit();
    }
}

function InitialiseRCPInterface()
{
    var params = CreateSearchParamsArray(window.location.search);
    var sortQuery = "";
    var filterQuery = "";
    params.forEach( function( value, key )
    {
        if( key.includes( "filter" ) && key.includes ( ".and" ) )
        {
            filterQuery += "&f_must[]=" + key.split(".").slice(-1) + ":" + value.replaceAll( " ", "+" ).replaceAll( "&", "%26" );  
        }
        else if( key.includes( "filter" ) && key.includes ( ".or" ) )
        {
            filterQuery += "&f[]=" + key.split(".").slice(-1) + ":" + value.replaceAll( " ", "+" ).replaceAll( "&", "%26" );  
        }
        else if( key.includes( "sort_by" ) )
        {
            sortQuery = "&sort=availability:desc," + value.replace( "+", " " );
        }
    });
    if( _rcp_template.template == "collection" )
    {
        if( _rcp_template.collectionHandle == "all" )
        {
            var query = "&f[]=type:product&plp=category" + filterQuery + sortQuery + "&facets=brand,tags"
            + "&hit_fields=to_cart_product_id,to_cart_variant_id,handle,sku_list,sku,to_cart_variant_id,title,image_link_l,brand,availability,price,price_amount,price_old,category,tags,image_link"
            + "&remove_fields=nested"
        }
        else
        {
            var query = "&f[]=type:product&plp=category&f[]=category:" + encodeURIComponent( _rcp_template.collectionTitle ) + filterQuery + sortQuery + "&facets=brand,tags"
            + "&hit_fields=to_cart_product_id,to_cart_variant_id,handle,sku_list,sku,to_cart_variant_id,title,image_link_l,brand,availability,price,price_amount,price_old,category,tags,image_link"
            + "&remove_fields=nested"
        }
        currentPage = GetPageFromUrlParam();
        GetLuigiBoxCollectionProducts(
            currentPage,
            50,
            function(results) {
                CreateCollectionFacets( results.facets )
            },
            function(error) {
            },
            query,
            _rcp_template.collectionTitle
        );
    }
    else if( _rcp_template.template == "search" )
    {
        var URLParams = CreateSearchParamsArray( window.location.search );
        var query = URLParams.get( "q" );
        if( query && query.length > 0 )
        {
        currentPage = GetPageFromUrlParam();
        GetLuigiBoxCollectionProducts(
            currentPage,
            50,
                function(results) {
                    CreateCollectionFacets( results.facets )
                },
                function(error) {
                },
                "&f[]=type:product&q=" + encodeURIComponent( query ) + filterQuery + sortQuery + "&facets=brand,tags"
                + "&hit_fields=to_cart_product_id,to_cart_variant_id,handle,sku_list,sku,to_cart_variant_id,title,image_link_l,brand,availability,price,price_amount,price_old,category,tags,image_link"
                + "&remove_fields=nested",
                "",
                query
            );
        }
    }

    SetupAutocompleteDebouncedInput();

    var searchInputs = document.querySelectorAll( ".search-bar form.search-form input[type='search']" );
    searchInputs.forEach( function( input )
    {
        input.addEventListener( "focus", HandleOpenSearchModal );
    });
    BlockIconDefaultClicks();
    var searchClearButtons = document.querySelectorAll( ".search-form__icon-clear" );
    searchClearButtons.forEach( function( button )
    {
        button.addEventListener( "click", function( e )
        {
            var input = button.parentElement.querySelector( "input[type='search']" )
            input.value = "";
            input.dispatchEvent(new PopStateEvent("input"));
        });
    });
    var searchForms = document.querySelectorAll( ".search-bar form.search-form" );
    searchForms.forEach( function( form )
    {
        form.addEventListener( "submit", HandleSearchSubmit );
    });
}

// Attach Recharge API functions to window for global access (no ES module export)
window.SendAPIRequest = SendAPIRequest;
window.FetchNextAutoshipOrder = FetchNextAutoshipOrder;
window.ReallyModifySubscriptionQuantity = ReallyModifySubscriptionQuantity;
window.ReallyCreateNewSubscription = ReallyCreateNewSubscription;
window.ReallyModifyOnetimeQuantityCancel = ReallyModifyOnetimeQuantityCancel;
window.ReallyModifyOnetimeQuantity = ReallyModifyOnetimeQuantity;
window.GetLuigiBoxCollectionProducts = GetLuigiBoxCollectionProducts;
window.InitialiseRCPInterface = InitialiseRCPInterface;
window.appDomain = appDomain;
window.curStore = curStore;
window.customer = customer;
window.rcpURL = rcpURL;

//Luigi's Box
window.addEventListener("DOMContentLoaded", function () {
    InitialiseRCPInterface();
    if ( _rcp_template.template == "collection" || _rcp_template.template == "search" )
    {
        setupFacetsAndMobileFilters();
    }
    reorderMobileProductCardInfo();
    reorderDesktopBrandAboveTitle();
    InitliaseFacetInputs();
    InitPdpAutoshipLabel();
    initOtherProductCards( );
    
    var pdpBtn = document.getElementById('ProductSubmitButton-autoship');
    if (pdpBtn)
    {
        var cust = window._rcp_customer || {};
        var loggedIn = !!(cust.email && cust.id);
        
        if (loggedIn && !document.body.classList.contains('has-autoship'))
        {
            var isUpdating = false;
            var lastLabel = '';
            
            function forcePdpButtonUpdate()
            {
                if (isUpdating) return;
                
                if (document.body.classList.contains('has-autoship')) return;
                
                var mainPriceEl = document.querySelector('.product-main-price');
                var autoshipPriceEl = document.querySelector('.autoship-price');
                
                if (mainPriceEl && autoshipPriceEl)
                {
                    var mainPrice = parseFloat(mainPriceEl.textContent.replace(/[^0-9.]/g, ''));
                    var autoshipPrice = parseFloat(autoshipPriceEl.textContent.replace(/[^0-9.]/g, ''));
                    
                    if (!isNaN(mainPrice) && !isNaN(autoshipPrice) && mainPrice > 0)
                    {
                        var autoshipPercent = Math.round(((mainPrice - autoshipPrice) / mainPrice) * 100);
                        if (autoshipPercent > 0)
                        {
                            var isMyAisle = document.body.id === 'lightning-my-aisle' || document.querySelector('#lightning-my-aisle');
                            var fontSize = isMyAisle ? '12px' : '14px';
                            var label = 'Subscribe & Save ' + autoshipPercent + '%';
                            
                            if (lastLabel === label) return;
                            
                            var autoshipNameEl = pdpBtn.querySelector('.autoship-name');
                            
                            if (autoshipNameEl)
                            {
                                var currentText = autoshipNameEl.textContent.trim();
                                
                                if (currentText.includes('Autoship every') || currentText.includes('every 4 weeks') || 
                                    (currentText.includes('Subscribe & Save') && !currentText.includes('%')))
                                {
                                    isUpdating = true;
                                    autoshipNameEl.textContent = label;
                                    autoshipNameEl.style.fontSize = fontSize;
                                    autoshipNameEl.style.verticalAlign = 'middle';
                                    var strongTag = autoshipNameEl.querySelector('strong');
                                    if (strongTag)
                                    {
                                        autoshipNameEl.innerHTML = label;
                                    }
                                    lastLabel = label;
                                    setTimeout(function() { isUpdating = false; }, 100);
                                }
                                else if (currentText === label)
                                {
                                    lastLabel = label;
                                }
                            }
                            else
                            {
                                isUpdating = true;
                                var svgIcon = `
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="14" viewBox="0 0 22 14" fill="none">
                                        <path d="M20.938 3.88773C20.9263 3.88703 20.9507 3.8827 21.0044 3.95316C21.0533 4.01728 21.1018 4.11242 21.1479 4.22464C21.2395 4.44722 21.3024 4.69594 21.3286 4.80179C21.4313 5.21251 21.4383 5.55473 21.4312 5.78812V5.79007C21.4093 6.87764 21.1147 7.78731 20.8765 8.37308C20.7451 8.69572 20.5918 9.01084 20.4136 9.31937L20.2271 9.62503C18.1692 12.8252 14.2197 14.1985 10.5767 13.0225L10.2251 12.9004C9.94338 12.797 9.66997 12.6793 9.40869 12.545L9.40674 12.544C9.01046 12.3444 8.71 12.1893 8.47803 12.0459C8.24712 11.9032 8.09569 11.7793 7.99072 11.6465H7.98975C7.96867 11.6188 7.88628 11.5082 7.74561 11.4825V11.4815L7.73486 11.4805H7.64893C7.56814 11.492 7.50249 11.5337 7.45361 11.5782C7.39314 11.6332 7.34065 11.7088 7.29346 11.7813C7.19133 11.9381 7.08437 12.1303 6.90479 12.375C6.57139 12.8292 6.3297 12.9984 6.17432 13.085L6.16943 13.0879C6.15368 13.0973 6.13643 13.1024 6.12158 13.1104L6.0835 13.0576C5.8908 12.7759 5.35022 11.9703 5.06396 10.9073C4.82966 10.0283 4.84975 9.2811 4.89111 7.83694V7.83109C4.89111 7.81474 4.89164 7.79881 4.89209 7.78323C4.91137 7.78029 4.93228 7.77695 4.95459 7.77347C5.4896 7.68959 6.5544 7.52632 7.66553 7.67191C8.22829 7.74649 9.19241 7.80166 10.3647 8.21194V8.21292C10.411 8.22966 10.4539 8.24616 10.4937 8.26077C10.3538 8.59904 10.1357 8.8126 9.99951 8.94534C9.55987 9.35934 9.32657 9.56772 9.20264 9.68069C9.16097 9.71868 9.12711 9.7535 9.1001 9.78128H8.95947L9.0083 10.0215C9.02812 10.1185 9.09679 10.1826 9.14404 10.2188C9.19716 10.2595 9.26304 10.2948 9.3335 10.3252C9.47566 10.3865 9.66801 10.4423 9.89502 10.4893C10.3512 10.5836 10.9756 10.647 11.688 10.6328C13.1113 10.6045 14.9132 10.2666 16.437 9.22269C16.8351 8.95031 17.6499 8.33018 18.4644 7.52151C19.276 6.71568 20.1045 5.70601 20.5073 4.65335L20.5083 4.65237C20.5447 4.55529 20.623 4.34198 20.7261 4.1553C20.778 4.06123 20.8306 3.98414 20.8794 3.9346C20.9109 3.90271 20.9299 3.89106 20.938 3.88773Z" fill="black" stroke="black" stroke-width="0.4"/>
                                        <path d="M1.40625 4.01465C3.53427 0.711274 7.67062 -0.644625 11.4121 0.736328C11.6937 0.839712 11.9673 0.956482 12.2285 1.09082L12.2305 1.0918C12.6268 1.29137 12.9272 1.44642 13.1592 1.58984C13.39 1.73256 13.5415 1.85657 13.6465 1.98926C13.664 2.01217 13.729 2.10121 13.8398 2.14062L13.8916 2.1543L13.9023 2.15625C14.0236 2.17152 14.1184 2.11694 14.1836 2.05762C14.244 2.00262 14.2966 1.92784 14.3438 1.85547C14.4459 1.69866 14.5528 1.50645 14.7324 1.26172C15.0659 0.807379 15.3075 0.638318 15.4629 0.551758L15.4678 0.548828C15.4835 0.539471 15.4998 0.532448 15.5146 0.524414L15.5537 0.579102C15.7224 0.825821 16.1573 1.47235 16.4551 2.3418L16.5732 2.72852C16.8077 3.60771 16.7875 4.35534 16.7461 5.7998V5.80469C16.7461 5.82089 16.7446 5.83709 16.7441 5.85254L16.6826 5.86328C16.1477 5.94714 15.0834 6.11024 13.9727 5.96484C13.4096 5.89018 12.4432 5.83399 11.2695 5.42285C11.2236 5.40622 11.1811 5.38952 11.1416 5.375C11.2813 5.0368 11.5005 4.82322 11.6367 4.69043L11.6377 4.69141C12.0781 4.27673 12.3117 4.06798 12.4355 3.95508C12.493 3.90272 12.5383 3.86066 12.5664 3.82715C12.5812 3.80949 12.6052 3.77809 12.6191 3.73535C12.6358 3.68402 12.6301 3.64 12.624 3.6123H12.6221C12.6006 3.51895 12.5354 3.4563 12.4893 3.4209C12.4362 3.3803 12.3701 3.34578 12.2998 3.31543C12.1577 3.25413 11.9662 3.19734 11.7393 3.15039C11.283 3.05603 10.658 2.99267 9.94531 3.00684C8.52197 3.03515 6.72013 3.37303 5.19629 4.41699C4.79819 4.68936 3.98343 5.30951 3.16895 6.11816C2.3573 6.924 1.52878 7.93366 1.12598 8.98633V8.9873C1.08959 9.08436 1.01043 9.29854 0.907227 9.48535C0.855339 9.57922 0.802618 9.65562 0.753906 9.70508C0.720376 9.73906 0.700455 9.74834 0.693359 9.75098C0.684344 9.74593 0.663079 9.73005 0.629883 9.68652C0.581067 9.62246 0.531496 9.52809 0.485352 9.41602C0.439507 9.30462 0.4005 9.18637 0.370117 9.08301L0.304688 8.83789C0.201999 8.42717 0.195001 8.08495 0.202148 7.85156V7.84961C0.223984 6.76231 0.518683 5.85332 0.756836 5.26758C0.888124 4.94499 1.04157 4.62975 1.21973 4.32129L1.40625 4.01465Z" fill="black" stroke="black" stroke-width="0.4"/>
                                    </svg>
                                `;
                                pdpBtn.innerHTML = `
                                    <span class="autoship-add-to">
                                        ${svgIcon}
                                        <span class="autoship-name" style="font-size:${fontSize}; vertical-align: middle;">${label}</span>
                                    </span>`;
                                lastLabel = label;
                                setTimeout(function() { isUpdating = false; }, 100);
                            }
                        }
                    }
                }
            }
            
            var observerTimeout = null;
            var observer = new MutationObserver(function(mutations) {
                if (document.body.classList.contains('has-autoship')) return;
                
                if (observerTimeout) return;
                observerTimeout = setTimeout(function() {
                    forcePdpButtonUpdate();
                    observerTimeout = null;
                }, 200);
            });
            
            observer.observe(pdpBtn, {
                childList: true,
                subtree: true,
                characterData: true
            });
            
            forcePdpButtonUpdate();
            setTimeout(forcePdpButtonUpdate, 500);
            setTimeout(forcePdpButtonUpdate, 1500);
            setTimeout(forcePdpButtonUpdate, 3000);
        }
    }
});

window.addEventListener("popstate", function()
{
    HandleFacetUpdate();
});

document.addEventListener( "DOMContentLoaded", function( )
{
    var product = window.Shopify.current_product;
    if ( product && product.current_variant && product.current_variant.id )
    {
        FetchNextAutoshipOrder(function (err, rechargeData) 
        {
            if (err || !rechargeData)
            {
                var button = document.querySelector( "#ProductSubmitButton-autoship" );
                if ( button )
                {
                    setupPdpAutoshipQuantityPseudo(product.current_variant.id, button);
                }
            }
        });
    }
});

function getNewestRequest( key, keyValue )
{
    var filteredRequests = window.autoshipQuantityUpdates.filter( ( request ) => request[ key ] == keyValue );
    if ( filteredRequests.length > 0 )
    {
        return filteredRequests[ filteredRequests.length - 1 ];
    }
    else
    {
        return null;
    }
}

function clearFinishedRequests( key, keyValue )
{
    var filteredRequests = window.autoshipQuantityUpdates.filter( ( request ) => request[ key ] == keyValue );
    filteredRequests.forEach( ( request ) =>
    {
        if ( window.autoshipQuantityUpdates.indexOf( request ) !== -1 )
        {
            window.autoshipQuantityUpdates.splice( window.autoshipQuantityUpdates.indexOf( request ), 1  );
        }
    } );
}

function setupPdpAutoshipQuantityPseudo(variantId, autoshipBtn)
{
    var tries = 0;

    function attach()
    {
        var cartItem = document.querySelector(
            `.cart-drawer__content .cart-drawer-items-container .we_cart_item[data-variant-id="${variantId}"][data-selling-plan-id]`
        );
        if (!cartItem)
        {
            if (tries++ < 15) return setTimeout(attach, 200);
            return;
        }

        var lineKey = cartItem.getAttribute("data-line-item-id");
        var qtyInput = cartItem.querySelector("input.cart-quantity-value");
        var qty = parseInt((qtyInput && qtyInput.value) || "1", 10);
        var shownQty = parseInt((qtyInput && qtyInput.value) || "1", 10);

        var wrap = autoshipBtn.parentNode.querySelector(".pdp-autoship-qty");
        if (!wrap) return;

        var stickyQty = document.querySelector( ".sticky-atc-modal .sticky-autoship-qty" )

        wrap.classList.remove("hidden");
        wrap.dataset.quantity = qty;
        autoshipBtn.classList.add("hidden");

        var text           = wrap.querySelector(".pdp-autoship-qty-count");
        var minus          = wrap.querySelector(".pdp-autoship-minus");
        var plus           = wrap.querySelector(".pdp-autoship-plus");
        var stickyQtyText  = stickyQty.querySelector( ".sticky-atc-modal .pdp-autoship-qty-count" );
        var stickyPdpMinus = stickyQty.querySelector( ".sticky-atc-modal .pdp-autoship-minus" );
        var stickyPdpPlus  = stickyQty.querySelector( ".sticky-atc-modal .pdp-autoship-plus" );
        var stickyATC      = document.querySelector( ".sticky-atc-modal .product-buy-button-col-autoship" );
        var minusBtns      = [ ];
        var plusBts        = [ ];
        var qtyTexts       = [ ];

        minusBtns.push( minus );
        plusBts.push( plus );
        qtyTexts.push( text );

        if ( stickyPdpMinus )
        {
            minusBtns.push( stickyPdpMinus );
        }
        if ( stickyPdpPlus )
        {
            plusBts.push( stickyPdpPlus );
        }
        if ( stickyQtyText )
        {
            qtyTexts.push( stickyQtyText );
        }

        text.textContent = AutoshipQtyString(qty);
        if (stickyQtyText) {
            stickyQtyText.textContent = AutoshipQtyString( qty );
        }

        var requestInProgress = false;

        var product = window.Shopify.current_product;

        function getSubscriptionInfo() {
            if (product && window._autoshipData) {
                return getRechargeLineInfo(window._autoshipData, product.id, variantId);
            }
            return null;
        }

        function syncPdpQuantityFromCart() {
            var currentCartItem = document.querySelector(
                `.cart-drawer__content .cart-drawer-items-container .we_cart_item[data-variant-id="${variantId}"][data-selling-plan-id]`
            );
            if (currentCartItem) {
                var currentQtyInput = currentCartItem.querySelector("input.cart-quantity-value");
                if (currentQtyInput) {
                    var currentCartQty = parseInt((currentQtyInput.value) || "0", 10);
                    if (currentCartQty !== qty && currentCartQty > 0) {
                        qty = currentCartQty;
                        shownQty = currentCartQty;
                        wrap.dataset.quantity = currentCartQty;
                        qtyTexts.forEach( qtyText => {
                            if (qtyText) {
                                qtyText.textContent = AutoshipQtyString(currentCartQty);
                            }
                        });
                    } else if (currentCartQty === 0 && qty > 0) {
                        qty = 0;
                        shownQty = 0;
                        wrap.classList.add("hidden");
                        if (stickyQty) stickyQty.classList.add( "hidden" );
                        autoshipBtn.classList.remove("hidden");
                        if (stickyATC) stickyATC.classList.remove( "hidden" );
                        var icon = autoshipBtn.querySelector("img");
                        if (icon) icon.classList.remove("autoship-icon--rotating");
                    }
                }
            }
        }

        var cartObserver = new MutationObserver(function(mutations) {
            syncPdpQuantityFromCart();
        });

        if (cartItem) {
            cartObserver.observe(cartItem, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['data-line-item-id']
            });
            
            if (qtyInput) {
                var inputObserver = new MutationObserver(function() {
                    syncPdpQuantityFromCart();
                });
                inputObserver.observe(qtyInput, {
                    attributes: true,
                    attributeFilter: ['value']
                });
                
                qtyInput.addEventListener('input', function() {
                    setTimeout(syncPdpQuantityFromCart, 100);
                });
                qtyInput.addEventListener('change', syncPdpQuantityFromCart);
            }
        }

        function pushUpdate(newQty)
        {
            var payload = {
                updates: {},
                sections: "cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template"
            };
            payload.updates[lineKey] = newQty;

            var subscriptionInfo = getSubscriptionInfo();

            var subscriptionUpdatePromise = Promise.resolve();
            if (subscriptionInfo && subscriptionInfo.sid && newQty > 0) {
                subscriptionUpdatePromise = new Promise(function(resolve, reject) {
                    window.ReallyModifySubscriptionQuantity(subscriptionInfo.sid, newQty, function(err, response) {
                        if (err) {
                            console.warn("Failed to update subscription quantity:", err);
                        } else {
                            window._autoshipData = response;
                        }
                        resolve();
                    });
                });
            } else if (subscriptionInfo && subscriptionInfo.sid && newQty === 0) {
                subscriptionUpdatePromise = new Promise(function(resolve, reject) {
                    window.ReallyModifySubscriptionQuantity(subscriptionInfo.sid, 0, function(err, response) {
                        if (err) {
                            console.warn("Failed to remove subscription:", err);
                        } else {
                            window._autoshipData = response;
                        }
                        resolve();
                    });
                });
            }

            fetch(window.Shopify.routes.root + "cart/update.js",
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            })
            .then(function(r){ return r.json(); })
            .then(function(data)
            {
                return subscriptionUpdatePromise.then(function() {
                    return data;
                });
            })
            .then(function(data)
            {
                qty                   = newQty;
                wrap.dataset.quantity = newQty;
                requestInProgress     = false;
                var newestRequest     = getNewestRequest( "line", lineKey );
                if ( newestRequest == null || newestRequest.quantity == qty )
                {
                    if (typeof updateCartDrawer === "function") updateCartDrawer(data);

                    if (qty === 0)
                    {
                        wrap.classList.add("hidden");
                        stickyQty.classList.add( "hidden" );
                        autoshipBtn.classList.remove("hidden");
                        stickyATC.classList.remove( "hidden" );
                        var icon = autoshipBtn.querySelector("img");
                        if (icon) icon.classList.remove("autoship-icon--rotating");
                        
                    }

                    clearFinishedRequests( "line", lineKey );
                }
                else
                {
                    pushUpdate( newestRequest.quantity );
                }
            })
            .catch(function(err){ console.warn("cart/update error", err); });
        }

        minusBtns.forEach( btn =>
        {
            if (!btn.dataset.bound)
            {
                btn.dataset.autoshipBound = "true";
                btn.addEventListener("click", function()
                {
                    if ( !requestInProgress )
                    {
                        qty = parseInt( wrap.dataset.quantity );
                        shownQty = parseInt( wrap.dataset.quantity );
                    }
                    if ( shownQty - 1 >= 0 )
                    {
                        var newQty = shownQty - 1;
                        window.autoshipQuantityUpdates.push( { line: lineKey, quantity: newQty } );
                        qtyTexts.forEach( qtyText =>
                        {
                            qtyText.textContent = AutoshipQtyString(newQty);
                        });
                        shownQty = newQty;
                        if ( !requestInProgress )
                        {
                            requestInProgress = true;
                            if (qty <= 1)
                            {
                                if (!confirm("Remove this item from Autoship?")) return;
                                pushUpdate(0);
                            }
                            else
                            {
                                pushUpdate(newQty);
                            }
                        }
                    }
                });
            }
        });

        plusBts.forEach( btn =>
        {
            if (!btn.dataset.bound)
            {
                btn.dataset.autoshipBound = "true";
                btn.addEventListener("click", function()
                {
                    if ( !requestInProgress )
                    {
                        qty = parseInt( wrap.dataset.quantity );
                        shownQty = parseInt( wrap.dataset.quantity );
                    }
                    var newQty = shownQty + 1;
                    window.autoshipQuantityUpdates.push( { line: lineKey, quantity: newQty } );
                    qtyTexts.forEach( qtyText =>
                        {
                            qtyText.textContent = AutoshipQtyString(newQty);
                        });
                    shownQty = newQty;
                    if ( !requestInProgress )
                    {
                        requestInProgress = true;
                        pushUpdate(newQty);
                    }
                });
            }
        });
    }

    attach();
}





function setupAutoshipQuantitySync(sid)
{
    var modalInput        = document.querySelector('.autoship-modal__qty-input');
    var pdpQtyText        = document.querySelector('.pdp-autoship-qty-count');
    var modalMinus        = document.querySelector('.autoship-modal__qty-minus');
    var modalPlus         = document.querySelector('.autoship-modal__qty-plus');
    var pdpMinus          = document.querySelector('.pdp-autoship-minus');
    var pdpPlus           = document.querySelector('.pdp-autoship-plus');
    var stickyQtyText     = document.querySelector( ".sticky-atc-modal .pdp-autoship-qty-count" );
    var stickyPdpMinus    = document.querySelector( ".sticky-atc-modal .pdp-autoship-minus" );
    var stickyPdpPlus     = document.querySelector( ".sticky-atc-modal .pdp-autoship-plus" );
    var removeBtn         = document.querySelector('.autoship-modal__remove');
    const product         = window.Shopify.current_product;
    const variant         = getSelectedVariant();
    var requestInProgress = false;

    var info;
    if ( product && variant )
    {
        info = getRechargeLineInfo( window._autoshipData, product.id, variant.id );
    }

    var currQty           = parseInt( ( info && info.qty ) || ( modalInput && modalInput.value) || '1', 10 );
    var shownQty          = parseInt( ( info && info.qty ) || ( modalInput && modalInput.value) || '1', 10 );

    function updateUI(qty) {
        if (modalInput) modalInput.value = qty;
        if (pdpQtyText) pdpQtyText.textContent = `${AutoshipQtyString( qty )}`;

        // Also update PLP qty blocks
        const allPLPQtys = document.querySelectorAll('.pdp-autoship-qty-count:not( .pdp-autoship-qty-count--am )');
        allPLPQtys.forEach(el => {
            if (el !== pdpQtyText) el.textContent = `${AutoshipQtyString( qty ) }`;
        });
    }

    function scheduleBackendSync(newQty)
    {
        window.ReallyModifySubscriptionQuantity(sid, newQty, function (err, response)
        {
            if (err)
            {
                console.warn('Autoship update failed:', err);
            }
            else
            {
                window._autoshipData = response;
                var newestRequest = getNewestRequest( "sid", sid );
                if ( newestRequest != null && newestRequest.quantity != newQty  )
                {
                    scheduleBackendSync( newestRequest.quantity );
                }
                else
                {
                    requestInProgress = false;
                    if ( currQty > newQty )
                    {
                        var aMProductCard = document.querySelector( `.autoship-manager .product-card[ data-sid="${ sid }" ]` );
                        if ( aMProductCard ) handleAutoshipManagerQU( aMProductCard, newQty, "minus" );
                    }
                    else
                    {
                        var aMProductCard = document.querySelector( `.autoship-manager .product-card[ data-sid="${ sid }" ]` );
                        if ( aMProductCard ) handleAutoshipManagerQU( aMProductCard, newQty, "plus" );
                    }

                    currQty = newQty;
                    clearFinishedRequests( "sid", sid );
                }
            }
        });
    }

    function changeQty(diff)
    {
        if ( shownQty + diff >= 0 )
        {
            shownQty += diff;
            updateUI( shownQty )
            var newQty = Math.max(1, shownQty);
            window.autoshipQuantityUpdates.push( { sid: sid, quantity: newQty } );
            if ( !requestInProgress )
            {
                requestInProgress = true;
                scheduleBackendSync(newQty);
            }
        }
    }

    function handleMinusClick()
    {
        if (shownQty === 1)
        {
            window.autoshipQuantityUpdates.push( { sid: sid, quantity: 0 } );
            if ( !requestInProgress )
            {
                requestInProgress = true;
                if (!window.confirm('Remove this item from Autoship?'))
                {
                    return;
                }
                if (sid)
                {
                    window.ReallyModifySubscriptionQuantity(sid, 0, function (err, response)
                    {
                        if (err)
                        {
                            window.alert('Failed to remove from Autoship: ' + (err.error || err));
                        }
                        else
                        {
                            window._autoshipData = response;
                            var aMProductCard = document.querySelector( `.autoship-manager .product-card[ data-sid="${ sid }" ]` );
                            if ( aMProductCard ) handleAutoshipManagerQU( aMProductCard, 0, "minus" );
                            cleanupAutoshipUI();
                        }
                    });
                }
                else
                {
                    cleanupAutoshipUI();
                }
            }
        }
        else
        {
            changeQty(-1);
        }
    }

    function cleanupAutoshipUI()
    {
        var pdpAutoshipEl = document.querySelector('.pdp-autoship-qty');
        if (pdpAutoshipEl && pdpAutoshipEl.parentNode)
        {
            pdpAutoshipEl.classList.add( "hidden" );
        }
        var addToCartBtn = document.querySelector('.autoship-add-to-cart');
        if (addToCartBtn)
        {
            addToCartBtn.classList.remove('hidden');
        }
        if (modalInput)
        {
            modalInput.value = '1';
        }
        if (pdpQtyText)
        {
            pdpQtyText.textContent = AutoshipQtyString( 1 );
        }
        if ( stickyQtyText )
        {
            stickyQtyText.textContent = AutoshipQtyString( 1 );
        }
    }

    if (modalMinus)
    {
        modalMinus.addEventListener('click', function ()
        {
            changeQty(-1);
        });
    }
    if (modalPlus)
    {
        modalPlus.addEventListener('click', function ()
        {
            changeQty(1);
        });
    }
    if (pdpMinus && pdpMinus.dataset.autoshipBound === "false" )
    {
        pdpMinus.dataset.autoshipBound = "true";
        pdpMinus.addEventListener('click', handleMinusClick);
    }
    if (pdpPlus && pdpPlus.dataset.autoshipBound === "false")
    {
        pdpPlus.dataset.autoshipBound = "true";
        pdpPlus.addEventListener('click', function ()
        {
            changeQty(1);
        });
    }

    if ( stickyPdpMinus && stickyPdpMinus.dataset.autoshipBound === "false" )
    {
        stickyPdpMinus.dataset.autoshipBound = "true";
        stickyPdpMinus.addEventListener( 'click', handleMinusClick );
    }
    
    if ( stickyPdpPlus && stickyPdpPlus.dataset.autoshipBound === "false" )
    {
        stickyPdpPlus.dataset.autoshipBound = "true";
        stickyPdpPlus.addEventListener( 'click', function ( )
        {
            changeQty( 1 );
        });
    }

    if (modalInput)
    {
        modalInput.addEventListener('change', function (e)
        {
            var val = parseInt(e.target.value, 10);
            if (!isNaN(val) && val > 0)
            {
                scheduleBackendSync(val);
            }
        });
    }

    if (removeBtn)
    {
        removeBtn.addEventListener('click', function (e)
        {
            e.preventDefault();
            cleanupAutoshipUI();
        });
    }
}

function renderAutoshipUI( product, variant )
{
    FetchNextAutoshipOrder( function (err, rechargeData)
    {
        if ( ( rechargeData ) && ( product ) && ( variant ) )
        {
            var info = getRechargeLineInfo( rechargeData, product.id, variant.id );

            if ( ( info ) && ( info.sid ) )
            {
                setupAutoshipQuantitySync( info.sid );
            }
        }
    });
}

function getSelectedVariant()
{
    var product = window.Shopify.current_product;
    if( product.id )
    {
        var selected      = document.querySelector('input[type="radio"][name="Size"]:checked');
        var selectedValue = selected ? selected.value : undefined;
        var result        = null;
        for (var i = 0; i < product.variants.length; i++)
        {
            var v = product.variants[i];
            if (v.option1 === selectedValue)
            {
                result = v;
                break;
            }
        }
        return result || product.variants[0];
    }
}

function initAutoshipVariantSync()
{
    var product        = window.Shopify.current_product;
    var variantOptions = document.querySelectorAll('input[type="radio"][name="Size"]');
    renderAutoshipUI(product, getSelectedVariant());
    for (var i = 0; i < variantOptions.length; i++)
    {
        variantOptions[i].addEventListener('change', function ()
        {
            renderAutoshipUI(product, getSelectedVariant());
        });
    }
}

function rcpAddToCart( data, callback )
{
    fetch('/cart/add.js?sections=cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json'
        },
        body: data
    })
    .then(response => {
        if (!response.ok) {
        throw new Error('Error adding to cart: ' + response.status);
        }
        return response.json();
    })
    .then(cart => {
        KlaviyoTrack( "Added to Cart", cart );
        updateCartDrawer(cart);
        var cart_count = $('#CartCount').text();
        cart_count = parseInt(cart_count);
        $('#CartCount').text(cart_count)
        setUpCartEventsWellEasy();
        updateGridSection()
        orderUpdateGridSection();
        wishlistUpdateGridSection();
        callback( cart );
    })
    .catch(error => {
        console.error('Error adding to cart:', error);
    });
}

function toggleATCButton( atcButton )
{
    if ( !atcButton )
    {
        return;
    }

    var vid = atcButton.dataset.variantId;
    if ( !vid )
    {
        return;
    }

    // Source of truth: cart quantities map (populated on back nav and available after cart fetch)
    var cartMap = window.__BACKNAV_CART_MAP__ || null;
    var qtyFromMap = 0;
    if ( cartMap && cartMap.hasOwnProperty( String( vid ) ) )
    {
        qtyFromMap = Number( cartMap[ String( vid ) ] || 0 );
    }

    // Fallback to cart drawer DOM if map is missing (non-back-nav paths)
    var cartItem = document.querySelector(
        `.cart-drawer__content .cart-drawer-items-container .we_cart_item[data-variant-id="${vid}"]`
    );

    var spid = cartItem ? cartItem.getAttribute( "data-selling-plan-id" ) : null;

    // Subscription items still use the existing autoship path
    if ( cartItem && spid )
    {
        var productCard = atcButton.closest( ".product-grid__product-card" );
        var qtyInput    = cartItem.querySelector( "input.cart-quantity-value" );
        var qty         = qtyInput ? Number( qtyInput.value ) : 0;

        SetupProductCardForPseudoAutoship( productCard, qty );
        return;
    }

    // One-time purchases: reconcile UI to match cart state
    // Find quantity-input wrapper - try parentElement first, fallback to product card container
    var wrapper = null;
    if ( atcButton.parentElement )
    {
        wrapper = atcButton.parentElement.querySelector( "quantity-input" );
    }
    if ( !wrapper )
    {
        var productCard = atcButton.closest( ".product-grid__product-card" );
        if ( productCard )
        {
            wrapper = productCard.querySelector( "quantity-input" );
        }
    }
    var inputEl = wrapper
        ? wrapper.querySelector( "input.quantity__input" )
        : null;

    // Prefer map quantity; fallback to drawer quantity if map absent
    var qty = qtyFromMap;
    if ( qty === 0 && cartItem )
    {
        var cartQtyEl = cartItem.querySelector( "input.cart-quantity-value" );
        if ( cartQtyEl )
        {
            qty = Number( cartQtyEl.value || 0 );
        }
    }

    var hasCart = qty > 0;

    // If item is in cart with qty > 0 → show selector, hide ATC, sync value
    if ( hasCart && qty > 0 && wrapper && inputEl )
    {
        atcButton.dataset.swapped = "true";
        atcButton.classList.add( "hidden" );

        wrapper.classList.remove( "hidden" );
        wrapper.disabled = false;
        wrapper.classList.remove( "disabled" );
        wrapper.setAttribute( "data-item-in-cart", "true" );

        inputEl.setAttribute( "data-cart-quantity", String( qty ) );
        inputEl.value = String( qty );
    }
    // If not in cart (or qty is 0) → revert to plain ATC
    else
    {
        atcButton.dataset.swapped = "false";
        atcButton.classList.remove( "hidden" );

        if ( wrapper )
        {
            wrapper.classList.add( "hidden" );
            wrapper.removeAttribute( "data-item-in-cart" );
        }
    }
}

function refreshProductCardButtons()
{
    if ( typeof toggleATCButton !== "function" )
    {
        return;
    }

    var buttons = document.querySelectorAll( ".product-card__buy-button" );
    if ( !buttons.length )
    {
        return;
    }

    var run = function( )
    {
        buttons.forEach( function( button )
        {
            try
            {
                toggleATCButton( button );
            }
            catch ( error )
            {
                console.warn( "Unable to sync product card state", error );
            }
        } );
    };

    if ( typeof requestAnimationFrame === "function" )
    {
        requestAnimationFrame( run );
    }
    else
    {
        run( );
    }
}

window.refreshProductCardButtons = refreshProductCardButtons;

document.addEventListener( "click", function( e )
{
    if ( e.target.matches( ".product-card__buy-button" ) )
    {
        variantId = e.target.dataset.variantId;
        rcpAddToCart( 'id='+variantId+'&quantity=1', function( cart ) { toggleATCButton( e.target ) } );
    }
    else if ( e.target.closest( ".product-grid__product-card quantity-input button[name='minus']" ) )
    {
        //need a better solution for this
        setTimeout(() => {
            toggleATCButton( e.target.parentElement.parentElement.querySelector( ".product-card__buy-button" ) );
        }, 1000);
    }
});

function qtyChangeEvent(e) 
{
  if (e.target.matches(".product-card__buy-button") || e.target.closest( ".product-form__submit:not( .autoship-add-to-cart )" )) 
  {
    let wrapper;

    if (e.target.matches("input.quantity__input")) {
      wrapper = e.target.closest("quantity-input");
    } else if (e.target.matches(".product-card__buy-button")) {
      wrapper = e.target;
    } else if (e.target.closest( ".product-form__submit" )) {
        wrapper = e.target;
    }

    if (wrapper && !wrapper.querySelector(".qty-spinner")) 
    {
      const spinner = document.createElement("div");
      spinner.className = "qty-spinner";
      spinner.style.cssText = `
        position: absolute;
        top: 50%;
        left: 50%;
        width: 20px;
        height: 20px;
        margin-top: -10px;
        margin-left: -10px;
        border: 2px solid rgba(0, 0, 0, 0.1);
        border-top: 2px solid #000;
        border-radius: 50%;
        animation: spin 0.6s linear infinite;
        z-index: 5;
        pointer-events: none;
      `;
      wrapper.style.position = "relative";
      wrapper.appendChild(spinner);
    }

    if (wrapper) {
      setTimeout(() => 
      {
        wrapper.classList.remove("disabled");
        wrapper.removeAttribute("disabled");

        const spinner = wrapper.querySelector(".qty-spinner");
        if (spinner) spinner.remove();
      }, 1000);
    }
  }
}

//document.addEventListener("change", qtyChangeEvent);
document.addEventListener("click", qtyChangeEvent);


document.addEventListener('DOMContentLoaded', function () 
{
  if (_rcp_customer.email && _rcp_customer.id) 
  {
    initAutoshipVariantSync();
  }

  var addToAutoshipBtn = document.querySelector('.autoship-add-to-cart');
  if (!addToAutoshipBtn) return;

  if (addToAutoshipBtn.dataset.autoshipBound === '1') return;
  addToAutoshipBtn.dataset.autoshipBound = '1';

  addToAutoshipBtn.addEventListener('click', function (e) 
  {
    e.preventDefault();

    const button  = e.currentTarget;
    if (button.dataset.autoshipProcessing === '1') return;
    button.dataset.autoshipProcessing = '1';

    const iconImg = button.querySelector('svg');
    const product = window.Shopify.current_product;
    const variant = getSelectedVariant();
    var stickyTrigger = document.querySelector( ".sticky-autoship-trigger" );
    if (!product || !variant) 
    {
      delete button.dataset.autoshipProcessing;
      return;
    }

    if (iconImg) iconImg.classList.add('autoship-icon--rotating');

    function stopSpin()
    {
      if (iconImg) iconImg.classList.remove('autoship-icon--rotating');
      delete button.dataset.autoshipProcessing;
      if ( stickyTrigger )
      {
        stickyTrigger.querySelector( "svg" ).classList.remove( "autoship-icon--rotating" );
      }
    }
    function fallbackAdd()
    {
      HandleAutoshipAddAsSubscription(button);
      
      stopSpin();
    }

    if (_rcp_customer.email && _rcp_customer.id) 
    {
      FetchNextAutoshipOrder(function (err, rechargeData) 
      {
        if (err || !rechargeData) return fallbackAdd();
        const info = getNextRechargeSub(rechargeData);
        if (!info || !info.aid || !info.ncs || !info.freq || !info.freqUnit) return fallbackAdd();

        ReallyCreateNewSubscription(
          info.aid, info.ncs, info.freq, info.freqUnit, 1, product.id, variant.id,
          function (err2) 
          {
            if (err2) return fallbackAdd();

            let tries = 0;
            (function poll() 
            {
              if (tries++ > 10) { stopSpin(); return; }
              setTimeout(function () 
              {
                FetchNextAutoshipOrder(function (err3, updatedData) 
                {
                  const fresh = getRechargeLineInfo(updatedData, product.id, variant.id);
                  if (!fresh?.sid) return poll();

                  try { showAutoshipModal({ product, variant, rechargeData: updatedData }); } catch(_){}
                  stopSpin();

                  button.classList.add( "hidden" );
                  button.parentElement.querySelector( ".pdp-autoship-qty" ).classList.remove( "hidden" )
                  button.parentElement.querySelector( ".pdp-autoship-qty-count" ).textContent = fresh.qty + " in Autoship";
                  
                  setupAutoshipQuantitySync(fresh.sid);

                  FetchNewAutoShipProducts( updatedData );
                });
              }, 500);
            })();
          }
        );
      });
    } else 
    {
      fallbackAdd();
    }
  });
});


function setupFacetsAndMobileFilters()
{
    const openBtn          = document.querySelector(".mobile-filters-toggle");
    const closeBtn         = document.querySelector(".mobile-filter-close");
    const modal            = document.querySelector(".mobile-filters-modal");
    const stickyNav        = document.querySelector('.sticky-nav-mob');
    const applyBtn         = document.querySelector(".mobile-filters-apply");
    const resetBtn         = document.querySelector(".mobile-filters-reset");
    const filtersContainer = document.querySelector(".header__facets-search__filters");
    const LUIGI_BASE       = `https://live.luigisbox.tech/search?tracker_id=${publicKey}`;

    function buildBaseQuery()
    {
        if (_rcp_template.template === "collection")
        {
            if (_rcp_template.collectionHandle === "all")
            {
                return "&f[]=type:product&plp=category";
            }
            else
            {
                return `&f[]=type:product&plp=category&f[]=category:${encodeURIComponent(_rcp_template.collectionTitle)}`;
            }
        }
        else
        {
            const qp = CreateSearchParamsArray(window.location.search).get("q") || "";
            return `&f[]=type:product&q=${encodeURIComponent(qp)}`;
        }
    }

    function buildSortQuery()
    {
        const sort = document.querySelector(".header__facets-search__sort").dataset.selected;
        return `&sort=${sort}`;
    }

    function mirrorMobileToDesktop()
    {
        modal.querySelectorAll(".mobile-filter-options").forEach(optionsEl =>
        {
            const group = optionsEl.dataset.group;
            const desktopBlock = Array.from(
                filtersContainer.querySelectorAll(".header__facets-search__filter")
            ).find(block =>
                handleize(block.getAttribute("data-facet-title")) === group
            );
            if (!desktopBlock)
            {
                return;
            }
            optionsEl.querySelectorAll("input[type=checkbox]").forEach(mobileInput =>
            {
                const matching = desktopBlock.querySelector(`input[value="${mobileInput.value}"]`);
                if (matching)
                {
                    matching.checked = mobileInput.checked;
                }
            });
        });
    }

    function updateMobileCount()
    {
        mirrorMobileToDesktop();
        let filterQuery = "";
        filtersContainer.querySelectorAll("input[filter-parent]").forEach(di =>
        {
            if (!di.checked)
            {
                return;
            }
            const facetKey = di.getAttribute("filter-parent");
            const opName   = di.getAttribute("filter-operator") === "and" ? "f_must" : "f";
            const val      = encodeURIComponent(di.value);
            filterQuery   += `&${opName}[]=${facetKey}:${val}`;
        });
        const url = LUIGI_BASE
                  + "&size=1&page=1"
                  + buildBaseQuery()
                  + filterQuery
                  + buildSortQuery();
        fetch(url)
            .then(res => res.json())
            .then(data =>
            {
                const hits = data.results?.total_hits ?? 0;
                applyBtn.textContent = `Show ${hits} items`;
            })
            .catch(() =>
            {
                applyBtn.textContent = "Show items";
            });
    }

    openBtn?.addEventListener("click", () =>
    {
        modal?.classList.remove("hidden");
        document.body.style.overflow = "hidden";
        stickyNav?.classList.add("hidden");
        document.body.classList.add("mobile-filters-open");
        updateMobileCount();
    });

    closeBtn?.addEventListener("click", () =>
    {
        modal?.classList.add("hidden");
        document.body.style.overflow = "";
        stickyNav?.classList.remove("hidden");
        document.body.classList.remove("mobile-filters-open");
    });

    resetBtn?.addEventListener("click", () =>
    {
        modal.querySelectorAll("input[type=checkbox]").forEach(cb => cb.checked = false);
        updateMobileCount();
    });

    modal.querySelectorAll("input[type=checkbox]").forEach(inp =>
        inp.addEventListener("change", updateMobileCount)
    );

    applyBtn?.addEventListener("click", () =>
    {
        mirrorMobileToDesktop();
        HandleFacetChangeEvent(new Event("change", { bubbles: true }), filtersContainer, null);
        modal?.classList.add("hidden");
        document.body.style.overflow = "";
        stickyNav?.classList.remove("hidden");
        document.body.classList.remove("mobile-filters-open");
        renderSelectedFilterTags(); 
    });

    document.querySelectorAll(".mobile-filter-toggle").forEach(btn =>
    {
        btn.addEventListener("click", () =>
        {
            const expanded = btn.getAttribute("aria-expanded") === "true";
            btn.setAttribute("aria-expanded", String(!expanded));
            const options = btn.nextElementSibling;
            if (options)
            {
                options.classList.toggle("open", !expanded);
            }
        });
    });
}

function escapeForAttr(val)
{
    if (window.CSS && typeof CSS.escape === "function")
    {
        return CSS.escape(String(val));
    }
    return String(val).replace(/["\\]/g, "\\$&");
}

function renderSelectedFilterTags()
{
    var filters = Array.prototype.slice.call(
        document.querySelectorAll(
            ".header__facets-search__filters input[type=checkbox]:checked, .header__facets-search__filters input[type=radio]:checked"
        )
    );
    var wrapper = document.querySelector(".selected-filters-wrapper");
    if (!wrapper) { return; }

    wrapper.innerHTML = "";

    filters.forEach(function(input)
    {
        var pill = document.createElement("span");
        pill.className = "selected-filter-tag";

        var textSpan = document.createElement("span");
        textSpan.className = "selected-filter-text";
        textSpan.textContent = input.value;
        pill.appendChild(textSpan);

        var btn = document.createElement("button");
        btn.className = "selected-filter-remove";
        btn.textContent = "×";
        btn.addEventListener("click", function()
        {
            input.checked = false;

            var safeVal = escapeForAttr(input.value);
            var mobileInput = document.querySelector('.mobile-filter-option input[value="' + safeVal + '"]');
            if (mobileInput)
            {
                mobileInput.checked = false;
            }

            HandleFacetChangeEvent(
                new Event("change", { bubbles: true }),
                document.querySelector(".header__facets-search__filters"),
                null
            );
            renderSelectedFilterTags();
        });
        pill.appendChild(btn);

        wrapper.appendChild(pill);
    });
}




function reorderMobileProductCardInfo() {
  if (window.innerWidth <= 768) {
    document.querySelectorAll('.product-card__info').forEach(function (infoEl) {
      const titleEl = infoEl.querySelector('.product-card__title');
      const metaEl = infoEl.querySelector('.product-card__meta');

      if (titleEl && metaEl && metaEl.nextSibling !== titleEl) {
        metaEl.parentNode.insertBefore(titleEl, metaEl.nextSibling);
      }
    });
  }
}

function initOtherProductCards()
{
    var products = document.querySelectorAll( ".product-grid__product-card--not-collection" );

    if ( products.length > 0 )
    {
        console.log( "My Aisle Products Found" );

        FetchNextAutoshipOrder( function( err, rechargeData )
        {
            var products = document.querySelectorAll( ".product-grid__product-card--not-collection" );
            products.forEach( product =>
            {
                var autoshipBtn = product.querySelector( ".autoship-add-to-cart" )
                autoshipBtn.addEventListener( 'click', function( e )
                {
                    e.preventDefault( );
                    autoshipBtn.disabled = true;
                    handleAutoshipAdd( e.currentTarget );
                });

                product._productData = JSON.parse( product.dataset.productData );
                ObserveSingleProductCard( product );
                
                oneTimeATC = product.querySelector( ".product-card__buy-button" );
                toggleATCButton( oneTimeATC );
            });

            if ( rechargeData && rechargeData.charges && rechargeData.charges.length > 0 )
            {
            }
            else
            {
                document.querySelectorAll(".autoship-add-to-cart:not(#ProductSubmitButton-autoship)").forEach(btn => 
                {
                    var isMyAisle = document.body.id === 'lightning-my-aisle' || document.querySelector('#lightning-my-aisle');
                    var fontSize = isMyAisle ? '12px' : '14px';
                    btn.innerHTML =
                    `
                        <span class="autoship-add-to">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="14" viewBox="0 0 22 14" fill="none" style="vertical-align:middle; margin-right:6px;">
                            <path d="M20.938 3.88773C20.9263 3.88703 20.9507 3.8827 21.0044 3.95316C21.0533 4.01728 21.1018 4.11242 21.1479 4.22464C21.2395 4.44722 21.3024 4.69594 21.3286 4.80179C21.4313 5.21251 21.4383 5.55473 21.4312 5.78812V5.79007C21.4093 6.87764 21.1147 7.78731 20.8765 8.37308C20.7451 8.69572 20.5918 9.01084 20.4136 9.31937L20.2271 9.62503C18.1692 12.8252 14.2197 14.1985 10.5767 13.0225L10.2251 12.9004C9.94338 12.797 9.66997 12.6793 9.40869 12.545L9.40674 12.544C9.01046 12.3444 8.71 12.1893 8.47803 12.0459C8.24712 11.9032 8.09569 11.7793 7.99072 11.6465H7.98975C7.96867 11.6188 7.88628 11.5082 7.74561 11.4825V11.4815L7.73486 11.4805H7.64893C7.56814 11.492 7.50249 11.5337 7.45361 11.5782C7.39314 11.6332 7.34065 11.7088 7.29346 11.7813C7.19133 11.9381 7.08437 12.1303 6.90479 12.375C6.57139 12.8292 6.3297 12.9984 6.17432 13.085L6.16943 13.0879C6.15368 13.0973 6.13643 13.1024 6.12158 13.1104L6.0835 13.0576C5.8908 12.7759 5.35022 11.9703 5.06396 10.9073C4.82966 10.0283 4.84975 9.2811 4.89111 7.83694V7.83109C4.89111 7.81474 4.89164 7.79881 4.89209 7.78323C4.91137 7.78029 4.93228 7.77695 4.95459 7.77347C5.4896 7.68959 6.5544 7.52632 7.66553 7.67191C8.22829 7.74649 9.19241 7.80166 10.3647 8.21194V8.21292C10.411 8.22966 10.4539 8.24616 10.4937 8.26077C10.3538 8.59904 10.1357 8.8126 9.99951 8.94534C9.55987 9.35934 9.32657 9.56772 9.20264 9.68069C9.16097 9.71868 9.12711 9.7535 9.1001 9.78128H8.95947L9.0083 10.0215C9.02812 10.1185 9.09679 10.1826 9.14404 10.2188C9.19716 10.2595 9.26304 10.2948 9.3335 10.3252C9.47566 10.3865 9.66801 10.4423 9.89502 10.4893C10.3512 10.5836 10.9756 10.647 11.688 10.6328C13.1113 10.6045 14.9132 10.2666 16.437 9.22269C16.8351 8.95031 17.6499 8.33018 18.4644 7.52151C19.276 6.71568 20.1045 5.70601 20.5073 4.65335L20.5083 4.65237C20.5447 4.55529 20.623 4.34198 20.7261 4.1553C20.778 4.06123 20.8306 3.98414 20.8794 3.9346C20.9109 3.90271 20.9299 3.89106 20.938 3.88773Z" fill="black" stroke="black" stroke-width="0.4"/>
                            <path d="M1.40625 4.01465C3.53427 0.711274 7.67062 -0.644625 11.4121 0.736328C11.6937 0.839712 11.9673 0.956482 12.2285 1.09082L12.2305 1.0918C12.6268 1.29137 12.9272 1.44642 13.1592 1.58984C13.39 1.73256 13.5415 1.85657 13.6465 1.98926C13.664 2.01217 13.729 2.10121 13.8398 2.14062L13.8916 2.1543L13.9023 2.15625C14.0236 2.17152 14.1184 2.11694 14.1836 2.05762C14.244 2.00262 14.2966 1.92784 14.3438 1.85547C14.4459 1.69866 14.5528 1.50645 14.7324 1.26172C15.0659 0.807379 15.3075 0.638318 15.4629 0.551758L15.4678 0.548828C15.4835 0.539471 15.4998 0.532448 15.5146 0.524414L15.5537 0.579102C15.7224 0.825821 16.1573 1.47235 16.4551 2.3418L16.5732 2.72852C16.8077 3.60771 16.7875 4.35534 16.7461 5.7998V5.80469C16.7461 5.82089 16.7446 5.83709 16.7441 5.85254L16.6826 5.86328C16.1477 5.94714 15.0834 6.11024 13.9727 5.96484C13.4096 5.89018 12.4432 5.83399 11.2695 5.42285C11.2236 5.40622 11.1811 5.38952 11.1416 5.375C11.2813 5.0368 11.5005 4.82322 11.6367 4.69043L11.6377 4.69141C12.0781 4.27673 12.3117 4.06798 12.4355 3.95508C12.493 3.90272 12.5383 3.86066 12.5664 3.82715C12.5812 3.80949 12.6052 3.77809 12.6191 3.73535C12.6358 3.68402 12.6301 3.64 12.624 3.6123H12.6221C12.6006 3.51895 12.5354 3.4563 12.4893 3.4209C12.4362 3.3803 12.3701 3.34578 12.2998 3.31543C12.1577 3.25413 11.9662 3.19734 11.7393 3.15039C11.283 3.05603 10.658 2.99267 9.94531 3.00684C8.52197 3.03515 6.72013 3.37303 5.19629 4.41699C4.79819 4.68936 3.98343 5.30951 3.16895 6.11816C2.3573 6.924 1.52878 7.93366 1.12598 8.98633V8.9873C1.08959 9.08436 1.01043 9.29854 0.907227 9.48535C0.855339 9.57922 0.802618 9.65562 0.753906 9.70508C0.720376 9.73906 0.700455 9.74834 0.693359 9.75098C0.684344 9.74593 0.663079 9.73005 0.629883 9.68652C0.581067 9.62246 0.531496 9.52809 0.485352 9.41602C0.439507 9.30462 0.4005 9.18637 0.370117 9.08301L0.304688 8.83789C0.201999 8.42717 0.195001 8.08495 0.202148 7.85156V7.84961C0.223984 6.76231 0.518683 5.85332 0.756836 5.26758C0.888124 4.94499 1.04157 4.62975 1.21973 4.32129L1.40625 4.01465Z" fill="black" stroke="black" stroke-width="0.4"/>
                        </svg>
                        <span class="autoship-name" style="font-size: ` + fontSize + `; vertical-align: middle;"><strong>Autoship </strong>every 4 weeks</span>
                        </span>

                `;
                });
            }

            setUpCartEventsWellEasy( );
            WE_ReviewsIo_InitRatingSnippet( );
            updateGridSection( );
        } );
    }
}

function WE_ReviewsIo_InitRatingSnippet( )
{
    var canInit = ( window.WE_RatingSnippet_Initialised != true );

    if ( canInit )
    {
        window.WE_RatingSnippet_Initialised = true;

        ratingSnippet( "ruk_rating_snippet",
        {
            store: "www.welleasy.co.uk",
            showNumericalAverageRating: true,
            color: "#F7A855",
            linebreak: false,
            text: " ",
            singularText: " ",
            lang: "en",
            usePolaris: true,
            showEmptyStars: false
        } );

        WE_ReviewsIo_StripReviewTextAndBracketCount( );
        setTimeout( WE_ReviewsIo_StripReviewTextAndBracketCount, 500 );
    }
}

function WE_ReviewsIo_StripReviewTextAndBracketCount( )
{
    var snippets = document.querySelectorAll( ".ruk_rating_snippet" );
    var i        = 0;

    for ( i = 0; i < snippets.length; i++ )
    {
        WE_ReviewsIo_FixOneSnippetCount( snippets[ i ] );
    }
}

function WE_ReviewsIo_FixOneSnippetCount( snippet )
{
    var title      = snippet.getAttribute( "title" ) || "";
    var rating     = "";
    var count      = "";
    var match      = null;
    var spans      = snippet.querySelectorAll( ".ruk-rating-snippet-count" );
    var stars      = snippet.querySelectorAll( "i[class*='ruk-icon']" );
    var firstSpan  = spans[ 0 ] || null;
    var lastSpan   = spans[ spans.length - 1 ] || null;
    var firstStar  = stars[ 0 ] || null;
    var ratingNum  = 0;
    var fullCount  = 0;
    var partialPct = 0;
    var i          = 0;
    var clone        = null;
    var insertBefore = null;
    var spacer       = null;
    var ratingSpan   = null;

    match = title.match( /([\d.]+)\s*Stars?\s*-\s*(\d+)(?:\s*Reviews?)?/i );
    if ( match )
    {
        rating = match[ 1 ];
        count  = match[ 2 ];
    }
    if ( !rating && firstSpan && /^\d+\.?\d*$/.test( ( firstSpan.textContent || "" ).trim( ) ) )
    {
        rating = ( firstSpan.textContent || "" ).trim( );
    }
    if ( !count && lastSpan )
    {
        count = ( lastSpan.textContent || "" ).replace( /[^\d]/g, "" );
    }
    if ( lastSpan && ( lastSpan.textContent.indexOf( "Review" ) >= 0 || ( /^\(\d+\)$/.test( lastSpan.textContent ) == false && count ) ) )
    {
        lastSpan.textContent = "(" + count + ")";
    }
    if ( rating && ( spans.length < 2 || ( firstSpan && /^\d+\.?\d*$/.test( firstSpan.textContent.trim( ) ) == false ) ) )
    {
        if ( firstSpan && firstSpan.textContent.indexOf( "Review" ) >= 0 )
        {
            firstSpan.textContent = rating;
        }
        else if ( spans.length == 0 || ( spans.length == 1 && lastSpan.textContent.indexOf( "(" ) == 0 ) )
        {
            spacer = document.createElement( "span" );
            spacer.style.display = "inline-block";
            spacer.style.minWidth = "8px";
            ratingSpan = document.createElement( "span" );
            ratingSpan.setAttribute( "aria-hidden", "true" );
            ratingSpan.className = "ruk-rating-snippet-count";
            ratingSpan.textContent = rating;
            if ( lastSpan )
            {
                lastSpan.parentNode.insertBefore( spacer, lastSpan );
                lastSpan.parentNode.insertBefore( ratingSpan, spacer );
            }
            else
            {
                snippet.appendChild( ratingSpan );
                snippet.appendChild( spacer );
            }
        }
    }

    if ( firstStar && stars.length == 1 && rating )
    {
        ratingNum   = parseFloat( rating ) || 0;
        fullCount   = Math.floor( ratingNum );
        partialPct  = Math.round( ( ratingNum - fullCount ) * 100 );
        insertBefore = firstStar;
        for ( i = 1; i < 5; i++ )
        {
            clone = firstStar.cloneNode( true );
            if ( i < fullCount )
            {
                clone.className = "ruk-icon-percentage-star--100";
            }
            else if ( i == fullCount && partialPct > 0 )
            {
                clone.className = "ruk-icon-percentage-star--" + partialPct;
            }
            else if ( i >= fullCount )
            {
                clone.className = "ruk-icon-percentage-star--0";
            }
            insertBefore.parentNode.insertBefore( clone, insertBefore.nextSibling );
            insertBefore = clone;
        }
    }
}

function WE_ReviewsIo_RunFix( )
{
    WE_ReviewsIo_StripReviewTextAndBracketCount( );
}

function WE_ReviewsIo_EnforceReviewFormatGlobally( )
{
    var observer = null;

    WE_ReviewsIo_RunFix( );
    setTimeout( WE_ReviewsIo_RunFix, 500 );
    setTimeout( WE_ReviewsIo_RunFix, 1500 );
    setTimeout( WE_ReviewsIo_RunFix, 3000 );

    function WE_ReviewsIo_OnSnippetMutation( mutations )
    {
        var i     = 0;
        var j     = 0;
        var node  = null;
        var added = null;

        for ( i = 0; i < mutations.length; i++ )
        {
            if ( mutations[ i ].type == "childList" && mutations[ i ].addedNodes.length )
            {
                added = mutations[ i ].addedNodes;
                for ( j = 0; j < added.length; j++ )
                {
                    node = added[ j ];
                    if ( node.nodeType == 1 )
                    {
                        if ( node.classList && node.classList.contains( "ruk_rating_snippet" ) )
                        {
                            WE_ReviewsIo_FixOneSnippetCount( node );
                        }
                        if ( node.querySelectorAll )
                        {
                            node.querySelectorAll( ".ruk_rating_snippet" ).forEach( WE_ReviewsIo_FixSnippetInNode );
                        }
                    }
                }
            }
        }
    }
    function WE_ReviewsIo_FixSnippetInNode( el )
    {
        WE_ReviewsIo_FixOneSnippetCount( el );
    }
    observer = new MutationObserver( WE_ReviewsIo_OnSnippetMutation );
    observer.observe( document.body, { childList: true, subtree: true } );
    setTimeout( WE_ReviewsIo_DisconnectObserverLater, 10000 );

    function WE_ReviewsIo_DisconnectObserverLater( )
    {
        observer.disconnect( );
    }
}

function WE_ReviewsIo_OnDOMReady( )
{
    WE_ReviewsIo_EnforceReviewFormatGlobally( );
}

document.addEventListener( "DOMContentLoaded", WE_ReviewsIo_OnDOMReady );


function InitPdpAutoshipLabel()
{
    var root = document.getElementById('ProductSubmitButton-autoship')
               || document.querySelector('.ProductSubmitButton-autoship')
               || document.querySelector('.autoship-add-to-cart');

    if (!root)
    {
        return;
    }
    
    var pdpBtn = document.getElementById('ProductSubmitButton-autoship');
    if (pdpBtn && root === pdpBtn)
    {
        var cust = window._rcp_customer || {};
        var loggedIn = !!(cust.email && cust.id);
        
        var autoshipNameEl = pdpBtn.querySelector('.autoship-name');
        if (autoshipNameEl)
        {
            return;
        }
        
        if (loggedIn)
        {
            return;
        }
    }
    
    if (root.dataset.autoshipLabelBound === '1')
    {
        return;
    }
    
    root.dataset.autoshipLabelBound = '1';

    function needsGuestLabel(callback)
    {
        var cust      = window._rcp_customer || {};
        var loggedIn  = !!(cust.email && cust.id);

        if (!loggedIn)
        {
            callback(true);
            return;
        }

        callback(false);
    }

    function applyGuestLabel()
    {
        var icon         = root.querySelector('img') || null;
        var autoshipSpan = root.querySelector('.autoship-text');
        var leadingSpan  = root.querySelector('span:not(.autoship-text)');

        if (!autoshipSpan)
        {
            autoshipSpan = document.createElement('span');
            autoshipSpan.className = 'autoship-text';
            root.appendChild(autoshipSpan);
        }

        autoshipSpan.textContent = 'Autoship';

        if (leadingSpan)
        {
            leadingSpan.style.display = 'none';
        }

        if (!icon)
        {
            var src = (typeof window.autoshipIcon === 'string' && window.autoshipIcon)
                      || root.getAttribute('data-autoship-icon')
                      || '';
            if (src)
            {
                icon = new Image();
                icon.src = src;
                icon.width = 20;
                icon.height = 'auto';
                root.insertBefore(icon, root.firstChild);
            }
        }

        if (icon && root.firstChild !== icon)
        {
            root.insertBefore(icon, root.firstChild);
        }

        if (icon && autoshipSpan.previousSibling !== icon)
        {
            root.insertBefore(autoshipSpan, icon.nextSibling);
        }
        else if (!icon && root.firstChild !== autoshipSpan)
        {
            root.insertBefore(autoshipSpan, root.firstChild);
        }

        Array.prototype.slice.call(root.querySelectorAll('.autoship-frequency')).forEach(function (n)
        {
            n.parentNode.removeChild(n);
        });

        Array.prototype.slice.call(root.childNodes).forEach(function (n)
        {
            if (n.nodeType === 3 && /\& Save\b/i.test(n.nodeValue))
            {
                n.parentNode.removeChild(n);
            }
        });

        var addSaveText = true;
        var pdpBtn      = document.getElementById('ProductSubmitButton-autoship');

        if (pdpBtn)
        {
            var cust = window._rcp_customer || {};
            var loggedIn = !!(cust.email && cust.id);
            if (loggedIn)
            {
                return;
            }
            
            var svgLabel  = pdpBtn.querySelector('.autoship-add-to');
            var textLabel = pdpBtn.querySelector('.autoship-text');

            if (svgLabel)
            {
                svgLabel.style.display = 'inline-flex';
                if (textLabel) { textLabel.style.display = 'none'; }

                var kids = pdpBtn.childNodes;
                for (var i = kids.length - 1; i >= 0; i--)
                {
                    var n = kids[i];
                    if (n.nodeType === 3 && /(^|\s)&\s*Save\b/i.test(n.nodeValue))
                    {
                        pdpBtn.removeChild(n);
                    }
                }

                addSaveText = false;
            }
        }

        var pdpParent = autoshipSpan.closest( "#ProductSubmitButton-autoship" );
        if( pdpParent )
        {
            pdpParent.classList.remove( "visibility-hidden" );
            
            function updatePdpButtonPercent()
            {
                if (document.body.classList.contains('has-autoship')) return false;
                
                var mainPriceEl = document.querySelector('.product-main-price');
                var autoshipPriceEl = document.querySelector('.autoship-price');
                
                if (!mainPriceEl || !autoshipPriceEl) return false;
                
                var mainPrice = parseFloat(mainPriceEl.textContent.replace(/[^0-9.]/g, ''));
                var autoshipPrice = parseFloat(autoshipPriceEl.textContent.replace(/[^0-9.]/g, ''));
                
                if (isNaN(mainPrice) || isNaN(autoshipPrice) || mainPrice <= 0) return false;
                
                var autoshipPercent = Math.round(((mainPrice - autoshipPrice) / mainPrice) * 100);
                if (autoshipPercent <= 0) return false;
                
                var autoshipNameEl = pdpParent.querySelector('.autoship-name');
                if (autoshipNameEl)
                {
                    if (document.body.classList.contains('has-autoship')) return false;
                    var currentText = autoshipNameEl.textContent.trim();
                    if (currentText.includes('Autoship every') && currentText.includes('4 weeks')) return false;
                    
                    var isMyAisle = document.body.id === 'lightning-my-aisle' || document.querySelector('#lightning-my-aisle');
                    var fontSize = isMyAisle ? '12px' : '14px';
                    var label = 'Subscribe & Save ' + autoshipPercent + '%';
                    autoshipNameEl.style.fontSize = fontSize;
                    autoshipNameEl.style.verticalAlign = 'middle';
                    autoshipNameEl.textContent = label;
                    var strongTag = autoshipNameEl.querySelector('strong');
                    if (strongTag)
                    {
                        strongTag.textContent = label;
                        autoshipNameEl.innerHTML = label;
                    }
                    return true;
                }
                return false;
            }
            
            if (!updatePdpButtonPercent())
            {
                setTimeout(updatePdpButtonPercent, 500);
                setTimeout(updatePdpButtonPercent, 1500);
                setTimeout(updatePdpButtonPercent, 3000);
            }
        }
        else if (addSaveText)
        {
            autoshipSpan.after(document.createTextNode(' & Save'));
        }
    }

    needsGuestLabel(function (shouldApply)
    {
        if (shouldApply)
        {
            applyGuestLabel();
        }
        else
        {
            if (!document.body.classList.contains('has-autoship'))
            {
                var pdpBtn = document.getElementById('ProductSubmitButton-autoship');
                if (pdpBtn)
                {
                    var mainPriceEl = document.querySelector('.product-main-price');
                    var autoshipPriceEl = document.querySelector('.autoship-price');
                    
                    if (mainPriceEl && autoshipPriceEl)
                    {
                    function updatePdpButtonForLoggedIn()
                    {
                        if (document.body.classList.contains('has-autoship')) return false;
                        
                        var mainPrice = parseFloat(mainPriceEl.textContent.replace(/[^0-9.]/g, ''));
                        var autoshipPrice = parseFloat(autoshipPriceEl.textContent.replace(/[^0-9.]/g, ''));
                        
                        if (isNaN(mainPrice) || isNaN(autoshipPrice) || mainPrice <= 0) return false;
                        
                        var autoshipPercent = Math.round(((mainPrice - autoshipPrice) / mainPrice) * 100);
                        if (autoshipPercent <= 0) return false;
                            
                        if (document.body.classList.contains('has-autoship')) return false;
                        
                        var isMyAisle = document.body.id === 'lightning-my-aisle' || document.querySelector('#lightning-my-aisle');
                        var fontSize = isMyAisle ? '12px' : '14px';
                        var label = 'Subscribe & Save ' + autoshipPercent + '%';
                        
                        var autoshipNameEl = pdpBtn.querySelector('.autoship-name');
                        if (autoshipNameEl)
                        {
                            if (document.body.classList.contains('has-autoship')) return false;
                            var currentText = autoshipNameEl.textContent.trim();
                            if (currentText.includes('Autoship every') && currentText.includes('4 weeks')) return false;
                            
                            autoshipNameEl.style.fontSize = fontSize;
                            autoshipNameEl.style.verticalAlign = 'middle';
                            autoshipNameEl.textContent = label;
                            var strongTag = autoshipNameEl.querySelector('strong');
                            if (strongTag)
                            {
                                strongTag.textContent = label;
                                autoshipNameEl.innerHTML = label;
                            }
                            return true;
                        }
                        
                        if (document.body.classList.contains('has-autoship')) return false;
                        
                        var svgIcon = `
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="14" viewBox="0 0 22 14" fill="none">
                                    <path d="M20.938 3.88773C20.9263 3.88703 20.9507 3.8827 21.0044 3.95316C21.0533 4.01728 21.1018 4.11242 21.1479 4.22464C21.2395 4.44722 21.3024 4.69594 21.3286 4.80179C21.4313 5.21251 21.4383 5.55473 21.4312 5.78812V5.79007C21.4093 6.87764 21.1147 7.78731 20.8765 8.37308C20.7451 8.69572 20.5918 9.01084 20.4136 9.31937L20.2271 9.62503C18.1692 12.8252 14.2197 14.1985 10.5767 13.0225L10.2251 12.9004C9.94338 12.797 9.66997 12.6793 9.40869 12.545L9.40674 12.544C9.01046 12.3444 8.71 12.1893 8.47803 12.0459C8.24712 11.9032 8.09569 11.7793 7.99072 11.6465H7.98975C7.96867 11.6188 7.88628 11.5082 7.74561 11.4825V11.4815L7.73486 11.4805H7.64893C7.56814 11.492 7.50249 11.5337 7.45361 11.5782C7.39314 11.6332 7.34065 11.7088 7.29346 11.7813C7.19133 11.9381 7.08437 12.1303 6.90479 12.375C6.57139 12.8292 6.3297 12.9984 6.17432 13.085L6.16943 13.0879C6.15368 13.0973 6.13643 13.1024 6.12158 13.1104L6.0835 13.0576C5.8908 12.7759 5.35022 11.9703 5.06396 10.9073C4.82966 10.0283 4.84975 9.2811 4.89111 7.83694V7.83109C4.89111 7.81474 4.89164 7.79881 4.89209 7.78323C4.91137 7.78029 4.93228 7.77695 4.95459 7.77347C5.4896 7.68959 6.5544 7.52632 7.66553 7.67191C8.22829 7.74649 9.19241 7.80166 10.3647 8.21194V8.21292C10.411 8.22966 10.4539 8.24616 10.4937 8.26077C10.3538 8.59904 10.1357 8.8126 9.99951 8.94534C9.55987 9.35934 9.32657 9.56772 9.20264 9.68069C9.16097 9.71868 9.12711 9.7535 9.1001 9.78128H8.95947L9.0083 10.0215C9.02812 10.1185 9.09679 10.1826 9.14404 10.2188C9.19716 10.2595 9.26304 10.2948 9.3335 10.3252C9.47566 10.3865 9.66801 10.4423 9.89502 10.4893C10.3512 10.5836 10.9756 10.647 11.688 10.6328C13.1113 10.6045 14.9132 10.2666 16.437 9.22269C16.8351 8.95031 17.6499 8.33018 18.4644 7.52151C19.276 6.71568 20.1045 5.70601 20.5073 4.65335L20.5083 4.65237C20.5447 4.55529 20.623 4.34198 20.7261 4.1553C20.778 4.06123 20.8306 3.98414 20.8794 3.9346C20.9109 3.90271 20.9299 3.89106 20.938 3.88773Z" fill="black" stroke="black" stroke-width="0.4"/>
                                    <path d="M1.40625 4.01465C3.53427 0.711274 7.67062 -0.644625 11.4121 0.736328C11.6937 0.839712 11.9673 0.956482 12.2285 1.09082L12.2305 1.0918C12.6268 1.29137 12.9272 1.44642 13.1592 1.58984C13.39 1.73256 13.5415 1.85657 13.6465 1.98926C13.664 2.01217 13.729 2.10121 13.8398 2.14062L13.8916 2.1543L13.9023 2.15625C14.0236 2.17152 14.1184 2.11694 14.1836 2.05762C14.244 2.00262 14.2966 1.92784 14.3438 1.85547C14.4459 1.69866 14.5528 1.50645 14.7324 1.26172C15.0659 0.807379 15.3075 0.638318 15.4629 0.551758L15.4678 0.548828C15.4835 0.539471 15.4998 0.532448 15.5146 0.524414L15.5537 0.579102C15.7224 0.825821 16.1573 1.47235 16.4551 2.3418L16.5732 2.72852C16.8077 3.60771 16.7875 4.35534 16.7461 5.7998V5.80469C16.7461 5.82089 16.7446 5.83709 16.7441 5.85254L16.6826 5.86328C16.1477 5.94714 15.0834 6.11024 13.9727 5.96484C13.4096 5.89018 12.4432 5.83399 11.2695 5.42285C11.2236 5.40622 11.1811 5.38952 11.1416 5.375C11.2813 5.0368 11.5005 4.82322 11.6367 4.69043L11.6377 4.69141C12.0781 4.27673 12.3117 4.06798 12.4355 3.95508C12.493 3.90272 12.5383 3.86066 12.5664 3.82715C12.5812 3.80949 12.6052 3.77809 12.6191 3.73535C12.6358 3.68402 12.6301 3.64 12.624 3.6123H12.6221C12.6006 3.51895 12.5354 3.4563 12.4893 3.4209C12.4362 3.3803 12.3701 3.34578 12.2998 3.31543C12.1577 3.25413 11.9662 3.19734 11.7393 3.15039C11.283 3.05603 10.658 2.99267 9.94531 3.00684C8.52197 3.03515 6.72013 3.37303 5.19629 4.41699C4.79819 4.68936 3.98343 5.30951 3.16895 6.11816C2.3573 6.924 1.52878 7.93366 1.12598 8.98633V8.9873C1.08959 9.08436 1.01043 9.29854 0.907227 9.48535C0.855339 9.57922 0.802618 9.65562 0.753906 9.70508C0.720376 9.73906 0.700455 9.74834 0.693359 9.75098C0.684344 9.74593 0.663079 9.73005 0.629883 9.68652C0.581067 9.62246 0.531496 9.52809 0.485352 9.41602C0.439507 9.30462 0.4005 9.18637 0.370117 9.08301L0.304688 8.83789C0.201999 8.42717 0.195001 8.08495 0.202148 7.85156V7.84961C0.223984 6.76231 0.518683 5.85332 0.756836 5.26758C0.888124 4.94499 1.04157 4.62975 1.21973 4.32129L1.40625 4.01465Z" fill="black" stroke="black" stroke-width="0.4"/>
                                </svg>
                            `;
                            pdpBtn.innerHTML = `
                                <span class="autoship-add-to">
                                    ${svgIcon}
                                    <span class="autoship-name" style="font-size:${fontSize}; vertical-align: middle;">${label}</span>
                                </span>`;
                            pdpBtn.classList.remove("visibility-hidden");
                            return true;
                        }
                        
                        if (!updatePdpButtonForLoggedIn())
                        {
                            setTimeout(updatePdpButtonForLoggedIn, 500);
                            setTimeout(updatePdpButtonForLoggedIn, 1500);
                            setTimeout(updatePdpButtonForLoggedIn, 3000);
                        }
                    }
                }
            }
        }
    });
}



///////////////////////////////////////////////////////////////////////////////////////////////////////////
// make rcp api call as soon as possible
///////////////////////////////////////////////////////////////////////////////////////////////////////////
FetchNextAutoshipOrder( function( err, response )
{
    window._autoshipData = response
    ApplyRCPDataToProductCards( );
    if ( ( response ) && ( response.charges ) && ( response.charges.length > 0 ) )
    {

    }
    else
    {
        initPDPPurchaseTypeToggle( );
    }
} );

function reorderDesktopBrandAboveTitle()
{
    if (window.innerWidth <= 768) { return; }

    var cards = document.querySelectorAll(".product-grid__product-card:not( .product-grid__product-card--skeleton )");
    cards.forEach(function(card)
    {
        var brand = card.querySelector(".product-card__brand-review-container");
        var title = card.querySelector(".product-card__title");
        if (brand && title && brand.nextSibling !== title)
        {
            title.parentNode.insertBefore(brand, title);
        }
    });
}

// document.addEventListener('click', function(e) 
// {
//   if (e.target.closest('.autoship-add-to-cart')) 
//   {
//     var svg = e.target.closest('.autoship-add-to')?.querySelector('svg');
//     if (svg) 
//     {
//       svg.classList.add('is-rotating');

//       var checkInterval = setInterval(function() 
//       {
//         var modal = document.querySelector('.autoship-modal');
//         if (modal && !modal.classList.contains('hidden')) 
//         {
//           svg.classList.remove('is-rotating');
//           clearInterval(checkInterval);
//         }
//       }, 1000);
//     }
//   }
// });


window.onload = function( )
{
    if ( _rcp_template.template == "collection" || _rcp_template.template == "search" )
    {
        history.scrollRestoration = "manual";
    }
}

//autoship manager and next order

function InitialiseNextAutoshipOrder(  )
{
    if ( window._autoshipData )
    {
        PopulateAutoshipDetails( window._autoshipData );
    }
    else 
    {
        FetchNextAutoshipOrder( function ( err, response )
        {
            window._autoshipData = response;
            PopulateAutoshipDetails( response );
        });
    }
}

function FormatWECWidget( )
{
    var container = document.querySelector( ".autoship-no .wec__text" );
    var headerContainer = document.querySelector( ".autoship-no__wec .wec__text" );
    var managerContainer = document.querySelector( ".autoship-manager .wec__info__text" );
    var checkInterval = setInterval(function() 
    {
        if ( !document.querySelector( ".autoship-manager .wec__info__data" ) )
        {
            return;
        }

        var points = document.querySelector( ".autoship-manager .wec__info__data" ).textContent;
        if ( points !== "" ) 
        {
            clearInterval( checkInterval );
            points = points.replace( /[^\d]/g, "" );
            points = parseInt( points, 10 ) || 0;

            var pointsMoney = formatter.format( parseFloat( points / 100 ) );

            if ( container )
            {
                var newHtml = container.innerHTML.replace( "%points%", points );
                container.innerHTML = newHtml;

                newHtml = container.innerHTML.replace( "%money%", pointsMoney );
                container.innerHTML = newHtml;

                container.querySelector( ".wec__text__amount" ).classList.remove( "hidden" );
            }

            if ( headerContainer )
            {
                var headerHtml = headerContainer.innerHTML.replace( "%points%", points );
                headerContainer.innerHTML = headerHtml;

                headerHtml = headerContainer.innerHTML.replace( "%money%", pointsMoney );
                headerContainer.innerHTML = headerHtml;

                var amt = headerContainer.querySelector( ".wec__text__amount" );
                if ( amt )
                {
                    amt.classList.remove( "hidden" );
                }
            }

            var newHtml = managerContainer.innerHTML.replace( "%cash%", pointsMoney );
            managerContainer.innerHTML = newHtml;
        }
    }, 250 );
}

function AutoshipPopulateManagerHeaderDatesFromProcessAt( processAtMs )
{
    function ordinalSuffixForDay( dayNum )
    {
        var suffix           = "th";
        var remainderTen     = dayNum % 10;
        var remainderHundred = dayNum % 100;

        if ( remainderTen == 1 && remainderHundred != 11 )
        {
            suffix = "st";
        }
        else if ( remainderTen == 2 && remainderHundred != 12 )
        {
            suffix = "nd";
        }
        else if ( remainderTen == 3 && remainderHundred != 13 )
        {
            suffix = "rd";
        }
        return suffix;
    }

    function formatOrdinalMonthDateEn( dateObj )
    {
        var monthNames = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
        var dayNum     = dateObj.getDate( );
        var monthName  = monthNames[ dateObj.getMonth( ) ];

        return monthName + " " + dayNum + ordinalSuffixForDay( dayNum );
    }

    function addTwoWorkingDaysFromProcessDate( startDate )
    {
        var cursor = new Date( startDate.getTime( ) );
        var dow    = cursor.getDay( );

        if ( dow === 6 )
        {
            cursor.setDate( cursor.getDate( ) + 2 );
        }
        else if ( dow === 0 )
        {
            cursor.setDate( cursor.getDate( ) + 1 );
        }

        dow = cursor.getDay( );

        var addDays;
        if ( dow >= 1 && dow <= 4 )
        {
            addDays = 2;
        }
        else if ( dow === 5 )
        {
            addDays = 4;
        }
        else
        {
            addDays = 3;
        }

        cursor.setDate( cursor.getDate( ) + addDays );
        return cursor;
    }

    var processDateObj         = new Date( processAtMs );
    var deliveryDateObj        = addTwoWorkingDaysFromProcessDate( processDateObj );
    var managerProcessedDateEl = document.querySelector( ".autoship-manager .header__processed-date" );
    var managerDeliveryDateEl  = document.querySelector( ".autoship-manager .header__delivery-date" );
    managerProcessedDateEl.textContent = formatOrdinalMonthDateEn( processDateObj );
    managerDeliveryDateEl.textContent  = formatOrdinalMonthDateEn( deliveryDateObj );
}

function PopulateAutoshipDetails( rechargeData )
{
    if ( rechargeData && rechargeData.charges && rechargeData.charges.length > 0 )
    {
        var trigger = document.querySelector( ".autoship-drawer-trigger" );
        if ( trigger ) trigger.style.display = "flex";

        var u1Elements = document.querySelectorAll( ".autoship-no .u1-element" );
        var u2Elements = document.querySelectorAll( ".autoship-no .u2-element" );
        var loader = document.querySelector( ".autoship-no .autoship-no__order__loader-container" );

        var nextOrder = document.querySelector( ".autoship-no" );

        var newestCharge = getNextRechargeCharge( rechargeData );
        if ( newestCharge.status == "SKIPPED" )
        {
            trigger.style.display = "none";
            var loader = document.querySelector( ".autoship-no .autoship-no__order__loader-container" );
            if ( loader )
            {
                loader.classList.add( "hidden" );
            }
        }

        const date = new Date( newestCharge.at );

        const options = { weekday: 'long', month: 'long', day: 'numeric' };
        const formatted = new Intl.DateTimeFormat( 'en-US', options ).format( date );

        if ( nextOrder )
        {
            var dateContainer = document.querySelector( ".autoship-no .details__date" );
            var text = dateContainer.dataset.text;
            dateContainer.textContent = text.replace( "%date%", formatted );
        }

        AutoshipPopulateManagerHeaderDatesFromProcessAt( newestCharge.at );

        fetchProductHandlesByStorefrontApi( newestCharge.lines ).then( function withStorefrontHandles( handleMap )
        {
            return Promise.all( newestCharge.lines.map( function fetchLineProduct( item ) { return fetchProductByVariantId( item.pid, item.vid, item.sid, item.qty, handleMap[ String( item.pid ) ] ); } ));
        } )
        .then( function collectLineProducts( products )
        {
            const validProducts = products.filter( function keepResolvedLine( p, i )
            {
                const line = newestCharge.lines[ i ];
                if ( p != null )
                {
                    return true;
                }
                console.warn( "[WE Autoship] Dropping unresolvable charge line", { pid: line.pid, vid: line.vid, sid: line.sid, qty: line.qty, charge: newestCharge.cid } );
                return false;
            } );

            if ( validProducts.length > 0 )
            {
                validProducts.reverse( );

                if ( nextOrder )
                {
                    PopulateAutoShipWidget( validProducts );
                    u1Elements.forEach( element =>
                    {
                        element.classList.remove( "u1-element--hidden" );
                    });
                    u2Elements.forEach( element =>
                    {
                        element.classList.add( "u2-element--hidden" );
                    });
                    loader.classList.add( "hidden" );
                    document.querySelector( ".autoship-no .order__manage__manage-button" ).addEventListener( "click", ToggleAutoshipManager );
                }

                PopulateAutoshipManager( validProducts );
            }
            else
            {
                console.log( "No valid products found." );
            }
        })
        .catch( err => console.error( "Error in promise", err ) );
    }
    else
    {
        var loader = document.querySelector( ".autoship-no .autoship-no__order__loader-container" );
        if ( loader )
        {
            loader.classList.add( "hidden" );
        }
    }
}

async function fetchProductHandlesByStorefrontApi( lines )
{
    const map   = { };
    var token   = null;
    const gids  = [ ];
    var i       = 0;
    var response = null;
    var json    = null;
    var nodes   = [ ];
    try { token = window._rcpStorefrontToken || null; } catch ( err ) { token = null; }
    if ( token == null || token == "" || !lines || lines.length == 0 )
    {
        return map;
    }
    for ( i = 0; i < lines.length; i++ )
    {
        gids.push( "gid://shopify/Product/" + lines[ i ].pid );
    }
    try
    {
        response = await fetch( "/api/2025-10/graphql.json", {
            method: "POST",
            headers: { "Content-Type": "application/json", "X-Shopify-Storefront-Access-Token": token },
            body: JSON.stringify( { query: "query($ids:[ID!]!){nodes(ids:$ids){... on Product{id handle}}}", variables: { ids: gids } } )
        } );
        json = await response.json( );
    }
    catch ( err )
    {
        json = null;
    }
    nodes = ( json && json.data && json.data.nodes ) ? json.data.nodes : [ ];
    for ( i = 0; i < nodes.length; i++ )
    {
        if ( nodes[ i ] && nodes[ i ].id && nodes[ i ].handle )
        {
            map[ String( nodes[ i ].id ).split( "/" ).pop( ) ] = nodes[ i ].handle;
        }
    }
    return map;
}

async function fetchProductByVariantId( productId, variantId, subId, quantity, knownHandle )
{
    var handle   = knownHandle || null;
    var response = null;
    var payload  = null;
    var list     = [ ];
    var product  = null;
    if ( handle == null || handle == "" )
    {
        try
        {
            response = await fetch( `/search/suggest.json?q=id:${productId}&resources[type]=product&limit=1` );
        }
        catch ( err )
        {
            response = null;
        }
        if ( response && response.ok )
        {
            try
            {
                payload = await response.json( );
            }
            catch ( err )
            {
                payload = null;
            }
        }
        if ( payload && payload.resources && payload.resources.results )
        {
            list = payload.resources.results.products || [ ];
        }
        if ( list.length > 0 && list[ 0 ].handle )
        {
            handle = list[ 0 ].handle;
        }
        else
        {
            console.warn( `Unable to fetch product ${ productId }` );
        }
    }
    if ( handle == null || handle == "" )
    {
        handle = await fetchProductHandleByVariantId( variantId );
    }
    if ( handle != null && handle != "" )
    {
        product = await fetchProductByVariantHandle( handle, productId, subId, variantId, quantity );
    }
    return product;
}

async function fetchProductByVariantHandle( handle, productId, subId, variantId, quantity )
{
    var response = null;
    var data     = null;
    var result   = null;
    try
    {
        response = await fetch( `/products/${ handle }.js` );
    }
    catch ( err )
    {
        response = null;
    }
    if ( response && response.ok )
    {
        try
        {
            data = await response.json( );
        }
        catch ( err )
        {
            data = null;
        }
    }
    else
    {
        console.warn( `Error fetching product ${ productId }` );
    }
    if ( data )
    {
        if ( subId )
        {
            data.sid = subId;
        }
        if ( quantity )
        {
            data.quantity = quantity;
        }
        if ( productId )
        {
            data.selected_variant_id = parseFloat( variantId );
        }
        result = data;
    }
    return result;
}

async function fetchProductHandleByVariantId( variantId )
{
    var handle   = "";
    var finalUrl = "";
    var match    = null;
    var response = null;
    if ( variantId != null && variantId != "" )
    {
        try
        {
            response = await fetch( "/variants/" + variantId, { credentials: "same-origin", redirect: "follow" } );
        }
        catch ( err )
        {
            response = null;
        }
        if ( response && response.ok )
        {
            finalUrl = String( response.url || "" );
            match = finalUrl.match( /\/products\/([^/?#]+)(?:[?#]|$)/ );
            if ( match && match[ 1 ] )
            {
                handle = match[ 1 ];
            }
        }
        if ( handle == "" )
        {
            console.warn( `[WE Autoship] Variant ${ variantId } not found` );
        }
    }
    return handle;
}

    // return fetch( "/variants/" + variantId, { credentials: "same-origin", redirect: "follow" } )
    // .then( variantResponse =>
    // {
    //     if ( variantResponse.ok )
    //     {
    //         var finalUrl = String( variantResponse.url || "" );
    //         var m = finalUrl.match( /\/products\/([^/?#]+)(?:[?#]|$)/ );
    //         var handle = m && m[ 1 ] ? m[ 1 ] : "";
    //         if ( !handle ) { return null; }

    //         return fetch( "/products/" + handle + ".js", { credentials: "same-origin" } )
    //         .then( response =>
    //         {
    //             if ( !response.ok )
    //             {
    //                 console.warn( `Variant ${ variantId } not found` );
    //                 return null; 
    //             }
    //             return response.json();
    //         })
    //         .then( data =>
    //         {
    //             if ( data && subId )
    //             {
    //                 data.sid = subId;
    //             }
    //             if ( data && quantity )
    //             {
    //                 data.quantity = quantity;
    //             }
    //             if ( data && variantId )
    //             {
    //                 data.selected_variant_id = parseFloat( variantId );
    //             }
    //             return data;
    //         })
    //         .catch( err =>
    //         {
    //             console.error( `Error fetching variant ${variantId}:`, err );
    //             return null;
    //         });
    //     }
    //     else
    //     {
    //         console.warn( `Variant ${ variantId } not found` );
    //         return null;
    //     }
    // } )
    // .catch( err =>
    // {
    //     console.error( `Error fetching variant ${variantId}:`, err );
    //     return null;
    // });

function FetchNewAutoShipProducts( rechargeData )
{
    if ( rechargeData && rechargeData.charges && rechargeData.charges.length > 0 )
    {
        var newestCharge = getNextRechargeCharge( rechargeData );

        var newItems = [];
        newestCharge.lines.forEach( variant =>
        {
            var matchingSideCartProduct = document.querySelector( `.autoship-manager .product-card[ data-sid="${ variant.sid }" ]` );
            if ( !matchingSideCartProduct )
            {
                newItems.push( variant );
            }
        });

        Promise.all( newItems.map( item => fetchProductByVariantId( item.pid, item.vid, item.sid, item.qty )))
        .then( products =>
        {
            const validProducts = products.filter( p => p !== null );

            if ( validProducts.length > 0 )
            {
                RenderNewAutoShipProducts( validProducts );
            }
            else
            {
                console.log( "No valid products found." );
            }
        })
        .catch( err => console.error( "Error in promise", err ) );
    }
    else
    {
        var loader = document.querySelector( ".autoship-no .autoship-no__order__loader-container" );
        if ( loader )
        {
            loader.classList.add( "hidden" );
        }
    }
}

function RenderNewAutoShipProducts( products )
{
    var totalPrice = 0;
    var totalQuantity = 0;
    var totalCompareAtPrice = 0;

    var autoshipManager = document.querySelector( ".autoship-manager" );
    var managerContainer =  autoshipManager.querySelector( ".autoship-manager__product-cards" );
    var managerTemplate = managerContainer.querySelector( ".product-card.product-card--template" );

    var autoshipNextOrder = document.querySelector( ".autoship-no" );
    if ( autoshipNextOrder )
    {
        var nextOrderContainer = autoshipNextOrder.querySelector( ".autoship-no .order__summary__items" );
        var nextOrderTemplate = nextOrderContainer.querySelector( ".order__summary__items__item--template" );
    }

    products.forEach( product =>
    {
        var compareAtPrice = product.compare_at_price;
        var price = product.price;

        var currentVariant = null;
        if ( product.variants.length > 0 )
        {
            product.variants.forEach( ( variant ) =>
            {
                if ( variant.id == product.selected_variant_id )
                {
                    currentVariant = variant;
                }
            });
        }

        if ( currentVariant )
        {
            compareAtPrice = currentVariant.selling_plan_allocations[ 0 ].compare_at_price;
            price = currentVariant.selling_plan_allocations[ 0 ].price;
        }

        var item = findRechargeChargeWithVariant( product.selected_variant_id );

        //next order card
        if ( autoshipNextOrder )
        {
            var noCard = nextOrderTemplate.cloneNode( true );
            noCard.classList.remove( "order__summary__items__item--template" );
            var oldCards = nextOrderContainer.querySelectorAll( ".order__summary__items__item:not( .hidden )" )
            if ( oldCards.length > 7 )
            {
                oldCards[ oldCards.length - 1 ].classList.add( "hidden" );
            }

            if ( currentVariant && currentVariant.featured_image )
            {
                var noCardImage = noCard.querySelector( "img" );
                noCardImage.setAttribute( "src", currentVariant.featured_image.src + "&width=150" );
                noCardImage.setAttribute( "alt", product.title );
            }
            else if ( product.featured_image )
            {
                var noCardImage = noCard.querySelector( "img" );
                noCardImage.setAttribute( "src", product.featured_image + "&width=150" );
                noCardImage.setAttribute( "alt", product.title );
            }

            noCard.dataset.subId = product.sid;
            noCard.dataset.variantId = product.id;
            noCard.dataset.price = price;

            nextOrderContainer.prepend( noCard );
        }

        //autoship manager card
        var amCard = managerTemplate.cloneNode( true );
        amCard.dataset.sid = product.sid;
        amCard.dataset.pid = product.id;
        amCard.dataset.variantId = product.selected_variant_id;
        amCard.dataset.quantity = product.quantity;
        amCard.dataset.price = price;
        amCard.dataset.compareAt = compareAtPrice;

        amCard.setAttribute( "href", product.url );
        amCard.classList.remove( "product-card--template" );

        if ( currentVariant && currentVariant.featured_image )
        {
            var amCardImage = amCard.querySelector( "img" );
            amCardImage.setAttribute( "src", currentVariant.featured_image.src + "&width=150" );
            amCardImage.setAttribute( "alt", product.title );
        }
        else if ( product.featured_image )
        {
            var amCardImage = amCard.querySelector( "img" );
            amCardImage.setAttribute( "src", product.featured_image + "&width=150" );
            amCardImage.setAttribute( "alt", product.title );
        }

        var weight = null;
        if ( currentVariant )
        {
            weight = currentVariant.name.match(/(\d*\.?\d+)\s?(kg|g|L|mL+)/g);
        }
        else
        {
            weight = product.title.match(/(\d*\.?\d+)\s?(kg|g|L|mL+)/g);
        }

        if ( weight != null )
        {
            amCard.querySelector( ".product-card__info__variant" ).textContent = weight[ 0 ];
        }

        amCard.querySelector( ".info__title-skip__title" ).textContent = product.title;
        amCard.querySelector( ".info__price__discounted" ).textContent = formatter.format( price / 100 );
        amCard.querySelector(".info__price__full").textContent         = "(RRP " + formatter.format(product.compare_at_price / 100) + ")";
        amCard.querySelector( ".pdp-autoship-qty-count" ).textContent  = product.quantity;
        amCard.querySelector( ".pdp-onetime-qty-count" ).textContent   = product.quantity;

        var sub = findRechargeSubWithVariant( product.selected_variant_id );
        if ( sub != null )
        {
            var frequencyContainer = amCard.querySelector( ".freq__text" );
            var frequencyUnit = sub.sub.frequencyUnit;
            var frequency = sub.sub.frequency;
            frequencyContainer.textContent = `every ${frequency} ${frequencyUnit}s`;
        }

        if ( item != null && item.type == "SUBSCRIPTION" )
        {
            amCard.querySelector( ".pdp-autoship-qty" ).classList.remove( "hidden" );
            amCard.querySelector( ".info__qty-freq__freq" ).classList.remove( "hidden" );
            handleAutoshipManagerQS( amCard );
            amCard.querySelector( ".info__title-skip__skip" ).addEventListener( "click", handleAutoshipManagerSkip );
            amCard.dataset.type = "SUBSCRIPTION";
        }
        else if ( item != null && item.type == "ONETIME" )
        {
            amCard.querySelector( ".pdp-onetime-qty" ).classList.remove( "hidden" );
            amCard.querySelector( ".info__qty-freq__onetime" ).classList.remove( "hidden" );
            handleAutoShipManagerOT( amCard );
            amCard.querySelector( ".info__title-skip__skip" ).remove();
            amCard.dataset.type = "ONETIME";
        }

        managerContainer.prepend( amCard );

        totalPrice += price * product.quantity;
        totalQuantity += product.quantity;
        totalCompareAtPrice += compareAtPrice * product.quantity;
    });

    var amFullPriceContainer = autoshipManager.querySelector( ".price__full" );
    var amDiscountedPriceContainer = autoshipManager.querySelector( ".price__discounted" );

    var oldFullPrice = parseFloat( amFullPriceContainer.dataset.totalCompareAt );
    var oldDiscountedPrice = parseFloat( amDiscountedPriceContainer.dataset.totalPrice );

    amDiscountedPriceContainer.textContent = formatter.format( ( oldDiscountedPrice + totalPrice ) / 100 );
    amDiscountedPriceContainer.dataset.totalPrice = oldDiscountedPrice + totalPrice;

    amFullPriceContainer.textContent = formatter.format( ( oldFullPrice + totalCompareAtPrice ) / 100 );
    amFullPriceContainer.dataset.totalCompareAt = oldFullPrice + totalCompareAtPrice;

    var currentQuantity = parseFloat( autoshipManager.querySelector( ".header__heading__count" ).textContent );
    autoshipManager.querySelector( ".header__heading__count" ).textContent = currentQuantity + totalQuantity;

    if ( autoshipNextOrder )
    {
        var noPriceContainer = autoshipNextOrder.querySelector( ".details__order__total-price__price" );
        noPriceContainer.textContent = formatter.format( ( oldDiscountedPrice + totalPrice ) / 100 );
        autoshipNextOrder.querySelector( ".details__order__quantity__quantity" ).dataset.quantity = currentQuantity + totalQuantity;
        autoshipNextOrder.querySelector( ".details__order__quantity__quantity" ).textContent = currentQuantity + totalQuantity + " Items";
    }


    var cartTrigger = document.querySelector( ".autoship-drawer-trigger__count" );
    if ( cartTrigger )
    {
        cartTrigger.textContent = currentQuantity + totalQuantity;
        cartTrigger.classList.add( "autoship-drawer-trigger__count--active" );
    }
    UpdateAutoshipShipping();
    MoveAutoshipFooterForMobile();
}

function PopulateAutoShipWidget( products )
{
    var widget = document.querySelector( ".autoship-no" );
    var container = widget.querySelector( ".autoship-no .order__summary__items" );
    var oldCards = container.querySelectorAll( ".order__summary__items__item:not( .order__summary__items__item--template )" );
    var template = container.querySelector( ".order__summary__items__item--template" );
    var totalPrice = null;
    var totalQuantity = 0;

    oldCards.forEach( card =>
    {
        card.remove( );
    });

    products.forEach( ( product, index ) =>
    {
        var compareAtPrice = product.compare_at_price;
        var price = product.price;

        var card = template.cloneNode( true );
        card.classList.remove( "order__summary__items__item--template" )
        if ( index > 7 )
        {
            card.classList.add( "hidden" );
        }

        var currentVariant = null;
        if ( product.variants.length > 0 )
        {
            product.variants.forEach( ( variant ) =>
            {
                if ( variant.id == product.selected_variant_id )
                {
                    currentVariant = variant;
                }
            });
        }

        if ( currentVariant )
        {
            compareAtPrice = currentVariant.selling_plan_allocations[ 0 ].compare_at_price;
            price = currentVariant.selling_plan_allocations[ 0 ].price;
        }

        if ( currentVariant && currentVariant.featured_image )
        {
            var cardImage = card.querySelector( "img" );
            cardImage.setAttribute( "src", currentVariant.featured_image.src + "&width=150" );
            cardImage.setAttribute( "alt", product.title );
        }
        else if ( product.featured_image )
        {
            var cardImage = card.querySelector( "img" );
            cardImage.setAttribute( "src", product.featured_image + "&width=150" );
            cardImage.setAttribute( "alt", product.title );
        }

        card.dataset.subId = product.sid;
        card.dataset.variantId = product.id;
        card.dataset.price = price;

        container.appendChild( card );
        totalPrice += price * product.quantity;

    });

    var newestCharge = getNextRechargeCharge( window._autoshipData );
    totalPrice = parseFloat( newestCharge.totalItemsPrice ) - parseFloat( newestCharge.totalDiscounts );

    var priceContainer = widget.querySelector( ".details__order__total-price__price" );
    priceContainer.textContent = formatter.format( totalPrice );

    if ( totalQuantity == 1 )
    {
        widget.querySelector( ".details__order__quantity__quantity" ).textContent = totalQuantity + " Item";
    }
    else
    {
        widget.querySelector( ".details__order__quantity__quantity" ).textContent = totalQuantity + " Items";
    }
    widget.querySelector( ".details__order__quantity__quantity" ).dataset.quantity = totalQuantity;
}

function ToggleAutoshipManager()
{
    var manager = document.querySelector(".autoship-manager");
    var trigger = document.querySelector(".autoship-manager-close");


    if (manager.classList.contains("autoship-manager--visible"))
    {
        manager.classList.remove("autoship-manager--visible");
        trigger.classList.remove("autoship-manager-close--visible");
    }
    else
    {
        manager.classList.add("autoship-manager--visible");
        trigger.classList.add("autoship-manager-close--visible");
    }
}

function MoveAutoshipFooterForMobile()
{
    if (window.innerWidth <= 768)
    {
        var footer = document.querySelector(".autoship-manager__footer");
        var cards  = document.querySelector(".autoship-manager__product-cards");

        if (footer && cards)
        {
            cards.appendChild(footer);
        }
    }
}

function OpenAutoshipManagerFromNav()
{
    var navLink   = document.querySelector(".desktop-new-nav-item-4");
    var stickyNav = document.querySelector(".sticky-nav-mob-item:nth-child(4)");
    var manager   = document.querySelector(".autoship-manager");
    var trigger   = document.querySelector(".autoship-manager-close");

    if (!manager || !trigger) { return; }

    function openManager(e)
    {
        e.preventDefault();
        e.stopPropagation();

        manager.classList.add("autoship-manager--visible");
        trigger.classList.add("autoship-manager-close--visible");
    }

    if (navLink)
    {
        navLink.addEventListener("click", openManager);
    }

    if (stickyNav)
    {
        stickyNav.addEventListener("click", openManager);
    }
}

function ToggleAutoshipManagerPromo( )
{
  var promo = document.querySelector( ".autoship-manager .wec__info__input-wrapper" );
  var minusIcon = document.querySelector( ".autoship-manager .promo__icon__minus" );
  var plusIcon = document.querySelector( ".autoship-manager .promo__icon__plus" );

  if ( promo.classList.contains( "wec__info__input-wrapper--hidden" ) )
  {
    promo.classList.remove( "wec__info__input-wrapper--hidden" );
    minusIcon.classList.remove( "hidden" );
    plusIcon.classList.add( "hidden" );
  }
  else
  {
    promo.classList.add( "wec__info__input-wrapper--hidden" );
    minusIcon.classList.add( "hidden" );
    plusIcon.classList.remove( "hidden" );
  }
}

function PopulateAutoshipManager( products )
{
    var manager = document.querySelector( ".autoship-manager" );
    var container = manager.querySelector( ".autoship-manager__product-cards" );
    var oldCards = container.querySelectorAll( ".product-card.product-card:not( .product-card.product-card--template )" );
    var template = container.querySelector( ".product-card.product-card--template" );
    var totalPrice = 0;
    var totalCompareAtPrice = 0;
    var totalQuantity = 0;

    oldCards.forEach( card =>
    {
        card.remove( );
    });

    products.forEach( ( product ) =>
    {
        var card = template.cloneNode( true );
        var item = findRechargeChargeWithVariant( product.selected_variant_id );
        var compareAtPrice = product.compare_at_price;
        var price = product.price;
        card.dataset.sid = product.sid;
        card.dataset.pid = product.id;
        card.dataset.variantId = product.selected_variant_id;
        var vid = product.selected_variant_id
        card.dataset.quantity = product.quantity;
        card.setAttribute( "href", product.url );
        card.classList.remove( "product-card--template" );

        totalQuantity += product.quantity;
        
        var currentVariant = null;
        if ( product.variants.length > 0 )
        {
            product.variants.forEach( ( variant ) =>
            {
                if ( variant.id == product.selected_variant_id )
                {
                    currentVariant = variant;
                }
            });
        }

        if ( currentVariant )
        {
            compareAtPrice = currentVariant.selling_plan_allocations[ 0 ].compare_at_price;
            price = currentVariant.selling_plan_allocations[ 0 ].price;
        }

        var weight = null;
        if ( currentVariant )
        {
            weight = currentVariant.name.match(/(\d*\.?\d+)\s?(kg|g|L|mL+)/g);
        }
        else
        {
            weight = product.title.match(/(\d*\.?\d+)\s?(kg|g|L|mL+)/g);
        }

        if ( weight != null )
        {
            card.querySelector( ".product-card__info__variant" ).textContent = weight[ 0 ];
        }

        card.dataset.price = price;
        card.dataset.compareAt = compareAtPrice;
        
        if ( currentVariant && currentVariant.featured_image )
        {
            var cardImage = card.querySelector( "img" );
            cardImage.setAttribute( "src", currentVariant.featured_image.src + "&width=150" );
            cardImage.setAttribute( "alt", product.title );
        }
        else if ( product.featured_image )
        {
            var cardImage = card.querySelector( "img" );
            cardImage.setAttribute( "src", product.featured_image + "&width=150" );
            cardImage.setAttribute( "alt", product.title );
        }

        card.querySelector( ".info__title-skip__title" ).textContent = product.title;
        totalPrice += price * product.quantity;
        totalCompareAtPrice += compareAtPrice * product.quantity;
        card.querySelector( ".info__price__discounted" ).textContent = formatter.format( price / 100 );
        card.querySelector(".info__price__full").textContent         = "(RRP " + formatter.format(product.compare_at_price / 100) + ")";
        card.querySelector( ".pdp-autoship-qty-count" ).textContent  = product.quantity;
        card.querySelector( ".pdp-onetime-qty-count" ).textContent   = product.quantity;

        var sub = findRechargeSubWithVariant( vid );
        if ( sub != null )
        {
            var frequencyContainer = card.querySelector( ".freq__text" );
            var frequencyUnit = sub.sub.frequencyUnit;
            var frequency = sub.sub.frequency;
            frequencyContainer.textContent = `every ${frequency} ${frequencyUnit}s`;
        }

        if ( item != null && item.type == "SUBSCRIPTION" )
        {
            card.querySelector( ".pdp-autoship-qty" ).classList.remove( "hidden" );
            card.querySelector( ".info__qty-freq__freq" ).classList.remove( "hidden" );
            handleAutoshipManagerQS( card );
            card.querySelector( ".info__title-skip__skip" ).addEventListener( "click", handleAutoshipManagerSkip );
            card.dataset.type = "SUBSCRIPTION";
        }
        else if ( item != null && item.type == "ONETIME" )
        {
            card.querySelector( ".pdp-onetime-qty" ).classList.remove( "hidden" );
            card.querySelector( ".info__qty-freq__onetime" ).classList.remove( "hidden" );
            handleAutoShipManagerOT( card );
            card.querySelector( ".info__title-skip__skip" ).remove();
            card.dataset.type = "ONETIME";
        }

        container.appendChild( card );
    });

    if (window.innerWidth <= 768)
    {
        var footer = document.querySelector(".autoship-manager__footer");
        if (footer && container)
        {
            container.appendChild(footer);
        }
    }

    container.classList.remove( "autoship-manager__product-cards--loading" );
    container.querySelector( ".autoship-manager__product-cards__loader" ).classList.add( "hidden" );

    var date = new Date();
    date.setDate( date.getDate() + 1 );
    manager.querySelector( ".autoship-manager__reschedule-input" ).min = date.toISOString().split("T")[0];

    var newestCharge = getNextRechargeCharge( window._autoshipData );
    var fullPrice = parseFloat( newestCharge.totalItemsPrice );
    var discounts = parseFloat( newestCharge.totalDiscounts );
    var discountedPrice = fullPrice - discounts;

    if ( discountedPrice == fullPrice )
    {
        manager.querySelector( ".price__full" ).classList.add( "hidden" );
        manager.querySelector( ".footer__end__discount" ).classList.add( "hidden" );
    }

    manager.querySelector( ".price__discounted" ).dataset.totalPrice = discountedPrice;
    manager.querySelector( ".price__discounted" ).textContent = formatter.format( discountedPrice );
    manager.querySelector( ".price__full" ).dataset.totalCompareAt = fullPrice;
    manager.querySelector( ".price__full" ).textContent = formatter.format( fullPrice );
    manager.querySelector( ".discount__amount" ).textContent = "- " + formatter.format( discounts );
    UpdateAutoshipShipping();
    var rescheduleButton = manager.querySelector( ".autoship-manager__reschedule" );
    rescheduleButton.removeAttribute( "disabled" );

    manager.querySelector( ".header__heading__count" ).textContent = totalQuantity;
    manager.dataset.quantity = totalQuantity;

    var cartTrigger = document.querySelector( ".autoship-drawer-trigger__count" );
    if (cartTrigger)
    {
        cartTrigger.textContent = totalQuantity;
        cartTrigger.classList.add("autoship-drawer-trigger__count--active");
    }

    MoveAutoshipFooterForMobile();
}

function initAutoShipManagerEL( )
{
    document.querySelector( ".autoship-manager .autoship-manager__close" ).addEventListener( "click", ToggleAutoshipManager );
    document.querySelector( ".autoship-manager-close" ).addEventListener( "click", ToggleAutoshipManager );
    document.querySelector( ".autoship-drawer-trigger-nav" )?.addEventListener( "click", function( )
    {
        document.body.classList.toggle( "is-menu-open" );
        document.querySelector( ".full-page-overlay" ).classList.toggle( "overlay-opacity" );
        $("#multilevel-menu nav > .new-desktop-menu").toggle('show').toggleClass('main-menu-show');
        document.querySelectorAll( ".header-nav-vertical li" ).forEach( element => element.classList.remove( "open" ) );
        if ( window.screen.width < 968 )
        {
            document.querySelector( ".header-navigation" ).classList.add( "header-navigation--open" );
        }
        ToggleAutoshipManager( );
    });
    document.querySelector( ".autoship-manager .wec__info__promo" ).addEventListener( "click", ToggleAutoshipManagerPromo );

	document.querySelector( ".autoship-manager .autoship-manager__reschedule" ).addEventListener( "click", function( )
	{
		this.parentElement.querySelector( ".autoship-manager__reschedule-input" ).showPicker?.();
	});
}

function handleAutoshipManagerQS(productCard)
{
    var quantitySelector  = productCard.querySelector( ".pdp-autoship-qty" );
    var minusBtn          = quantitySelector.querySelector( ".pdp-autoship-minus" );
    var plusBtn           = quantitySelector.querySelector( ".pdp-autoship-plus" );
    var count             = quantitySelector.querySelector( ".pdp-autoship-qty-count" );
    var sid               = productCard.dataset.sid;
    var requestInProgress = false;
    var originalMinusSVG  = minusBtn.innerHTML;
    var quantity          = parseFloat( productCard.dataset.quantity );
    var shownQuantity     = parseFloat( productCard.dataset.quantity );

    var trashIconSVG =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" style="width: 14px">' +
            '<path d="M4 6H20L18.4199 20.2209C18.3074 21.2337 17.4512 22 16.4321 22H7.56786C6.54876 22 5.69264 21.2337 5.5801 20.2209L4 6Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
            '<path d="M7.34491 3.14716C7.67506 2.44685 8.37973 2 9.15396 2H14.846C15.6203 2 16.3249 2.44685 16.6551 3.14716L18 6H6L7.34491 3.14716Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
            '<path d="M2 6H22" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
            '<path d="M10 11V16" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
            '<path d="M14 11V16" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>';

    function updateMinusIcon(qty)
    {
        if ( qty <= 1 )
        {
            minusBtn.innerHTML = trashIconSVG;
        }
        else
        {
            minusBtn.innerHTML = originalMinusSVG;
        }
    }

    function ReallyUpdateQuantity( newQty )
    {
        window.ReallyModifySubscriptionQuantity( sid, newQty, function( err, response )
        {
            if ( err )
            {
                alert( "Failed to update Autoship quantity." );
            }
            else
            {
                window._autoshipData = response;
                var newestRequest    = getNewestRequest( "sid", sid );
                if ( newestRequest != null && newestRequest.quantity != newQty )
                {
                    quantity = newQty;
                    ReallyUpdateQuantity( newestRequest.quantity );
                }
                else
                {
                    requestInProgress = false;

                    if ( quantity > newQty )
                    {
                        handleAutoshipManagerQU( productCard, newQty, "minus" );
                    }
                    else
                    {
                        handleAutoshipManagerQU( productCard, newQty, "plus" );
                    }

                    quantity = newQty;

                    if ( newQty <= 0 )
                    {
                        productCard.remove();
                    }

                    updateMinusIcon( newQty );
                    clearFinishedRequests( "sid", sid );
                }
            }
            //productCard.querySelector( ".product-card__loader-container" ).classList.add( "hidden" );
        });
    }

    updateMinusIcon( shownQuantity || 0 );

    minusBtn.addEventListener( "click", function( e )
    {
        e.preventDefault();
        //productCard.querySelector( ".product-card__loader-container" ).classList.remove( "hidden" );

        if ( shownQuantity - 1 >= 0 )
        {
            var currentQty  = shownQuantity || 0;
            shownQuantity   --;
            var newQty      = currentQty - 1;
            count.innerText = newQty;
            window.autoshipQuantityUpdates.push( { sid: sid, quantity: newQty } );

            if ( !requestInProgress )
            {
                requestInProgress = true;
                ReallyUpdateQuantity( newQty );
            }
        }
    });

    plusBtn.addEventListener( "click", function( e )
    {
        e.preventDefault();
        //productCard.querySelector( ".product-card__loader-container" ).classList.remove( "hidden" );

        var currentQty  = shownQuantity || 0;
        shownQuantity   ++;
        var newQty      = currentQty + 1;
        count.innerText = newQty;
        window.autoshipQuantityUpdates.push( { sid: sid, quantity: newQty } );

        if ( !requestInProgress )
        {
            requestInProgress = true;
            ReallyUpdateQuantity( newQty );
        }
    });
}



function handleAutoShipManagerOT( productCard )
{
    var quantitySelector = productCard.querySelector( ".pdp-onetime-qty" );
    var minusBtn = quantitySelector.querySelector( ".pdp-onetime-minus" )
    var plusBtn = quantitySelector.querySelector( ".pdp-onetime-plus" );
    var count = quantitySelector.querySelector( ".pdp-onetime-qty-count" );
    var sid = productCard.dataset.sid;

    minusBtn.addEventListener( "click", function( e )
    {
        e.preventDefault();
        productCard.querySelector( ".product-card__loader-container" ).classList.remove( "hidden" );
        var newQty = parseFloat( productCard.dataset.quantity ) - 1;
        minusBtn.setAttribute( "disabled", "" );
        ReallyModifyOnetimeQuantityCancel( sid, newQty, ( err ) => 
        {
            if ( err )
            {
                alert( 'Failed to update Autoship quantity.' );
                minusBtn.removeAttribute( "disabled" );
            }
            else
            {
                FetchNextAutoshipOrder( function( err, rechargeData )
                {
                    
                    if ( err )
                    {
                        console.log( err )
                    }
                    else
                    {
                        window._autoshipData = rechargeData;
                        handleAutoshipManagerQU( productCard, newQty, "minus" );
                        if ( newQty == 0 )
                        {
                            productCard.remove( );
                        }
                        else if ( newQty > 0 )
                        {
                            minusBtn.removeAttribute( "disabled" );
                        }
                    }
                    productCard.querySelector( ".product-card__loader-container" ).classList.add( "hidden" );
                });
            }
        });
    });

    plusBtn.addEventListener( "click", function( e )
    {
        e.preventDefault();
        productCard.querySelector( ".product-card__loader-container" ).classList.remove( "hidden" );
        var newQty = parseFloat( productCard.dataset.quantity ) + 1;
        plusBtn.setAttribute( "disabled", "" );
        ReallyModifyOnetimeQuantityCancel( sid, newQty, ( err ) => 
        {
            if ( err )
            {
                alert( 'Failed to update Autoship quantity.' );
                plusBtn.removeAttribute( "disabled" );
            }
            else
            {
                FetchNextAutoshipOrder( function( err, rechargeData )
                {
                    
                    if ( err )
                    {
                        console.log( err )
                    }
                    else
                    {
                        window._autoshipData = rechargeData;
                        handleAutoshipManagerQU( productCard, newQty, "plus" );
                        plusBtn.removeAttribute( "disabled" );
                    }
                    productCard.querySelector( ".product-card__loader-container" ).classList.add( "hidden" );
                });
            }
        });
    });
}

function handleAutoshipManagerQU( productCard, quantity, type )
{
    var nextOrderContainer = document.querySelector( ".autoship-no" );
    var manager = document.querySelector( ".autoship-manager" );
    var managerQuantity = document.querySelector( ".autoship-manager .header__heading__count" );
    if ( nextOrderContainer )
    {
        var nextOrderPriceContainer = nextOrderContainer.querySelector( ".details__order__total-price__price" );
    }
    var managerPriceContainer = document.querySelector( ".autoship-manager .price__discounted" );
    var managerFullPrice = document.querySelector( ".autoship-manager .price__full" );
    var newestCharge = getNextRechargeCharge( window._autoshipData );
    var totalFullprice = parseFloat( newestCharge.totalItemsPrice );
    var totalDiscounts = parseFloat( newestCharge.totalDiscounts );
    var totalDiscountedPrice = totalFullprice - totalDiscounts;

    var sid = productCard.dataset.sid;
    var vid = productCard.dataset.variantId;

    productCard.dataset.quantity = quantity;

    if ( productCard.dataset.type == "SUBSCRIPTION" )
    {
        productCard.querySelector( ".pdp-autoship-qty-count" ).textContent = quantity;
    }
    else if ( productCard.dataset.type == "ONETIME" )
    {
        productCard.querySelector( ".pdp-onetime-qty-count" ).textContent = quantity;
    }

    var cartTrigger = document.querySelector( ".autoship-drawer-trigger__count" );

    managerPriceContainer.dataset.totalPrice = totalDiscountedPrice;
    managerPriceContainer.textContent = formatter.format( totalDiscountedPrice);
    managerFullPrice.dataset.totalCompareAt = totalFullprice;
    managerFullPrice.textContent = formatter.format( totalFullprice );
    if ( nextOrderContainer )
    {
        nextOrderPriceContainer.dataset.totalPrice = totalDiscountedPrice;
        nextOrderPriceContainer.textContent = formatter.format( totalDiscountedPrice );
    }
    manager.querySelector( ".discount__amount" ).textContent = "- " + formatter.format( totalDiscounts );
    manager.querySelector( ".footer__end__discount" ).classList.remove( "hidden" );
    managerFullPrice.classList.remove( "hidden" );

    if ( totalFullprice == totalDiscountedPrice )
    {
        manager.querySelector( ".footer__end__discount" ).classList.add( "hidden" );
        managerFullPrice.classList.add( "hidden" );
    }

    if ( type == "minus" )
    {
        if ( nextOrderContainer )
        {
            currentQuantity = parseFloat( nextOrderContainer.querySelector( ".details__order__quantity__quantity" ).dataset.quantity );
            nextOrderContainer.querySelector( ".details__order__quantity__quantity" ).dataset.quantity = currentQuantity - 1;
        }
        if ( cartTrigger )
        {
            currentQuantity = parseFloat( cartTrigger.textContent );
            cartTrigger.textContent = currentQuantity - 1;
            cartTrigger.classList.add( "autoship-drawer-trigger__count--active" );
        }
        managerQuantity.textContent = parseFloat( managerQuantity.textContent ) - 1;
        
    }
    else if ( type == "plus" )
    {

        if ( nextOrderContainer )
        {
            currentQuantity = parseFloat( nextOrderContainer.querySelector( ".details__order__quantity__quantity" ).dataset.quantity );
            nextOrderContainer.querySelector( ".details__order__quantity__quantity" ).dataset.quantity = currentQuantity + 1;
        }
        if ( cartTrigger )
        {
            currentQuantity = parseFloat( cartTrigger.textContent );
            cartTrigger.textContent = currentQuantity + 1;
            cartTrigger.classList.add( "autoship-drawer-trigger__count--active" );
        }
        managerQuantity.textContent = parseFloat( managerQuantity.textContent ) + 1;
    }

    if ( quantity == 0 )
    {
        if ( nextOrderContainer )
        {
            if ( !nextOrderContainer.querySelector( `.order__summary__items__item[data-sub-id="${sid}"]` ).classList.contains( "hidden" ) )
            {
                nextOrderContainer.querySelector( ".order__summary__items__item.hidden" )?.classList.remove( "hidden" );
            }
            nextOrderContainer.querySelector( `.order__summary__items__item[data-sub-id="${sid}"]` ).remove( )
        }

        productCard.remove( );

        document.querySelectorAll( `.product-grid__product-card[data-variant-id="${vid}"]` ).forEach( card =>
        {
            card.querySelector( ".autoship-add-to-cart" ).removeAttribute( "disabled" );
        });

        var managerCards = document.querySelectorAll( ".autoship-manager .product-card:not( .product-card--template )" );
        if ( managerCards.length == 0 )
        {
            var managerContainer = document.querySelector( ".autoship-manager .autoship-manager__product-cards" );
            managerContainer.classList.add( "autoship-manager__product-cards--loading" );
            managerContainer.querySelector( ".autoship-manager__product-cards__loader" ).classList.remove( "hidden" );
            PopulateAutoshipDetails( window._autoshipData );
        }

    }

    var autoshipQuantity = 0;
    var newestCharge = getNextRechargeCharge( window._autoshipData );
    newestCharge.lines.forEach( item =>
    {
        autoshipQuantity += item.qty;
    });

    var cartTrigger = document.querySelector( ".autoship-drawer-trigger__count" );
    if ( cartTrigger )
    {
        cartTrigger.textContent = autoshipQuantity;
        cartTrigger.classList.add( "autoship-drawer-trigger__count--active" );
    }

    if ( autoshipQuantity == 1 && nextOrderContainer )
    {
        nextOrderContainer.querySelector( ".details__order__quantity__quantity" ).textContent = `${autoshipQuantity} Item`;
    }
    else if ( nextOrderContainer )
    {
        nextOrderContainer.querySelector( ".details__order__quantity__quantity" ).textContent = `${autoshipQuantity} Items`;
    }
    
    UpdateAutoshipShipping();
    updateGridSection( );
}

function findRechargeSubWithVariant( variantId )
{
	var subKeys = Object.keys( window._autoshipData.subs );
    if ( subKeys.length > 0 )
    {
        subKeys.sort( function( a, b )
        {
            a = a.split( "T" )[ 0 ].split('-').join('');
            b = b.split( "T" )[ 0 ].split('-').join('');
            return a - b;
        } );

        return window._autoshipData.subs[ subKeys[ 0 ] ].find( sub => { return sub.vid == variantId } );
    }

    return null;
}

function findRechargeChargeWithVariant( variantId )
{
    var charges = window._autoshipData.charges;
    var returnedItem = null;
    charges.sort( function( a, b )
    {
        a = a.at.split( "T" )[ 0 ].split('-').join('');
        b = b.at.split( "T" )[ 0 ].split('-').join('');
        return a - b;
    } );

    var newestCharge = charges.find( ( charge ) => charge.status == "QUEUED" );

    if ( newestCharge == null ) newestCharge = charges[ 0 ];

    newestCharge.lines.forEach( item =>
    {
        if ( item.vid == variantId )
        {
            returnedItem = item;
            returnedItem.aid = newestCharge.aid;
        }
        else if ( item.pid == variantId )
        {
            returnedItem = item;
            returnedItem.aid = newestCharge.aid;
        }
    });
    return returnedItem;
}

function handleAutoshipManagerSkip( e )
{
    e.preventDefault( );
    var productCard = e.target.parentElement.parentElement.parentElement;
    var sid = productCard.dataset.sid;
    var newestCharge = getNextRechargeCharge( window._autoshipData );

    if ( newestCharge )
    {
        productCard.querySelector( ".product-card__loader-container" ).classList.remove( "hidden" );
        ReallySkipAutoshipCharge( newestCharge.cid, sid, function( err, response )
        {
            if ( response )
            {
                window._autoshipData = response;
                showSkipOverlay( productCard );
                productCard.querySelector( ".product-card__loader-container" ).classList.add( "hidden" );
            }
        });
    }
    else
    {
        console.error( "Unable to find newest charge" );
    }
}

function showSkipOverlay( productCard )
{
    productCard.querySelector( ".product-card__image" ).classList.add( "hidden" );
    productCard.querySelector( ".product-card__info" ).classList.add( "hidden" );
    var productSid = productCard.dataset.sid;
    var productName = productCard.querySelector( ".info__title-skip__title" ).textContent;
    var nextAutoshipDate = null;

    for ( const [ key, value ] of Object.entries( window._autoshipData.subs ) )
    {
        value.forEach( item =>
        {
            if ( item.sid == productSid )
            {
                nextAutoshipDate = new Date( key );
            }
        });
    }

    const options = { weekday: 'long', month: 'long', day: 'numeric' };
    const formatted = new Intl.DateTimeFormat( 'en-US', options ).format( nextAutoshipDate );

    var nameContainer = productCard.querySelector( ".skipped-overlay__text__header" );
    nameContainer.textContent = nameContainer.textContent.replace( "%name%", productName );

    var dateContainer = productCard.querySelector( ".skipped-overlay__text__paragraph" );
    dateContainer.textContent =  dateContainer.textContent.replace( "%date%", formatted );

    var overlay = productCard.querySelector( ".product-card__skipped-overlay" );
    overlay.classList.add( "product-card__skipped-overlay--active" );

    overlay.querySelector( ".skipped-overlay__close" ).addEventListener( "click", function( e )
    {
        e.preventDefault();
        handleAutoshipManagerQU( productCard, 0, "minus" );
    });
}

/* LoyaltyLion promo + silent discount apply (Lightning standards) */

var weLlApplying = false;

function ApplyFooterPromoCode(value)
{
    if (weLlApplying)
    {
        return Promise.resolve();
    }

    var code = String( value || '' ).trim();

    if ( !code )
    {
        return Promise.resolve();
    }

    if ( !/^[A-Za-z0-9_\-]+$/.test( code ) )
    {
        return Promise.resolve();
    }

    weLlApplying = true;

    try
    {
        sessionStorage.setItem( 'we_last_discount', code );
    }
    catch ( e )
    {
    }

    return fetch( '/discount/' + encodeURIComponent( code ), { credentials: 'same-origin', redirect: 'manual' } )
        .catch( function() { } )
        .finally( function()
        {
            try
            {
                var img = new Image();
                img.src = '/discount/' + encodeURIComponent( code ) + '?v=' + Date.now();
            }
            catch ( e2 )
            {
            }

            weLlApplying = false;
        } );
}

function InitLoyaltyLionPromoEnterOnly()
{
    var SUBTOTAL_SELECTOR = '[data-wec-subtotal], [data-cart-subtotal], .cart__subtotal-value, .wec__subtotal__value';

    var input = document.querySelector( '.footer__wec input[name="autoship-manager-promo"]' );

    if ( !input )
    {
        wireCheckoutButtonsWithSavedDiscount();
        return;
    }

    if ( input.dataset.weLlBound === '1' )
    {
        wireCheckoutButtonsWithSavedDiscount();
        return;
    }

    input.dataset.weLlBound = '1';

    var wrapper = input.closest( '.wec__info__input-wrapper' ) || input.parentElement;
    if ( !wrapper )
    {
        wireCheckoutButtonsWithSavedDiscount();
        return;
    }

    var enterBtn = wrapper.querySelector( '.wec__promo-enter' );
    if ( !enterBtn )
    {
        enterBtn = document.createElement( 'button' );
        enterBtn.setAttribute( 'type', 'button' );
        enterBtn.className = 'wec__promo-enter';
        enterBtn.textContent = 'Enter';
        wrapper.appendChild( enterBtn );
    }

    var loader = wrapper.querySelector( '.wec__promo-loader' );
    if ( !loader )
    {
        loader = document.createElement( 'span' );
        loader.className = 'wec__promo-loader';
        loader.setAttribute( 'aria-hidden', 'true' );
        wrapper.appendChild( loader );
    }

    var applied = wrapper.querySelector( '.wec__promo-applied' );
    if ( !applied )
    {
        applied = document.createElement( 'span' );
        applied.className = 'wec__promo-applied';
        applied.textContent = 'Applied';
        wrapper.appendChild( applied );
    }

    function setBusy(state)
    {
        if ( state )
        {
            wrapper.classList.add( 'is-busy' );
            input.setAttribute( 'disabled', 'disabled' );
            enterBtn.setAttribute( 'disabled', 'disabled' );
        }
        else
        {
            wrapper.classList.remove( 'is-busy' );
            input.removeAttribute( 'disabled' );
            enterBtn.removeAttribute( 'disabled' );
        }
    }

    function markApplied()
    {
        applied.classList.add( 'is-visible' );

        setTimeout( function()
        {
            applied.classList.remove( 'is-visible' );
        }, 4000 );

        input.value = "";
    }

    function formatMoney(cents)
    {
        try
        {
            if ( window.Shopify && typeof Shopify.formatMoney === 'function' )
            {
                var mf = window.money_format || '{{amount}}';
                return Shopify.formatMoney( cents, mf );
            }
        }
        catch ( e )
        {
        }

        var n = ( parseInt( cents, 10 ) || 0 ) / 100;
        return '£' + n.toFixed( 2 );
    }

    function refreshCartTotals(onDone)
    {
        fetch( '/cart.js', { credentials: 'same-origin' } )
            .then( function( r ) { return r.json(); } )
            .then( function( cart )
            {
                var subtotalEls = document.querySelectorAll( SUBTOTAL_SELECTOR );
                var text = formatMoney( cart.items_subtotal_price );

                subtotalEls.forEach( function( el )
                {
                    if ( el )
                    {
                        el.textContent = text;
                    }
                } );

                if ( typeof onDone === 'function' )
                {
                    onDone();
                }
            } )
            .catch( function()
            {
                if ( typeof onDone === 'function' )
                {
                    onDone();
                }
            } );
    }

    function saveDiscount(code)
    {
        if ( !code )
        {
            return;
        }

        try
        {
            localStorage.setItem( 'wec_last_discount', code );
        }
        catch ( e )
        {
        }

        try
        {
            document.cookie = 'wec_last_discount=' + encodeURIComponent( code ) + '; path=/; max-age=' + ( 60 * 60 * 24 * 7 );
        }
        catch ( e2 )
        {
        }
    }

    function getSavedDiscount()
    {
        try
        {
            var v = localStorage.getItem( 'wec_last_discount' );
            if ( v && v.trim().length > 0 )
            {
                return v.trim();
            }
        }
        catch ( e )
        {
        }

        try
        {
            var m = document.cookie.match( /(?:^|;\s*)wec_last_discount=([^;]+)/ );
            if ( m && m[ 1 ] )
            {
                return decodeURIComponent( m[ 1 ] );
            }
        }
        catch ( e2 )
        {
        }

        return '';
    }

    function appendDiscountParam(href, code)
    {
        if ( !href )
        {
            href = '/checkout';
        }

        try
        {
            var url = new URL( href, window.location.origin );
            url.searchParams.set( 'discount', code );
            url.searchParams.set( 'discount_code', code );
            return url.pathname + url.search + url.hash;
        }
        catch ( e )
        {
            var join = ( href.indexOf( '?' ) === -1 ) ? '?' : '&';
            return href + join + 'discount=' + encodeURIComponent( code ) + '&discount_code=' + encodeURIComponent( code );
        }
    }

    function wireCheckoutButtons(code)
    {
        if ( !code )
        {
            return;
        }

        var anchors = document.querySelectorAll(
            'a[href*="/checkout"], ' +
            'a[href*="/a/recharge"], ' +
            'a[href*="/tools/recurring"], ' +
            '.cart__checkout, .wec__checkout-btn, .checkout-button, ' +
            '[data-recharge-checkout], [data-recharge-button], [data-recharge-action="checkout"]'
        );

        anchors.forEach( function( el )
        {
            if ( !el )
            {
                return;
            }

            var href = ( el.getAttribute && el.getAttribute( 'href' ) ) || '';

            if ( href )
            {
                el.setAttribute( 'href', appendDiscountParam( href, code ) );
                return;
            }

            el.addEventListener( 'click', function( e )
            {
                var target = e.currentTarget;
                var to = target.getAttribute( 'data-href' ) || target.getAttribute( 'data-url' ) || '/checkout';
                e.preventDefault();
                e.stopPropagation();
                window.location.href = appendDiscountParam( to, code );
            } );
        } );

        var forms = document.querySelectorAll( 'form[action="/cart"], form[action*="/cart"]' );
        forms.forEach( function( f )
        {
            f.addEventListener( 'submit', function( e )
            {
                var submitter = e.submitter || document.activeElement;
                var looksLikeCheckout = false;

                if ( submitter )
                {
                    var t = ( submitter.textContent || '' ).toLowerCase();
                    looksLikeCheckout = ( submitter.name === 'checkout' ) || ( t.indexOf( 'checkout' ) !== -1 );
                }

                if ( looksLikeCheckout )
                {
                    e.preventDefault();
                    e.stopPropagation();
                    window.location.href = appendDiscountParam( '/checkout', code );
                }
            } );
        } );
    }

    function wireCheckoutButtonsWithSavedDiscount()
    {
        var saved = getSavedDiscount();
        if ( saved )
        {
            wireCheckoutButtons( saved );
        }
    }

    function applyPromoNoRefresh(raw)
    {
        var code = ( raw || '' ).trim();

        if ( code.length === 0 )
        {
            return;
        }

        setBusy( true );

        var newestCharge = getNextRechargeCharge( window._autoshipData );

        ReallApplyChargeDiscount( newestCharge.cid, code, function( err, response )
        {
            if ( err )
            {
                ApplyFooterPromoCode( code )
                .then( function()
                {
                    saveDiscount( code );

                    wireCheckoutButtons( code );

                    refreshCartTotals( function()
                    {
                        markApplied();
                        setBusy( false );
                    } );
                } )
                .catch( function()
                {
                    setBusy( false );
                } );
            }
            else if( response )
            {
                reloadPrices( response );
                markApplied();
                setBusy( false );
            }
        });
    }

    input.addEventListener( 'keydown', function( e )
    {
        if ( e.key === 'Enter' )
        {
            e.preventDefault();
            e.stopPropagation();
            applyPromoNoRefresh( input.value );
        }
    } );

    enterBtn.addEventListener( 'click', function()
    {
        applyPromoNoRefresh( input.value );
    } );

    var form = input.closest( 'form' );
    if ( form )
    {
        form.addEventListener( 'submit', function( e )
        {
            if ( document.activeElement === input || ( input.value && input.value.trim().length > 0 ) )
            {
                e.preventDefault();
                e.stopPropagation();
                applyPromoNoRefresh( input.value );
            }
        } );
    }

    wireCheckoutButtonsWithSavedDiscount();

    var mo = new MutationObserver( function()
    {
        wireCheckoutButtonsWithSavedDiscount();
    } );
    mo.observe( document.body, { childList: true, subtree: true } );
}


function InitAutoshipDrawerTrigger()
{
    var trigger = document.querySelector(".autoship-drawer-trigger");
    var manager = document.querySelector(".autoship-manager");

    if (!trigger || !manager)
    {
        return;
    }

    trigger.addEventListener("click", ToggleAutoshipManager);
}

function initAutoShipManagerReschedule( )
{
    document.querySelector( ".autoship-manager #autoship-manager-reschedule" ).addEventListener( "change", function( )
    {
        var newestCharge = getNextRechargeCharge( window._autoshipData );

        if ( newestCharge )
        {
            var currChargeDate = newestCharge.at;
            var skippedChargeToReschedule = getSkippedSubsCharge( currChargeDate );

            var value = this.value;
            var newDate = new Date( value );
            var todayDate = new Date();
            if ( newDate < todayDate )
            {
                console.error( "Not a valid date" );
                return;
            }

            var month = ( newDate.getMonth() + 1 + "" ).padStart( 2, "0" );

            var date = ( newDate.getDate() + "" ).padStart( 2, "0" );


            var rescheduleTo = `${newDate.getFullYear()}-${month}-${date}`;

            var loader = document.querySelector( ".autoship-no .autoship-no__order__loader-container" );
            if ( loader ) loader.classList.remove( "hidden" );

            var managerContainer = document.querySelector( ".autoship-manager .autoship-manager__product-cards" );
            managerContainer.classList.add( "autoship-manager__product-cards--loading" );
            managerContainer.querySelector( ".autoship-manager__product-cards__loader" ).classList.remove( "hidden" );

            var rescheduleButton = document.querySelector( ".autoship-manager .autoship-manager__reschedule" );
            rescheduleButton.setAttribute( "disabled", "" );

            ReallyRescheduleAutoshipDate( newestCharge.cid, rescheduleTo, function( err, response )
            {
                if ( err )
                {
                    console.error( "Unable to reschedule - " +  err.detail.message );
                }
                else
                {
                    if ( skippedChargeToReschedule )
                    {
                        ReallyRescheduleAutoshipDate( skippedChargeToReschedule.cid, rescheduleTo, function( err, response )
                        {
                            if ( err )
                            {
                                console.log( "Unable to reschedule skipped subs - " + err.detail.message );
                            }
                            else
                            {
                                window._autoshipData = response;
                                PopulateAutoshipDetails( response );
                            }
                        });
                    }
                    else
                    {
                        window._autoshipData = response;
                        PopulateAutoshipDetails( response );
                    }
                }
            });
        }
    });
}

function reloadPrices( rechargeData )
{
    if ( rechargeData && rechargeData.charges && rechargeData.charges.length > 0 )
    {
        var newestCharge = getNextRechargeCharge( rechargeData );
        var fullPrice = parseFloat( newestCharge.totalItemsPrice );
        var discounts = parseFloat( newestCharge.totalDiscounts );
        var discountedPrice = fullPrice - discounts;

        var nextOrder = document.querySelector( ".autoship-no" );
        var managerContainer = document.querySelector( ".autoship-manager" );

        if ( nextOrder )
        {
            nextOrder.querySelector( ".details__order__total-price__price" ).textContent = discountedPrice;
        }

        managerContainer.querySelector( ".price__full" ).dataset.totalCompareAt = fullPrice;
        managerContainer.querySelector( ".price__full" ).textContent = formatter.format( fullPrice );
        managerContainer.querySelector( ".price__full" ).classList.remove( "hidden" );
        managerContainer.querySelector( ".price__discounted" ).dataset.totalPrice = discountedPrice;
        managerContainer.querySelector( ".price__discounted" ).textContent = formatter.format( discountedPrice );
        managerContainer.querySelector( ".discount__amount" ).textContent = "- " + formatter.format( discounts );
        managerContainer.querySelector( ".footer__end__discount" ).classList.remove( "hidden" );
    }
}

document.addEventListener( "DOMContentLoaded", function( )
{
    InitialiseNextAutoshipOrder( );
    initAutoShipManagerEL( );
    InitAutoshipDrawerTrigger( );
    InitLoyaltyLionPromoEnterOnly( );
    initAutoShipManagerReschedule( );
    FormatWECWidget( );
    OpenAutoshipManagerFromNav();
});

document.addEventListener( "click", function( e )
{
    if ( e.target.matches( ".autoship-modal__portal-link" ) )
    {
        const modal   = document.getElementById( 'autoship-modal' );
        const overlay = document.querySelector( '.full-page-overlay' );
        modal.classList.add( 'hidden' );
        document.querySelector( '.autoship-overlay' )?.classList.add( 'hidden' );
        if ( overlay ) 
        {
            overlay.style.opacity    = '0';
            overlay.style.visibility = 'hidden';
        }
        ToggleAutoshipManager( );
    }
});

/////////////////////////////////////////////////////////////////////////////////////////////////
// Stay signed in
//
// Notes:
// - Defaults to checked on page load
// - Runs only when "Keep me logged in" is enabled
// - Manual logout clears tokens and disables auto re-login
/////////////////////////////////////////////////////////////////////////////////////////////////

function CheckSSIStatus( )
{
    var token = localStorage.getItem( 'we_ssi_token' );
    var staySignedIn = localStorage.getItem( 'we_ssi_enabled' ) === 'true';
    var checkbox = document.querySelector( '#keep-signed-in' );

    if ( checkbox )
    {
        checkbox.checked = true;
        localStorage.setItem( 'we_ssi_enabled', 'true' );

        checkbox.addEventListener( 'change', function( )
        {
            var isChecked = checkbox.checked;
            localStorage.setItem( 'we_ssi_enabled', isChecked ? 'true' : 'false' );

            if ( !isChecked )
            {
                localStorage.removeItem( 'we_ssi_token' );
            }
        } );
    }

    staySignedIn = localStorage.getItem( 'we_ssi_enabled' ) === 'true';
    if ( !staySignedIn )
    {
        return;
    }

    if ( ( window._rcp_customer ) && ( window._rcp_customer.email ) && ( window._rcp_customer.id ) )
    {
        if ( !token )
        {
            SendAPIRequest( "https://sso.lightning-e.com/api/ssi", "POST", window._rcp_customer, function( err, response )
            {
                if ( ( response ) && ( response.token ) )
                {
                    localStorage.setItem( 'we_ssi_token', response.token );

                    if ( window.location.pathname === '/' )
                    {
                        window.location.href = 'https://welleasy.co.uk/pages/lightning-my-aisle';
                    }
                }
            } );
        }
        else
        {
            if ( window.location.pathname === '/' )
            {
                window.location.href = 'https://welleasy.co.uk/pages/lightning-my-aisle';
            }
        }
    }
    else if ( token )
    {
        SendAPIRequest( "https://sso.lightning-e.com/api/ssi", "POST", { "token" : token, "url" : window.location.href }, function( err, response )
        {
            if ( ( response ) && ( response.url ) )
            {
                window.location.href = response.url;
            }
            else
            {
                localStorage.removeItem( 'we_ssi_token' );
            }
        } );
    }

    var logoutButton = document.querySelector( "a.welleasy-account-box-wrapper[href*='account/logout']" );

    if ( logoutButton )
    {
        logoutButton.addEventListener( 'click', function( e )
        {
            e.preventDefault( );
            e.stopPropagation( );

            localStorage.removeItem( 'we_ssi_token' );
            localStorage.removeItem( 'we_ssi_enabled' );

            var xhr = new XMLHttpRequest( );

            xhr.onreadystatechange = function( )
            {
                if ( xhr.readyState === 4 )
                {
                    if ( xhr.status === 200 )
                    {
                        window.location.href = 'https://welleasy.co.uk/account/logout';
                    }
                    else
                    {
                        console.log( 'Logout failed: ' + xhr.status );
                        console.log( xhr.responseText );
                    }
                }
            };

            xhr.open( 'GET', 'https://welleasy.co.uk/account/logout', true );
            xhr.send( );
        } );
    }
}

CheckSSIStatus( );
